import { conditionTitle as sharedConditionTitle } from "../../../../utils/conditions/conditionTitle";
import {
  AccountTreeOutlined,
  ApartmentOutlined,
  AssessmentOutlined,
  AccountBalanceOutlined,
  DataObjectOutlined,
  AutoAwesomeOutlined,
  CalculateOutlined,
  CategoryOutlined,
  CheckBoxOutlined as CheckBoxOutlinedIcon,
  CheckOutlined,
  CheckRounded,
  CloseRounded,
  ConstructionOutlined,
  DownloadOutlined,
  EditOutlined,
  EmailOutlined,
  ErrorOutline,
  EventBusyOutlined,
  EventOutlined,
  FolderOutlined,
  GavelOutlined,
  HourglassEmptyOutlined,
  FlagOutlined,
  GridViewOutlined,
  GroupsOutlined,
  HandshakeOutlined,
  HouseOutlined,
  InfoOutlined,
  KeyboardArrowDown,
  ManageSearchOutlined,
  ModeCommentOutlined,
  MoreVert,
  OpenInNewOutlined,
  PaidOutlined,
  PersonOutline,
  PlaylistAddCheckOutlined,
  QuizOutlined,
  ReceiptLongOutlined,
  RuleOutlined,
  PublishedWithChangesOutlined,
  SchemaOutlined,
  RestartAltOutlined,
  ShieldOutlined,
  SortByAlphaOutlined,
  SortRounded,
  StickyNote2Outlined,
  SwapVertOutlined,
  TaskAltOutlined,
  TuneRounded,
  TocOutlined,
  UnfoldLessOutlined,
  UnfoldMoreOutlined,
  UploadFileOutlined,
  ViewColumnOutlined,
  ViewListOutlined,
  Inventory2Outlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
  WarningAmberOutlined,
  Visibility,
  AddComment,
  AddCommentOutlined,
  LogoutOutlined,
  FactCheckOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Popover,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import {
  amber,
  blue,
  deepOrange,
  deepPurple,
  green,
  grey,
  orange,
  red,
} from "@mui/material/colors";
import { ModuleRegistry } from "ag-grid-community";
import {
  ColumnsToolPanelModule,
  ContextMenuModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SideBarModule,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { isBoolean, isNil, isString } from "lodash";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { useDispatch, useSelector, useStore } from "react-redux";
import useLocalStorageState from "use-local-storage-state";
import { columnTypesDate } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesDate";
import { columnTypesNumber } from "../../../../_src_shared/utils/agGrid/columnTypes/columnTypesNumber";
import { formatDateTime } from "../../../../_src_shared/utils/functions/formatDateTime";
import { formatDate } from "../../../../_src_shared/utils/functions/formatDate";
import AgGridTableWrapper from "../../../../components/agGrid/AgGridTableWrapper";
import CellRendererUserByEmail from "../../../../components/agGrid/cellRenderer/CellRendererUserByEmail";
import {
  getStatusStyle,
  loanFileStatusColumnDef,
  statusComparator,
} from "../../../../components/agGrid/cellRenderer/LoanFileStatusCell";
import DocumentAssociations from "../../../../components/associations/DocumentAssociations";
import SearchInput from "../../../../components/inputs/SearchInput";
import LoanDocumentGroupIcon, {
  getDocGroupColor,
} from "../../shared/LoanDocumentGroupIcon";
import {
  getClosingProjection,
  getValidityReferenceMs,
} from "../../../../utils/documents/validityReference";
import { useIsAcquisitions } from "../../../../pipelines/PipelineContext";
import {
  DUPLICATE_NAME_MESSAGE,
  findDuplicateDisplayName,
} from "../../../../utils/documents/duplicateDisplayName";
import {
  isOcrolusSupportedDocument,
  OCROLUS_PDF_ONLY_MESSAGE,
} from "../../../../utils/documents/ocrolusFileValidation";
import SelectFileAssignmentInput from "../../../../components/inputs/SelectFileAssignmentInput";
import BulkSelectionBar from "./BulkSelectionBar";
import PropTypes from "prop-types";
import { segmentedGroupSx } from "../../../../theme/activeStates";
import BasicModal from "../../../../components/modals/BasicModal";
import JsonPreview from "../../../../components/common/JsonPreview";
import SharePackagesPopover from "./SharePackagesPopover";
import TableSortDropdown from "../../../../components/ui/TableSortDropdown";
import Flx from "../../../../components/layout/Flx";
import GroupByChips from "./GroupByChips";
import {
  filePreviewSetData,
  filePreviewClear,
} from "../../../../redux/reducers/filePreviewReducer";
import CommentThreadPreviewTooltip from "../../../../components/tooltips/CommentThreadPreviewTooltip";
import UpdateLoanDocumentMetadataForm from "../../../../forms/UpdateLoanDocumentMetadataForm";
import Txt from "../../../../components/typography/Txt";
import {
  selectOptionsDocumentStatus,
  documentStatusLabel,
} from "../../../../constants/selectOptions/selectOptionsDocumentStatus";
import { useLoanFilesHook } from "../../../../hooks/useLoanFilesHook";
import { useUnderwritingHook } from "../../../../hooks/useUnderwritingHook";
import { useCreateConditionFromDocument } from "../../../../hooks/useCreateConditionFromDocument";
import { useChecklistRouteHook } from "../../../../hooks/useChecklistRouteHook";
import { getUserFullNameFromEmail } from "../../../../utils/functions/getUserFullNameFromEmail";
import { loanDrilldownSet } from "../../../../redux/actions/loanDrilldownActions";
import {
  sidebarSetValues,
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../../redux/actions/sidebarActions";
import { loanFetchedDataUwRequirementsSet } from "../../../../redux/reducers/loanFetchedDataReducer";
import { loanDrilldownSidebarTypes } from "../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { nsKey } from "../../../../utils/storage/partnerStorage";
import {
  DOCUMENT_SHARE_FLAGS,
  sharePackageFileName,
  getShareStamp,
  getShareSelectorConfig,
  isShareFlagOn,
} from "../../../../utils/documents/documentShareFlags";
import DocExpirationCell, {
  BeforeClosingPill,
  getDocClosingOutlook,
  getDocExpiration,
} from "./DocExpirationCell";
import DocDurationCell, { AutoDurationPill } from "./DocDurationCell";
import { formatDateShortYy } from "../../../../utils/dates/formatDateShortYy";
import InlineDatePopoverField from "./InlineDatePopoverField";
import colors, { level1, teal } from "../../../../theme/colors";
import DrilldownSubTabStrip from "../../components/DrilldownSubTabStrip";
import {
  getExpirationDaysForDocType,
  resolveDocExpirationDays,
  computeExpirationDate,
  isHardDurationDocType,
  isExplicitExpirationDocType,
  isDualDateDocType,
  deriveFromExpirationDate,
  deriveDualDateFields,
} from "../../../../constants/documents/docTypeExpirationDurations";

// Max files the multi-select "Download" action will fetch individually. Beyond
// this, a big burst of per-file browser saves gets slow/blocked — use the
// whole-loan "Download All" zip instead.
const MAX_BULK_DOWNLOAD = 20;

// The two rules that bracket the column header — the one under the toolbar and
// the one under the header row itself. They read as a matched pair framing the
// header band, so they are ONE value: changing it here moves both, and neither
// can quietly drift a shade away from the other.
const HEADER_BAND_RULE = "1px solid #e5e7eb";

// Toggles the toolbar "Packages" (share/closing-package builder) button.
const SHOW_PACKAGES_BUTTON = true;

// Group rows: statuses in the status dropdown's order (New Upload →
// Underwriter Accepted); categories and types alphabetically by name.
const groupOrderComparator = ({ nodeA, nodeB }) => {
  const field = nodeA?.field;
  if (field === "documentStatus")
    return statusComparator(nodeA?.key, nodeB?.key);
  if (field !== "docGroup" && field !== "docType") return 0;
  return String(nodeA?.key ?? "").localeCompare(
    String(nodeB?.key ?? ""),
    undefined,
    {
      sensitivity: "base",
    },
  );
};

// Minimum height of the grid itself on the Documents tab.
const DOCUMENTS_TABLE_MIN_HEIGHT = 400;

// Bulk-select checkbox indentation (grouped layouts). The base gutter is the
// checkbox's resting left padding; GROUP_INDENT_PX is one group level's worth of
// indent (kept in step with AG Grid's group-row indent) so a leaf row's checkbox
// lines up directly under its parent group's checkbox. The pinned column widens
// by one GROUP_INDENT_PX per active grouping level to hold the deepest indent.
const BULK_SELECT_GUTTER_PX = 16;
const GROUP_INDENT_PX = 28;
// Room kept to the right of the (indented) checkbox so it never clips.
const BULK_SELECT_CHECKBOX_ROOM = 22;
// Tree guide lines: one 1px rule per ancestor group, dropped straight down
// from that group's chevron (chevron centre = cell padding + this + one
// GROUP_INDENT_PX per level).
const TREE_LINE_OFFSET_PX = 8;
const TREE_LINE_COLOR = "#e2e8f0";
// The line under a CATEGORY's chevron takes a very light tint of that
// category's colour (--dmt-group-color, set per row by getRowStyle).
const TREE_LINE_CATEGORY_COLOR =
  "color-mix(in srgb, var(--dmt-group-color, #e2e8f0) 28%, #ffffff)";
const treeLine = (level, color) => {
  const x = `calc(var(--ag-cell-horizontal-padding, 16px) + ${
    TREE_LINE_OFFSET_PX + level * GROUP_INDENT_PX
  }px)`;
  return `linear-gradient(to right, transparent ${x}, ${color} ${x}, ${color} calc(${x} + 1px), transparent calc(${x} + 1px))`;
};
// Background layers for a row with `lines` ancestor groups. `categoryLevel`
// is the grouping level that is the category (-1 when not grouped by it).
const treeRowBackground = (lines, categoryLevel) =>
  Array.from({ length: lines }, (_, l) =>
    treeLine(
      l,
      l === categoryLevel ? TREE_LINE_CATEGORY_COLOR : TREE_LINE_COLOR,
    ),
  ).join(", ") || "none";
// A grouped file row's checkbox sits one indent step deeper than its parent
// group's checkbox, continuing the diagonal of the group checkboxes.
const bulkSelectIndentPx = (groupDepth) =>
  groupDepth ? (groupDepth + 1) * GROUP_INDENT_PX : 0;
// The pinned bulk-select column's width for a given grouping depth.
const bulkSelectColumnWidth = (groupDepth) =>
  BULK_SELECT_GUTTER_PX +
  bulkSelectIndentPx(groupDepth) +
  BULK_SELECT_CHECKBOX_ROOM;
// Upper bound (supports up to 3 grouping levels) — the column's min/max span
// this range so an explicit per-layout width is always in-bounds.
const BULK_SELECT_MAX_WIDTH = bulkSelectColumnWidth(3);

ModuleRegistry.registerModules([
  RowGroupingModule,
  // The "drag a column here to group" bar (Table settings → Group-by bar).
  RowGroupingPanelModule,
  SideBarModule,
  ColumnsToolPanelModule,
  // Enables the AG Grid right-click context menu so we can mirror the
  // filename column's 3-dot file-actions menu at the row level. Without
  // this module, getContextMenuItems is silently ignored.
  ContextMenuModule,
]);

// =================================================================
// MENU STYLING — mirrors src/components/StyledMenu.js (used by the
// Loan Officer Pipeline's Sort Options menu) so all in-table popovers
// share the same elevated, rounded paper + uppercase mini-header
// treatment.
// =================================================================
const STYLED_MENU_PAPER_SLOT_PROPS = ({ minWidth, maxWidth } = {}) => ({
  paper: {
    elevation: 3,
    sx: {
      borderRadius: "12px",
      border: "1px solid",
      borderColor: "divider",
      overflow: "hidden",
      ...(minWidth ? { minWidth } : { minWidth: 240 }),
      ...(maxWidth && { maxWidth }),
    },
  },
});

const STYLED_MENU_HEADER_SX = { px: 2, pt: 1.75, pb: 1.25 };

const STYLED_MENU_HEADER_TXT_SX = {
  fontWeight: 600,
  fontSize: "11px",
  color: "#6b7280",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const STYLED_MENU_ITEM_SX = {
  py: 1,
  px: 2,
  mx: 0.75,
  borderRadius: "8px",
  fontSize: 14,
  "&.Mui-selected": { backgroundColor: "action.selected" },
  "&:hover": { backgroundColor: "action.hover" },
};

// AG Grid context-menu items accept `icon` as an HTML string. Render the
// MUI icon component to static markup so the right-click menu visually
// mirrors the filename cell's 3-dot "File actions" menu.
const iconHtml = (IconComponent) =>
  renderToStaticMarkup(<IconComponent fontSize="small" />);

// Toolbar grouping toggle (Group Categories / Group Types). Acts as an
// independent on/off switch; when ACTIVE it shows a checkbox and takes the
// same teal accent as the view tabs, otherwise it shows its own icon in the
// quiet/grey state. Both `color` and `background` are set together per the
// button-color convention.
export const GroupToggleButton = ({ active, label, onClick, InactiveIcon }) => (
  <Button
    onClick={onClick}
    variant="outlined"
    size="small"
    startIcon={
      active ? (
        <CheckBoxOutlinedIcon sx={{ fontSize: 16 }} />
      ) : (
        <InactiveIcon sx={{ fontSize: 16 }} />
      )
    }
    sx={{
      textTransform: "none",
      fontSize: 12,
      fontWeight: active ? 600 : 400,
      whiteSpace: "nowrap",
      color: active ? level1.text : "#6B7280",
      borderColor: active ? level1.indicator : "#e5e3df",
      background: active ? level1.tint : "#ffffff",
      "& .MuiButton-startIcon": { mr: 0.5 },
      "& svg": { color: active ? level1.text : "#6B7280" },
      "&:hover": {
        background: active ? teal[200] : "#F7F7F5",
        borderColor: active ? level1.indicator : "#cbd5e1",
      },
    }}
  >
    {label}
  </Button>
);

const LoanDocumentManagerTable = ({
  rowData,
  onRowClicked,
  relatedFiles,
  hideLayouts = false,
  minHeight = 640,
  // Padding around the sticky toolbar (MUI spacing). Embedders that put the
  // table in their own bordered block want it tighter than the full Documents
  // tab does. A number is `p`; an object is spread as-is ({ pt, pb, px }).
  toolbarPadding = 2,
  // Style overrides for the grid container — merged LAST, so an embedder can
  // restyle header / row rules (the drilldown card tables pass
  // `CARD_FILES_GRID_SX`) without forking the table.
  gridSx,
  // Offset the sticky toolbar / column header sit below. Defaults to the
  // drilldown's pinned tab nav. An embedder whose card is its own overflow
  // context (the Applicants tab's bordered block) passes "0px" — there the
  // nav offset just opens a blank band above the toolbar.
  stickyTop = "var(--drilldown-nav-h, 0px)",
  groupDefaultExpanded = -1,
  // groupDefaultExpanded = -3
  // When set to a LAYOUT_OPTIONS key, force that layout regardless of the
  // user's persisted preference, and skip writing changes back to local
  // storage. Useful for embedding the table in a context where a specific
  // grouping is the whole point (e.g. "Property Files" grouped by docGroup).
  forcedLayout = null,
  // When true and the current layout groups by both docGroup AND docType,
  // hide the colored extension badge in the filename cell — the parent
  // group rows already convey the doc category, so the badge becomes
  // redundant. Off in non-grouped / single-axis-grouped layouts so the
  // filename cell keeps its full information density.
  hideFilenameExtensionBox = false,
  // Same gating as above: hides the small "<docType>" line beneath the
  // filename when both grouping axes are active. The parent docType
  // group row already names the type.
  hideFilenameDocTypeSubline = false,
  // Opt-in flag for the Settings button + persisted user preferences
  // (preserve column order, sidebar file preview). Only the main Documents
  // tab passes this — every other consumer of LoanDocumentManagerTable
  // (Subject Properties, Applicants, Liquidity Calculations, etc.) gets
  // the table on its defaults with no shared persisted state across
  // contexts.
  enableUserSettings = false,
  // Opt-in flag for the virtualized, fixed-height layout. When true the
  // grid runs `domLayout="normal"` inside a bounded-height scroll
  // container, so AG Grid only renders the ~visible rows instead of every
  // row. When false (the default — used by the Subject Properties /
  // Applicants embeds) the grid keeps `domLayout="autoHeight"` and grows
  // to fit its content. Only the main Documents tab — which can hold
  // hundreds of files — opts in; that's where row virtualization matters.
  fillHeight = false,
  // When true, leaf (file) rows under a grouped layout are NOT indented to
  // nest under their parent group label — the filename column sits flush left.
  // The chevron/indent on the group rows themselves is unaffected.
  disableLeafIndent = false,
  // Which subset of documents to show — decoupled from grouping so the tab's
  // view tabs (Visible / Hidden / External) and the grouping toggles are
  // independent axes. "visible" (default) hides hidden docs; "hidden" shows
  // ONLY hidden docs; "external" shows ONLY borrower-portal uploads. When not
  // passed, it's derived from `forcedLayout` for backward compatibility with
  // callers that still use the old hiddenFiles / borrowerPortalUploads keys.
  viewFilter = null,
  // Hidden-file scope WITHIN the "visible" view, driven by the Shown vs hidden
  // insight card: "visible" (default — hidden docs excluded), "total" (show
  // everything, hidden included) or "hidden" (only hidden docs). It's a second
  // axis on the Uploaded tab rather than a jump to the Hidden tab, so the
  // operator can widen the list in place. Ignored in the hidden/external views,
  // which already ARE a hidden-ness filter.
  visibilityScope = "visible",
  // Opt-in: render the two "Group Categories" / "Group Types" toggle buttons
  // in the toolbar (right of the search). Only the Documents tab passes these;
  // the parent owns the grouping state and threads the derived key back in via
  // `forcedLayout`.
  showGroupToggles = false,
  groupByStatus = false,
  groupByCategory = false,
  groupByType = false,
  onToggleGroupStatus,
  onToggleGroupCategory,
  onToggleGroupType,
  // Set of keys (file_storage_name and/or _id) for docs that have extracted
  // artifacts. When a row's doc matches, the filename cell shows a "Parsed"
  // chip. `onOpenParsedDoc(doc)` is fired when that chip is clicked (opens the
  // trifold in the parent).
  parsedDocKeys = null,
  onOpenParsedDoc = null,
  // Optional override for the filename click. Default opens the global file
  // preview sidebar; the Parsed view passes its trifold opener instead.
  onOpenFile = null,
}) => {
  const gridRef = useRef(null);
  // Wraps the AG Grid so we can read/restore its horizontal scroll viewport.
  const gridContainerRef = useRef(null);
  const [search, setSearch] = useState("");
  // Bulk-select mode: when the user clicks the toolbar's "Select Multiple"
  // toggle, a checkbox column appears on each row and an action bar mounts
  // at the top of the table for bulk updates. Mirrors the legacy
  // LoanFilesTable selection flow (see hooks/useHandleRowSelectionChange),
  // but with its own UI scoped to this manager table.
  // Selection checkboxes are always shown (no "enter multi-select" step) — the
  // pinned-left checkbox column, row selection, and the bulk action bar (which
  // appears once ≥1 row is checked) all key off this being true.
  const bulkSelectMode = true;
  // Loading flags for the toolbar "Download All" (whole-loan zip) and the
  // multi-select "Download" (per-file) actions — both hit the network and had
  // no feedback before, so a slow zip / batch looked stuck.
  const [downloadingAll, setDownloadingAll] = useState(false);
  const [bulkDownloading, setBulkDownloading] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState([]);
  // Confirmation dialog for the external/irreversible bulk actions ("extract"
  // | "ocrolus"). null = closed.
  const [confirmAction, setConfirmAction] = useState(null);
  // The PDF bank statements picked for "Send to Ocrolus" (the confirm dialog
  // sends exactly these).
  const [ocrolusDocs, setOcrolusDocs] = useState([]);
  const [savedColumnState, setSavedColumnState] = useLocalStorageState(
    COLUMN_STATE_STORAGE_KEY,
    { defaultValue: null },
  );
  const [tableSettings, setTableSettings] = useLocalStorageState(
    TABLE_SETTINGS_STORAGE_KEY,
    { defaultValue: DEFAULT_TABLE_SETTINGS },
  );
  // When this consumer hasn't opted in, behave as if no setting were
  // persisted — the saved values still live in localStorage (so toggling
  // back to the Documents tab restores them) but they don't leak into
  // other tabs that share the component.
  // Always remember the user's last table layout on the main Documents tab —
  // column order / visibility / width / pinning are persisted to localStorage
  // and restored on load (sort is remembered separately via `sortFilter`).
  // (This was an opt-in "Preserve column order" toggle; it's now always on.)
  const preserveColumnOrder = enableUserSettings;
  // Display toggles from the Table settings menu (Documents tab only — other
  // embeds keep the defaults below).
  //   showGroupPanel   the "drag a column here to group" bar (off by default)
  //   hideGroupIcons   no category icon on group rows
  //   compactRows      shorter rows, one line per cell (details in tooltips)
  const showGroupPanel =
    enableUserSettings &&
    showGroupToggles &&
    (tableSettings?.showGroupPanel ?? DEFAULT_TABLE_SETTINGS.showGroupPanel);
  const hideGroupIcons = enableUserSettings && !!tableSettings?.hideGroupIcons;
  // Off (default): a column the rows are grouped by is hidden — its value is
  // already the group header.
  const compactRows = enableUserSettings && !!tableSettings?.compactRows;
  // Hidden files are filtered out by default. When the user picks the
  // "Hidden Files" layout option, we invert that — showing ONLY hidden
  // documents so users have a dedicated view for cleanup/admin work.
  // "Borrower Uploads" is the same pattern: a dedicated view of files
  // uploaded through the borrower portal.
  // `viewFilter` (Documents-tab view tabs) is the source of truth; fall back to
  // the legacy forcedLayout keys so existing callers keep working.
  const effectiveViewFilter =
    viewFilter ||
    (forcedLayout === HIDDEN_FILES_LAYOUT_KEY
      ? "hidden"
      : forcedLayout === BORROWER_PORTAL_UPLOADS_LAYOUT_KEY
        ? "external"
        : "visible");
  const isHiddenFilesView = effectiveViewFilter === "hidden";
  const isBorrowerPortalUploadsView = effectiveViewFilter === "external";
  // Package filter — the share-flag field picked from the Packages menu's file
  // count chip ("show me what's in the Third-party review package"). null = off.
  const [packageFilter, setPackageFilter] = useState(null);
  const [showSelectedOnly, setShowSelectedOnly] = useState(false);
  const displayedRowData = useMemo(() => {
    const scoped = (() => {
      if (isHiddenFilesView) {
        return (rowData || []).filter((d) => isDocHidden(d));
      }
      if (isBorrowerPortalUploadsView) {
        return (rowData || []).filter(
          (d) => !isDocHidden(d) && isBorrowerPortalUpload(d),
        );
      }
      // Uploaded view — the insight card's scope decides how much of the
      // loan's hidden-ness to include.
      if (visibilityScope === "total") return rowData || [];
      if (visibilityScope === "hidden") {
        return (rowData || []).filter((d) => isDocHidden(d));
      }
      return (rowData || []).filter((d) => !isDocHidden(d));
    })();
    let out = packageFilter
      ? scoped.filter((d) => isShareFlagOn(d, packageFilter))
      : scoped;
    // Bulk bar "Show selected only" — narrows the table to the checked rows.
    if (showSelectedOnly && selectedDocs.length > 0) {
      const ids = new Set(selectedDocs.map((d) => d?._id));
      out = out.filter((d) => ids.has(d?._id));
    }
    return out;
  }, [
    rowData,
    isHiddenFilesView,
    isBorrowerPortalUploadsView,
    visibilityScope,
    packageFilter,
    showSelectedOnly,
    selectedDocs,
  ]);
  // Nothing selected → nothing to narrow to; drop the toggle so the next
  // selection starts from the full list.
  useEffect(() => {
    if (!selectedDocs.length) setShowSelectedOnly(false);
  }, [selectedDocs.length]);
  // Opt in to AG Grid's pagination once the unfiltered row count
  // crosses PAGINATION_THRESHOLD. We key off the source `rowData` so
  // the table doesn't oscillate in/out of paginated mode when the
  // user toggles the Show Hidden Files filter near the threshold.
  const paginationEnabled = (rowData?.length || 0) > PAGINATION_THRESHOLD;

  // ── Sort dropdown ───────────────────────────────────────────────────
  // Mirrors the original loan files table's "Sort By" dropdown. Choice
  // is persisted via tableSettings (Documents tab) or held locally for
  // other consumers. Applied to AG Grid via applyColumnState in an
  // effect — that way columnDefs stay stable across sort changes.
  const sortOptions = useMemo(() => SORT_OPTIONS_FACTORY(), []);
  const persistedSortFilter = enableUserSettings
    ? tableSettings?.sortFilter
    : undefined;
  const [localSortFilter, setLocalSortFilter] = useState(
    enableUserSettings
      ? (persistedSortFilter ?? DEFAULT_TABLE_SETTINGS.sortFilter)
      : null,
  );
  const sortFilter = enableUserSettings
    ? (persistedSortFilter ?? DEFAULT_TABLE_SETTINGS.sortFilter)
    : localSortFilter;
  const handleSortFilterChange = useCallback(
    (next) => {
      if (enableUserSettings) {
        setTableSettings((prev) => ({ ...(prev || {}), sortFilter: next }));
        return;
      }
      setLocalSortFilter(next);
    },
    [enableUserSettings, setTableSettings],
  );
  // Sort menu (right toolbar). The button label reflects the active preset,
  // or "Custom" when the user has sorted by clicking a column header.
  const [sortMenuAnchor, setSortMenuAnchor] = useState(null);
  const currentSortLabel = useMemo(() => {
    if (!sortFilter) return null;
    const key = JSON.stringify(sortFilter);
    const preset = sortOptions.find((o) => JSON.stringify(o.value) === key);
    if (preset) return preset.label;
    const hasSort = Array.isArray(sortFilter.state)
      ? sortFilter.state.length > 0
      : !!sortFilter.colId;
    return hasSort ? "Custom" : null;
  }, [sortFilter, sortOptions]);

  // The in-toolbar layout dropdown was hoisted out into the parent (see
  // LoanDocumentLayoutToggle exported below). The table is now purely
  // a slave to `forcedLayout` for grouping — the parent owns the
  // localStorage persistence and the toggle UI. With no internal layout
  // setter remaining, falling back to DEFAULT_LAYOUT when forcedLayout
  // isn't supplied is the right behavior.
  const layoutMode = forcedLayout || DEFAULT_LAYOUT;

  // Layout fields (which columns are row-grouped under the current layout).
  const layoutFields = useMemo(
    () => LAYOUT_OPTIONS.find((o) => o.key === layoutMode)?.fields || [],
    [layoutMode],
  );

  // Hoisted out of the per-cell renderers so we run ONE Redux
  // subscription for each of these instead of one per row. Even with row
  // virtualization (~30 rows in the DOM) this keeps the inline-edit cells
  // — status / docType / associations — from each opening their own
  // store subscription. The values flow to the cells via AG Grid's
  // `context` (see `gridContext` below), which — unlike
  // `cellRendererParams` — does NOT force a `columnDefs` rebuild when it
  // changes.
  const tableLoanId = useSelector((s) => s.loanDrilldown?._id);
  const tableLoanComments = useSelector((s) => s.loanDrilldown?.comments);
  const tableLoan = useSelector((s) => s.loanDrilldown);
  const tableUsers = useSelector((s) => s.users);

  // Pre-bucket comments by loanDocument id so each row's filename cell
  // does an O(1) lookup instead of filtering the full comments array.
  // The cellRendererParams passes the resulting Map into FilenameCell.
  const commentsByDocId = useMemo(() => {
    const map = new Map();
    for (const c of tableLoanComments || []) {
      const docIds = c?.associations?.loanDocuments;
      if (!Array.isArray(docIds)) continue;
      for (const id of docIds) {
        const list = map.get(id);
        if (list) list.push(c);
        else map.set(id, [c]);
      }
    }
    return map;
  }, [tableLoanComments]);

  // Conditions (underwriting requirements) bucketed by the loanDocument ids
  // they're attached to — so each row can show whether a condition references
  // that document and the condition's status. A condition links docs via
  // `uploadedDocumentIds` and/or `associations.loanDocuments`.
  const tableUwRequirements = useSelector(
    (s) => s.loanFetchedData?.uwRequirements,
  );
  const conditionsByDocId = useMemo(() => {
    const map = new Map();
    const list = Array.isArray(tableUwRequirements) ? tableUwRequirements : [];
    for (const c of list) {
      const ids = new Set([
        ...(Array.isArray(c?.uploadedDocumentIds) ? c.uploadedDocumentIds : []),
        ...(Array.isArray(c?.associations?.loanDocuments)
          ? c.associations.loanDocuments
          : []),
      ]);
      for (const id of ids) {
        const existing = map.get(id);
        if (existing) existing.push(c);
        else map.set(id, [c]);
      }
    }
    return map;
  }, [tableUwRequirements]);

  // Ensure conditions are loaded even if the user lands on Documents before
  // visiting the Conditions tab (the condition chip reads from this slice).
  const { getLoanUnderwritingRequirements } = useChecklistRouteHook();
  useEffect(() => {
    if (isNil(tableUwRequirements) && tableLoanId) {
      getLoanUnderwritingRequirements({
        dealId: tableLoanId,
        onSuccessFn: (data) => dispatch(loanFetchedDataUwRequirementsSet(data)),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableUwRequirements, tableLoanId]);

  // Conditions are a SEPARATE fetch that lands after first paint. AG Grid does
  // not re-render cells when `context` changes, so when the bucketed map
  // updates we explicitly refresh the Associations column (which hosts the
  // condition chip) — otherwise it stays empty until some other re-render.
  useEffect(() => {
    const api = gridRef.current?.api;
    if (api) api.refreshCells({ columns: ["associations"], force: true });
  }, [conditionsByDocId]);

  // NOTE: `columnDefs` deliberately does NOT depend on `savedColumnState`.
  // Earlier this used a derived `showDocGroupInDocTypeCell` that flipped on
  // every column toggle (because savedColumnState updates), which caused AG
  // Grid to receive a "new" columnDefs reference and reset the user's just-
  // applied column change. The docType cell renderer now reads docGroup
  // visibility from the api at render time instead — see DocTypeCellRenderer.
  // Both gating flags only fire when the layout groups by *both* docGroup
  // and docType — that's the case where the parent group rows already
  // carry the redundant info. Computed here so buildColumnDefs gets a
  // boolean and the cell renderer doesn't have to introspect layoutMode.
  const isDocGroupAndType = layoutMode === "docGroupAndType";
  const filenameHideExtBox = hideFilenameExtensionBox && isDocGroupAndType;
  const filenameHideDocTypeSubline =
    hideFilenameDocTypeSubline && isDocGroupAndType;

  // Reference day for doc validity: the loan's anchor date once it's closed,
  // otherwise today (see utils/documents/validityReference for the pre-close vs
  // acquisition rules). Selected field-wise so the table doesn't re-render on
  // unrelated loan changes.
  const isAcquisition = useIsAcquisitions();
  const loanStatusForValidity = useSelector((s) => s.loanDrilldown?.loanStatus);
  const loanClosedForValidity = useSelector((s) => s.loanDrilldown?.loanClosed);
  const originationDateForValidity = useSelector(
    (s) => s.loanDrilldown?.originationDate,
  );
  const fundedDateForValidity = useSelector((s) => s.loanDrilldown?.fundedDate);
  const estimatedClosingDateForValidity = useSelector(
    (s) => s.loanDrilldown?.estimatedClosingDate,
  );
  const expectedClosingDateForValidity = useSelector(
    (s) => s.loanDrilldown?.expectedClosingDate,
  );
  const closingScheduledDateForValidity = useSelector(
    (s) => s.loanDrilldown?.closingScheduledDate,
  );
  const validityNowMs = useMemo(
    () =>
      getValidityReferenceMs(
        {
          loanStatus: loanStatusForValidity,
          loanClosed: loanClosedForValidity,
          originationDate: originationDateForValidity,
          fundedDate: fundedDateForValidity,
          estimatedClosingDate: estimatedClosingDateForValidity,
          expectedClosingDate: expectedClosingDateForValidity,
        },
        { isAcquisition },
      ),
    [
      isAcquisition,
      loanStatusForValidity,
      loanClosedForValidity,
      originationDateForValidity,
      fundedDateForValidity,
      estimatedClosingDateForValidity,
      expectedClosingDateForValidity,
    ],
  );
  // The upcoming closing date a LIVE loan's docs are also checked against —
  // drives the "Before closing" flag on the Validity / Expires cells. Null
  // once the loan has closed (its reference day already is the close).
  const validityClosingMs = useMemo(
    () =>
      getClosingProjection(
        {
          loanStatus: loanStatusForValidity,
          loanClosed: loanClosedForValidity,
          closingScheduledDate: closingScheduledDateForValidity,
          expectedClosingDate: expectedClosingDateForValidity,
        },
        { isAcquisition },
      )?.closingMs ?? null,
    [
      isAcquisition,
      loanStatusForValidity,
      loanClosedForValidity,
      closingScheduledDateForValidity,
      expectedClosingDateForValidity,
    ],
  );

  // The FilenameCell column uses a named cellRenderer (defined at module
  // scope) plus this stable params object. AG Grid then doesn't have to
  // remount cells on every layout change — only the param values shift.
  const filenameCellRendererParams = useMemo(
    () => ({
      hideExtensionBox: filenameHideExtBox,
      hideDocTypeSubline: filenameHideDocTypeSubline,
      commentsByDocId,
      tableLoanId,
      layoutFields,
      // Flush the filename column left whenever a grouping is active (by
      // docType, docGroup, or both) — the group header already carries the
      // category, so the per-file tree indent just wastes horizontal space.
      disableLeafIndent: disableLeafIndent || layoutFields.length > 0,
      validityNowMs,
      parsedDocKeys,
      onOpenParsedDoc,
    }),
    [
      filenameHideExtBox,
      filenameHideDocTypeSubline,
      commentsByDocId,
      tableLoanId,
      layoutFields,
      disableLeafIndent,
      validityNowMs,
      parsedDocKeys,
      onOpenParsedDoc,
    ],
  );

  const columnDefs = useMemo(() => {
    // Effective Start Date always shows (it uses its column default), rather
    // than auto-hiding when no doc carries a report effective date.
    const base = buildColumnDefs(DEFAULT_COLUMN_VISIBILITY, layoutMode, {
      filenameCellRendererParams,
      validityNowMs,
      validityClosingMs,
    });
    // Stamp the active sort (`sortFilter`) directly onto the colDefs so it
    // travels WITH columnDefs and is applied atomically as part of AG Grid's
    // column reconcile. The earlier approach restored the sort via a separate
    // `applyColumnState` effect after columnDefs rebuilt (e.g. after an inline
    // status save refreshes the loan, which bubbles through commentsByDocId →
    // filenameCellRendererParams → columnDefs). But AG Grid v33 batches the
    // columnDefs reconcile, so that effect ran BEFORE the reconcile completed
    // and the restored sort was wiped — the bug where a header-click sort
    // reset after an inline edit. Carrying `sort`/`sortIndex` on the colDef
    // closes that race. `sortFilter` already tracks both the dropdown
    // selection AND header-click sorts (see handleSortChanged), so the stamp
    // stays in lockstep with the user's choice. Every non-sorted column is
    // stamped `sort: null` so a stale sort can't linger when the user
    // switches to a single-column sort.
    const sortState = resolveSortState(sortFilter);
    const sortByColId = new Map(
      (sortState || []).map((s, i) => [
        s.colId,
        { sort: s.sort ?? null, sortIndex: s.sortIndex ?? i },
      ]),
    );
    const withSort = base.map((col) => {
      const id = col.colId || col.field;
      const s = id != null ? sortByColId.get(id) : undefined;
      return s
        ? { ...col, sort: s.sort, sortIndex: s.sortIndex }
        : { ...col, sort: null, sortIndex: null };
    });
    if (!bulkSelectMode) return withSort;
    // Pinned-left checkbox column only mounts in bulk-select mode so the
    // default table layout stays untouched. `headerCheckboxSelection`
    // gives users a select-all toggle that respects filtering.
    // When grouped, every leaf sits at the same depth (= number of grouping
    // fields), so the indent is driven by `groupDepth` — NOT `node.level`, which
    // could diverge from the column width and push the checkbox past the cell's
    // clipped right edge (it vanished at depth ≥ 2). The column always keeps a
    // fixed CHECKBOX_ROOM to the right of the indent so the box can't be clipped.
    const groupDepth = layoutFields.length;
    const bulkSelectIndent = bulkSelectIndentPx(groupDepth);
    const bulkSelectWidth = bulkSelectColumnWidth(groupDepth);
    const selectionColumn = {
      // The id carries the grouping depth so every regroup creates a FRESH
      // column at this depth's width. AG Grid keeps an existing column's
      // runtime width across columnDefs changes, which left the wide grouped
      // column behind after ungrouping.
      colId: `__bulk_select_d${groupDepth}`,
      flex: 0,
      // Grouped, this column is wide (it holds the indented checkboxes), so
      // the "Filename" label moves in here beside the select-all checkbox
      // instead of floating after the gap.
      headerName: "",
      // Our own header: the select-all checkbox (indented to line up with the
      // top-level group checkboxes when grouped) and, when grouped, the
      // "Filename" label right beside it.
      headerComponent: BulkSelectHeader,
      headerComponentParams: { grouped: groupDepth > 0 },
      // min/max span every possible depth; the ACTUAL width is set explicitly
      // per layout via the effect below (AG Grid preserves a column's runtime
      // width across columnDefs changes, so a fixed width here would go stale
      // on a group toggle and clip the indented checkbox).
      width: bulkSelectWidth,
      minWidth: 44,
      maxWidth: BULK_SELECT_MAX_WIDTH,
      pinned: "left",
      lockPosition: "left",
      sortable: false,
      filter: false,
      resizable: false,
      suppressMenu: true,
      checkboxSelection: true,
      cellClass: "dmt-bulk-select-cell",
      headerClass: "dmt-bulk-select-header",
      // Indent the checkbox so it nests directly under its parent group's
      // checkbox. Static per layout (all leaves share the same depth), leaving
      // CHECKBOX_ROOM to the cell's right edge so it always renders.
      cellStyle: {
        paddingLeft: `${BULK_SELECT_GUTTER_PX + bulkSelectIndent}px`,
        paddingRight: 0,
      },
    };
    return [selectionColumn, ...withSort];
  }, [
    layoutMode,
    layoutFields,
    filenameCellRendererParams,
    validityNowMs,
    validityClosingMs,
    bulkSelectMode,
    sortFilter,
  ]);

  // AG Grid `context` — the escape hatch for handing per-render values to
  // every cell renderer WITHOUT them living in `columnDefs`. The inline-
  // edit cells (status / docType / associations) read `loan` / `loanId` /
  // `users` off `params.context` instead of each opening their own
  // `useSelector`. Crucially, changing `context` does not rebuild
  // `columnDefs` (which would make AG Grid reconcile every column) — and
  // loan mutations already replace `loanDocuments`, so AG Grid refreshes
  // the affected rows and the cells pick up the fresh context naturally.
  const dispatch = useDispatch();

  // File APIs used by the row context menu, the bulk bar, and the
  // share-flag cells. Hoisted above `gridContext` so the toggle handler
  // can be handed to the cells through AG Grid context — one hook
  // instance for the whole table instead of one per rendered cell.
  const {
    getFileById: getFileByIdForContext,
    updateLoanDocMetadata: updateLoanDocMetadataForContext,
    downloadLoanDocs: downloadLoanDocsBulk,
    downloadDocumentPackage,
    pushDocumentPackage,
    parseAndExtractDocuments,
    sendBankStatementsToOcrolus,
  } = useLoanFilesHook();

  // Inline flag toggle — debounced + SURGICAL. Committing the full server
  // response after each toggle re-renders (flashes) the table: its new
  // `comments` / array references make `commentsByDocId` (and therefore
  // `columnDefs`) rebuild, which AG Grid treats as a full refresh (and resets
  // the horizontal scroll). Instead we merge ONLY each toggled field into the
  // current loan — keeping every other reference (comments, borrowers, …)
  // stable — and dispatch once the user pauses. With `columnDefs` unchanged, AG
  // Grid delta-updates just the affected rows via `getRowId`: no flash, no
  // scroll jump. Cells paint optimistically until this settles.
  const loanRef = useRef(tableLoan);
  loanRef.current = tableLoan;
  const pendingFlagPatchesRef = useRef(new Map()); // docId -> { field: value }
  const loanCommitTimerRef = useRef(null);
  const flushLoanCommit = useCallback(() => {
    clearTimeout(loanCommitTimerRef.current);
    const patches = pendingFlagPatchesRef.current;
    if (!patches.size) return;
    const loan = loanRef.current;
    if (loan?.loanDocuments) {
      dispatch(
        loanDrilldownSet({
          ...loan,
          loanDocuments: loan.loanDocuments.map((d) =>
            patches.has(d._id) ? { ...d, ...patches.get(d._id) } : d,
          ),
        }),
      );
    }
    pendingFlagPatchesRef.current = new Map();
  }, [dispatch]);
  // Flush any pending commit on unmount so a save isn't visually dropped.
  useEffect(() => () => flushLoanCommit(), [flushLoanCommit]);

  const handleToggleShareFlag = useCallback(
    (doc, field, next, { onFailFn, onSuccessFn } = {}) => {
      if (!doc?._id) return;
      updateLoanDocMetadataForContext({
        loanId: doc?.dealId || tableLoanId,
        data: [{ _id: doc._id, [field]: !!next }],
        onSuccessFn: (resp) => {
          const patches = pendingFlagPatchesRef.current;
          patches.set(doc._id, {
            ...(patches.get(doc._id) || {}),
            [field]: !!next,
          });
          clearTimeout(loanCommitTimerRef.current);
          loanCommitTimerRef.current = setTimeout(flushLoanCommit, 500);
          onSuccessFn?.(resp);
        },
        onFailFn,
      });
    },
    [updateLoanDocMetadataForContext, tableLoanId, flushLoanCommit],
  );

  // ── Share packages ──────────────────────────────────────────────────
  // Each share flag has a matching package selector. Building a package
  // zips every flagged doc (foldered by docGroup), stages the zip as a
  // tracked loan document, and stamps each included doc — so the loan is
  // refetched afterwards to pick both up.
  const [packageMenuAnchor, setPackageMenuAnchor] = useState(null);
  const [packageBusySelector, setPackageBusySelector] = useState(null);
  // Which action is in flight for the busy selector ("download" | "stage" |
  // "push") — lets each button show its own spinner instead of all three
  // spinning together.
  const [packageBusyAction, setPackageBusyAction] = useState(null);
  const { getLoanById } = useUnderwritingHook();

  // Packages are built from the WHOLE loan, not the filtered table rows.
  const packageSourceDocs = tableLoan?.loanDocuments || rowData;
  const activePackageFlag = packageFilter
    ? DOCUMENT_SHARE_FLAGS.find((f) => f.field === packageFilter)
    : null;
  // The downloaded zip's name (without ".zip") — also the root of the
  // package detail tree.
  const packageZipBaseName = useCallback(
    (selector) =>
      sharePackageFileName(
        selector,
        tableLoan?.loanName || `Loan #${tableLoan?.loanNumber}`,
      ),
    [tableLoan?.loanName, tableLoan?.loanNumber],
  );

  const refreshLoanAfterPackage = useCallback(() => {
    if (!tableLoanId) return;
    getLoanById({
      loanId: tableLoanId,
      onSuccessFn: (data) => {
        if (data) dispatch(loanDrilldownSet(data));
      },
    });
  }, [getLoanById, tableLoanId, dispatch]);

  // The three package actions. Each keeps the popover open (the user may run
  // another) and calls `onSuccess` so the popover can confirm what happened.
  const runPackageAction = useCallback(
    async (flag, action, call, onSuccess) => {
      if (!tableLoanId) return;
      setPackageBusySelector(flag.selector);
      setPackageBusyAction(action);
      await call({
        loanId: tableLoanId,
        selector: flag.selector,
        onSuccessFn: () => {
          refreshLoanAfterPackage();
          onSuccess?.();
        },
      });
      setPackageBusySelector(null);
      setPackageBusyAction(null);
    },
    [tableLoanId, refreshLoanAfterPackage],
  );

  const handleDownloadPackage = useCallback(
    (flag, onSuccess) =>
      runPackageAction(
        flag,
        "download",
        (args) =>
          downloadDocumentPackage({
            ...args,
            fileDownloadName: `${packageZipBaseName(flag.selector)}.zip`,
          }),
        onSuccess,
      ),
    [runPackageAction, downloadDocumentPackage, packageZipBaseName],
  );

  const handleStagePackage = useCallback(
    (flag, onSuccess) =>
      runPackageAction(flag, "stage", pushDocumentPackage, onSuccess),
    [runPackageAction, pushDocumentPackage],
  );

  const gridContext = useMemo(
    () => ({
      loan: tableLoan,
      loanId: tableLoanId,
      users: tableUsers,
      conditionsByDocId,
      onToggleShareFlag: handleToggleShareFlag,
      // Table settings the cell / group renderers read.
      compact: compactRows,
      hideGroupIcons,
    }),
    [
      tableLoan,
      tableLoanId,
      tableUsers,
      conditionsByDocId,
      handleToggleShareFlag,
      compactRows,
      hideGroupIcons,
    ],
  );

  const persistColumnState = useCallback(
    (event) => {
      const api = gridRef.current?.api || event?.api;
      if (!api) return;
      // Refresh docType cells regardless — the inline docGroup line reacts
      // to docGroup column visibility, so it has to update on toggle even
      // when we're not persisting state.
      api.refreshCells({ columns: ["docType"], force: true });
      // Persist the layout on the main Documents tab (preserveColumnOrder is
      // always on there); the scoped embeds don't persist.
      if (!preserveColumnOrder) return;
      // Ignore our own api-driven restores — the re-apply effect below emits
      // "api"-sourced column events; persisting those would loop with it. Only
      // genuine user actions (column drag / tool-panel toggle / menu) persist.
      if (event?.source === "api") return;
      // Persist only visibility / width / order / pinning — drop the
      // grouping-related fields so they can't override layoutMode-driven
      // grouping on the next load. Also drop the pinned bulk-select column: its
      // width is layout-driven (it widens per grouping level to indent the
      // checkbox), so a persisted width would fight columnDefs — clipping the
      // checkbox on a group toggle and leaving stale space back in table view.
      const cleaned = api
        .getColumnState()
        .filter((c) => !String(c.colId).startsWith("__bulk_select"))
        .map(
          ({
            rowGroup,
            rowGroupIndex,
            pivot,
            pivotIndex,
            sort,
            sortIndex,
            ...rest
          }) => rest,
        );
      setSavedColumnState(cleaned);
    },
    [setSavedColumnState, preserveColumnOrder],
  );

  const handleGridReady = useCallback(
    (params) => {
      if (
        preserveColumnOrder &&
        savedColumnState &&
        Array.isArray(savedColumnState)
      ) {
        // Strip row-group / pivot / sort fields from the persisted state so
        // they don't override the layout-driven `rowGroupIndex` we set in
        // columnDefs (`layoutMode` is the source of truth for grouping). The
        // user only persists visibility / width / order via the column
        // sidebar; those still apply.
        const cleaned = savedColumnState
          .filter((c) => !String(c.colId).startsWith("__bulk_select"))
          .map(
            ({
              rowGroup,
              rowGroupIndex,
              pivot,
              pivotIndex,
              sort,
              sortIndex,
              ...rest
            }) => rest,
          );
        params.api.applyColumnState({
          state: cleaned,
          applyOrder: true,
        });
      }
      // Apply the persisted sort choice once the grid is ready. Other
      // sort changes are handled by the effect below.
      const sortState = resolveSortState(sortFilter);
      if (sortState) {
        params.api.applyColumnState({
          state: sortState,
          defaultState: { sort: null },
        });
      } else {
        params.api.applyColumnState({ defaultState: { sort: null } });
      }
    },
    [savedColumnState, preserveColumnOrder, sortFilter],
  );

  // Mirror a sort the user applies by clicking a column header back into
  // `sortFilter`, so it becomes the single source of truth for "the current
  // sort". Without this, a header-click sort lived only in AG Grid's internal
  // column state while `sortFilter` still held the (stale) dropdown choice —
  // so the moment `columnDefs` rebuilt (e.g. after inline-saving a document
  // status, which bubbles through `commentsByDocId` →
  // `filenameCellRendererParams`), the restamp effect below re-applied the
  // dropdown sort and the user's header-click sort was lost.
  //
  // Only react to genuine UI sorts (`source === "uiColumnSorted"`). Our own
  // `applyColumnState` restamps and columnDefs reconciliation fire with other
  // sources ("api" / "columnEverything"); reacting to those would loop or
  // clobber the user's choice.
  const handleSortChanged = useCallback(
    (event) => {
      if (event?.source !== "uiColumnSorted") return;
      const sortCols = (event.api?.getColumnState() || [])
        .filter((c) => c.sort != null)
        .sort((a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0))
        .map(({ colId, sort, sortIndex }) => ({ colId, sort, sortIndex }));
      // `{ state: [] }` represents "user cleared the sort" — distinct from
      // `null`, which would fall back to the persisted/default sort.
      handleSortFilterChange(
        sortCols.length ? { state: sortCols } : { state: [] },
      );
    },
    [handleSortFilterChange],
  );

  // Re-apply the current sort (`sortFilter`, which now tracks both the
  // dropdown selection AND header-click sorts) whenever it changes — and also
  // whenever `columnDefs` rebuild. AG Grid's reconciliation of a new
  // columnDefs reference can wipe the api-applied sort, so we restamp it
  // here. Effectful (rather than embedded in columnDefs) so this doesn't
  // clobber the user's column visibility/width changes.
  useEffect(() => {
    const api = gridRef.current?.api;
    if (!api) return;
    const sortState = resolveSortState(sortFilter);
    if (sortState) {
      api.applyColumnState({
        state: sortState,
        defaultState: { sort: null },
      });
    } else {
      api.applyColumnState({ defaultState: { sort: null } });
    }
  }, [sortFilter, columnDefs]);

  // Re-apply the saved column LAYOUT (visibility / order / width / pinning)
  // whenever columnDefs rebuild. columnDefs are built from
  // DEFAULT_COLUMN_VISIBILITY, so every rebuild (e.g. an inline save refreshes
  // the loan) resets each column's `hide` back to its default — which would
  // clobber a column the user just showed via "Edit Columns" (and lose it on
  // refresh). Restamping here keeps the user's layout. The applyColumnState is
  // "api"-sourced, which persistColumnState ignores, so this doesn't loop.
  useEffect(() => {
    if (!preserveColumnOrder) return;
    const api = gridRef.current?.api;
    if (!api || !Array.isArray(savedColumnState) || !savedColumnState.length)
      return;
    const cleaned = savedColumnState
      .filter((c) => !String(c.colId).startsWith("__bulk_select"))
      .map(
        ({
          rowGroup,
          rowGroupIndex,
          pivot,
          pivotIndex,
          sort,
          sortIndex,
          ...rest
        }) => rest,
      );
    api.applyColumnState({ state: cleaned, applyOrder: true });
  }, [columnDefs, savedColumnState, preserveColumnOrder]);

  const sideBar = useMemo(
    () => ({
      // hiddenByDefault keeps the sidebar collapsed on mount; the toolbar
      // "Columns" button below uses the grid api to toggle it open.
      hiddenByDefault: true,
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
          },
        },
      ],
    }),
    [],
  );

  const [columnsPanelOpen, setColumnsPanelOpen] = useState(false);
  const handleToggleColumnsPanel = useCallback(() => {
    const api = gridRef.current?.api;
    if (!api) return;
    setColumnsPanelOpen((prev) => {
      const next = !prev;
      if (next) {
        api.setSideBarVisible(true);
        api.openToolPanel("columns");
      } else {
        api.closeToolPanel();
        api.setSideBarVisible(false);
      }
      return next;
    });
  }, []);

  // Settings menu anchor state (local); toggle state is persisted via
  // `tableSettings`.
  // Table settings popover (row density, category icons, row-group bar).
  const [settingsAnchor, setSettingsAnchor] = useState(null);

  // The user has a persisted, non-default layout when there's saved column
  // state (order / visibility / width) or a custom sort. Gates the "Reset to
  // default" button.
  const hasActiveGrouping = groupByStatus || groupByCategory || groupByType;
  const hasSavedTableState =
    enableUserSettings &&
    ((Array.isArray(savedColumnState) && savedColumnState.length > 0) ||
      persistedSortFilter != null ||
      hasActiveGrouping);

  const handleResetTableDefaults = useCallback(() => {
    setSavedColumnState(null);
    handleSortFilterChange(null);
    // Also clear any active "Group by" selection (owned by the parent tab).
    if (groupByStatus) onToggleGroupStatus?.();
    if (groupByCategory) onToggleGroupCategory?.();
    if (groupByType) onToggleGroupType?.();
    const api = gridRef.current?.api;
    if (api) api.resetColumnState();
    setSettingsAnchor(null);
  }, [
    setSavedColumnState,
    handleSortFilterChange,
    groupByStatus,
    groupByCategory,
    groupByType,
    onToggleGroupStatus,
    onToggleGroupCategory,
    onToggleGroupType,
  ]);

  // Flip one boolean table setting (falls back to its default when unset).
  const handleToggleTableSetting = useCallback(
    (key) => {
      setTableSettings((prev) => ({
        ...(prev || {}),
        [key]: !(prev?.[key] ?? DEFAULT_TABLE_SETTINGS[key]),
      }));
    },
    [setTableSettings],
  );

  // Measure the sticky toolbar so the AG Grid header can stick directly
  // beneath it without overlap or gap. domLayout="autoHeight" lets the page
  // scroll instead of the grid, so AG Grid's built-in sticky header doesn't
  // engage — we pin .ag-header via CSS using this measured offset.
  const toolbarRef = useRef(null);
  const [toolbarHeight, setToolbarHeight] = useState(0);
  useEffect(() => {
    const el = toolbarRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const update = () => setToolbarHeight(el.getBoundingClientRect().height);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const groupRowRendererParams = useMemo(
    () => ({
      innerRenderer: GroupRowInnerRenderer,
      // Suppress the default "(N)" since our inner renderer renders its own
      // count + the optional "Expand all in group" affordance.
      suppressCount: true,
    }),
    [],
  );

  const columnTypes = useMemo(
    () => ({ ...columnTypesDate(), ...columnTypesNumber() }),
    [],
  );

  // Click a tree guide line to collapse the group it hangs from (the
  // category's line collapses the category, a type's line the type). The
  // lines are background art, so hit-test the pointer against their x
  // positions (same math as `treeLine`) on the row under it.
  useEffect(() => {
    const el = gridContainerRef.current;
    if (!el || !layoutFields.length) return undefined;
    const HIT_PX = 6;
    // The group a pointer event is on a guide line of, or null.
    const groupAtLine = (e) => {
      const rowEl = e.target?.closest?.(".ag-row[row-index]");
      const rootEl = el.querySelector(".ag-root-wrapper");
      const api = gridRef.current?.api;
      if (!rowEl || !rootEl || !api) return null;
      // Only the strip left of the checkbox column's content / group label.
      if (
        !rowEl.closest(
          ".ag-pinned-left-cols-container, .ag-full-width-container",
        )
      )
        return null;
      const node = api.getDisplayedRowAtIndex(
        Number(rowEl.getAttribute("row-index")),
      );
      if (!node) return null;
      const pad =
        parseFloat(
          getComputedStyle(rootEl).getPropertyValue(
            "--ag-cell-horizontal-padding",
          ),
        ) || 16;
      const x = e.clientX - rootEl.getBoundingClientRect().left;
      const lines = node.level || 0; // ancestors above this row
      for (let l = 0; l < lines; l += 1) {
        const lineX = pad + TREE_LINE_OFFSET_PX + l * GROUP_INDENT_PX;
        if (Math.abs(x - lineX) <= HIT_PX) {
          let g = node.parent;
          while (g && g.level > l) g = g.parent;
          return g && g.group && g.level === l ? g : null;
        }
      }
      return null;
    };
    const onClick = (e) => {
      const g = groupAtLine(e);
      if (!g) return;
      e.stopPropagation();
      e.preventDefault();
      g.setExpanded(false);
    };
    const onMove = (e) => {
      el.style.cursor = groupAtLine(e) ? "pointer" : "";
    };
    el.addEventListener("click", onClick, true);
    el.addEventListener("mousemove", onMove);
    return () => {
      el.removeEventListener("click", onClick, true);
      el.removeEventListener("mousemove", onMove);
      el.style.cursor = "";
    };
  }, [layoutFields]);

  // How tall the grid must be to reach the bottom of the first screen from
  // where it starts on the page (Documents tab). Measured from the page top,
  // so it doesn't change as you scroll.
  const [gridFillMinHeight, setGridFillMinHeight] = useState(
    DOCUMENTS_TABLE_MIN_HEIGHT,
  );
  useEffect(() => {
    if (!enableUserSettings || fillHeight) return undefined;
    const measure = () => {
      const el = gridContainerRef.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY;
      const next = Math.max(
        DOCUMENTS_TABLE_MIN_HEIGHT,
        Math.round(window.innerHeight - top - 16),
      );
      setGridFillMinHeight((cur) => (Math.abs(cur - next) > 1 ? next : cur));
    };
    measure();
    window.addEventListener("resize", measure);
    // Content above the grid (the summary panel opening, the row-group bar)
    // moves it down — re-measure when the page lays out again.
    const ro = new ResizeObserver(measure);
    ro.observe(document.body);
    return () => {
      window.removeEventListener("resize", measure);
      ro.disconnect();
    };
  }, [enableUserSettings, fillHeight]);

  const getRowId = useCallback((params) => params.data._id, []);

  // Fixed row heights. Replaces the per-column `autoHeight: true` the
  // filename / status / docType / associations columns used to set —
  // AG Grid's autoHeight renders each cell into an off-screen measuring
  // pass, then sets the real height and re-renders, which was the
  // visible "content loads, then the table jumps into place" on large
  // loans. Group rows: 42px (single label line). Leaf rows: uniform 44px
  // since the filename cell no longer renders a subline (effective date
  // and duration are rendered inline as a chip next to the filename).
  // Compact mode drops both to 32px — every cell renders on one line then.
  const getRowHeight = useCallback(
    (params) => {
      if (compactRows) return 32;
      if (params?.node?.group) return 42;
      return 44;
    },
    [compactRows],
  );
  // Row heights and the context-driven renderers (compact cells, group icons)
  // don't repaint on their own when a setting flips.
  useEffect(() => {
    const api = gridRef.current?.api;
    if (!api) return;
    api.resetRowHeights();
    api.redrawRows();
  }, [compactRows, hideGroupIcons]);

  // The group-by bar and the Status / Category / Type chips are two views of
  // the same grouping (owned by the parent tab). A drag into / out of the bar
  // flips the matching chip; the chips then rebuild the columns, so the bar
  // always ends in the fixed Status → Category → Type order.
  const handleColumnRowGroupChanged = useCallback(
    (e) => {
      if (!showGroupToggles) return;
      if (e?.source === "api" || e?.source === "gridOptionsChanged") return;
      const ids = (e?.api?.getRowGroupColumns?.() || []).map((c) =>
        c.getColId(),
      );
      if (ids.includes("documentStatus") !== !!groupByStatus) {
        onToggleGroupStatus?.();
      }
      if (ids.includes("docGroup") !== !!groupByCategory) {
        onToggleGroupCategory?.();
      }
      if (ids.includes("docType") !== !!groupByType) onToggleGroupType?.();
    },
    [
      showGroupToggles,
      groupByStatus,
      groupByCategory,
      groupByType,
      onToggleGroupStatus,
      onToggleGroupCategory,
      onToggleGroupType,
    ],
  );

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      minWidth: 120,
      // minWidth: 140,
      resizable: true,
      sortable: true,
      cellClass: "ag-cell-vertical-center",
      cellStyle: { display: "flex", alignItems: "center" },
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      // When the keystroke originates from a text input/textarea inside a
      // cell (e.g. the inline filename rename field), let the browser handle
      // it instead of AG Grid's cell navigation. Without this, ArrowLeft/
      // ArrowRight move the grid focus instead of the text caret, so the
      // user can't move the cursor while typing a filename.
      suppressKeyboardEvent: (params) => {
        const target = params?.event?.target;
        if (!target) return false;
        const tag = target.tagName;
        return (
          tag === "INPUT" ||
          tag === "TEXTAREA" ||
          target.isContentEditable === true
        );
      },
    }),
    [],
  );

  // The file preview is now a screen-level, redux-driven sidebar
  // (`filePreview` slice) so it persists across drilldown tabs and stays
  // pinned to the right. Opening = dispatch the doc as the preview data;
  // closing = clear it. `setPreviewFile` is kept as a thin alias so the
  // existing call sites (filename click, context menu) read naturally.
  const setPreviewFile = useCallback(
    (doc) => dispatch(doc ? filePreviewSetData(doc) : filePreviewClear()),
    [dispatch],
  );

  const [contextEditDetailsDoc, setContextEditDetailsDoc] = useState(null);
  const [contextValidityDoc, setContextValidityDoc] = useState(null);

  const handleContextDownload = useCallback(
    (doc) => {
      if (!doc) return;
      getFileByIdForContext({
        loanId: doc?.dealId || tableLoanId,
        file_storage_name: doc?.file_storage_name,
        fileDownloadName: doc?.file_display_name,
        fileDownload: true,
      });
    },
    [getFileByIdForContext, tableLoanId],
  );

  const handleContextOpenInNewTab = useCallback(
    (doc) => {
      if (!doc) return;
      getFileByIdForContext({
        loanId: doc?.dealId || tableLoanId,
        file_storage_name: doc?.file_storage_name,
        fileDownloadName: doc?.file_display_name,
        openInNewTab: true,
      });
    },
    [getFileByIdForContext, tableLoanId],
  );

  // ── Bulk-select handlers ────────────────────────────────────────────
  const handleBulkSelectionChanged = useCallback((params) => {
    setSelectedDocs(params.api.getSelectedRows());
  }, []);

  // The selection as the loan has it NOW. AG Grid keeps the selection across
  // a rowData refresh (rows are keyed by `_id`) without firing a selection
  // event, so `selectedDocs` can hold the pre-save copies — the bulk bar reads
  // current values ("2 of 5 now") and snapshots them for Undo, so it gets
  // these.
  const freshSelectedDocs = useMemo(() => {
    if (!selectedDocs.length) return selectedDocs;
    const byId = new Map((rowData || []).map((d) => [d?._id, d]));
    return selectedDocs.map((d) => byId.get(d?._id) || d);
  }, [selectedDocs, rowData]);

  // Clear the current selection (checkboxes stay visible).
  const handleClearSelection = useCallback(() => {
    setSelectedDocs([]);
    gridRef.current?.api?.deselectAll();
  }, []);

  const handleBulkSelectAll = useCallback(() => {
    const api = gridRef.current?.api;
    if (!api) return;
    // Selects every visible/filtered row, not the full unfiltered set.
    // (selectAllFiltered() returns void, so the old `|| selectAll()` fallback
    // always ran and re-selected hidden rows too.)
    api.selectAll("filtered");
  }, []);

  const handleBulkClearSelection = useCallback(() => {
    gridRef.current?.api?.deselectAll();
    setSelectedDocs([]);
  }, []);

  const handleBulkDownload = useCallback(async () => {
    // One request per file, via the single-file endpoint (file_by_id). The
    // backend's zip endpoints are population-based, not selection-based —
    // `/files/download_loan_docs` zips the WHOLE loan and
    // `/files/document_package/{selector}` zips whatever carries a share flag —
    // so neither can express "these 7 rows". Downloads run sequentially so the
    // spinner reflects real progress (and the browser isn't hit with a burst).
    // Capped at MAX_BULK_DOWNLOAD files — beyond that, "Download All" (one zip)
    // is the right tool, and a big burst of individual saves gets blocked/slow.
    if (
      !selectedDocs.length ||
      bulkDownloading ||
      selectedDocs.length > MAX_BULK_DOWNLOAD
    )
      return;
    setBulkDownloading(true);
    try {
      for (const doc of selectedDocs) {
        if (!doc?.file_storage_name) continue;
        await getFileByIdForContext({
          loanId: doc?.dealId || tableLoanId,
          file_storage_name: doc.file_storage_name,
          fileDownloadName: doc?.file_display_name,
          fileDownload: true,
        });
      }
    } finally {
      setBulkDownloading(false);
    }
  }, [selectedDocs, bulkDownloading, getFileByIdForContext, tableLoanId]);

  // Toolbar "Download All" — the whole-loan zip (foldered by docGroup) from
  // GET /files/download_loan_docs/{loanId}. Only offered on the main Documents
  // tab (enableUserSettings); the scoped embeds show a subset, so a whole-loan
  // zip there would be misleading.
  const handleDownloadAll = useCallback(async () => {
    if (!tableLoanId || downloadingAll) return;
    setDownloadingAll(true);
    try {
      await downloadLoanDocsBulk?.({
        loanId: tableLoanId,
        fileDownloadName: "loan-documents.zip",
      });
    } finally {
      setDownloadingAll(false);
    }
  }, [tableLoanId, downloadingAll, downloadLoanDocsBulk]);

  // Send the selected docs for parsing + data extraction (POST
  // /files/parse_extract_docs/{dealId}). The backend queues them onto the
  // `parse_documents` pipeline and the results land in the parsed-documents
  // store — this is fire-and-forget from the table's perspective.
  const handleBulkParseExtract = useCallback(() => {
    if (!selectedDocs.length || !tableLoanId) return;
    parseAndExtractDocuments({
      dealId: tableLoanId,
      files: selectedDocs,
      onSuccessFn: handleClearSelection,
    });
  }, [
    selectedDocs,
    tableLoanId,
    parseAndExtractDocuments,
    handleClearSelection,
  ]);

  // Send the picked PDF bank statements to Ocrolus (POST
  // /files/bank_statements_to_ocrolus/{dealId}); the backend auto-creates /
  // uses the loan's Ocrolus book. The bulk bar hands over only the eligible
  // subset of the selection, so a mixed selection still sends.
  const handleSendToOcrolus = useCallback(() => {
    const docs = ocrolusDocs.filter((doc) => isOcrolusSupportedDocument(doc));
    if (!docs.length || !tableLoanId) return;
    sendBankStatementsToOcrolus({
      dealId: tableLoanId,
      documents: docs,
      onSuccessFn: handleClearSelection,
    });
  }, [
    ocrolusDocs,
    tableLoanId,
    sendBankStatementsToOcrolus,
    handleClearSelection,
  ]);

  // Shared style for the right-side toolbar pill buttons (Sort, Columns,
  // Download All, Reset, Packages) — a clean bordered pill with a small icon.
  const toolbarBtnSx = {
    textTransform: "none",
    fontSize: "11.5px",
    fontWeight: 500,
    // Labels never wrap onto two lines — the search box gives way instead.
    whiteSpace: "nowrap",
    flexShrink: 0,
    color: "#334155",
    bgcolor: "#ffffff",
    borderColor: "#e2e8f0",
    borderRadius: "8px",
    minWidth: 0,
    px: 1.25,
    "& .MuiButton-startIcon": { mr: 0.5 },
    "& .MuiSvgIcon-root": { fontSize: "15px !important" },
    "&:hover": { bgcolor: "#f8fafc", borderColor: "#cbd5e1" },
  };
  // Icon-only toolbar buttons (Columns, Table settings) — same pill, square.
  const toolbarIconBtnSx = {
    minWidth: 0,
    width: 32,
    px: 0,
    "& .MuiSvgIcon-root": { fontSize: "17px !important" },
  };
  const toolbarBtnActiveSx = {
    bgcolor: "#eef2ff",
    borderColor: "#c7d2fe",
    color: "#4338ca",
    "&:hover": { bgcolor: "#e0e7ff", borderColor: "#a5b4fc" },
  };

  const handleContextAddComment = useCallback(
    (doc) => {
      if (!doc) return;
      dispatch(
        sidebarSetValues({
          type: loanDrilldownSidebarTypes.FILE_PREVIEW,
          state: doc,
          params: { openComments: true },
        }),
      );
    },
    [dispatch],
  );

  const handleContextToggleHidden = useCallback(
    (doc) => {
      if (!doc?._id) return;
      const nextHidden = !isDocHidden(doc);
      updateLoanDocMetadataForContext({
        loanId: tableLoanId,
        data: [{ _id: doc._id, isHidden: nextHidden }],
        onSuccessFn: (data) => {
          dispatch(loanDrilldownSet(data));
        },
      });
    },
    [updateLoanDocMetadataForContext, tableLoanId, dispatch],
  );

  const handleContextPreview = useCallback((doc) => {
    if (!doc) return;
    // Always open the improved pop-out preview sidebar.
    setPreviewFile(doc);
  }, []);

  // Right-click "Create condition" opens the Add Condition sidebar pre-seeded
  // with this document attached + its group/type prefilled (the native AG Grid
  // menu can't host the inline quick-condition popover, so it goes straight to
  // the full form).
  const { openForDocument: openConditionForDocument } =
    useCreateConditionFromDocument();

  const getContextMenuItems = useCallback(
    (params) => {
      // Group rows / no-data rows: defer to AG Grid's default menu so the
      // user still gets copy/paste/export. Returning undefined falls back.
      const doc = params?.node?.data;
      if (!doc) return params?.defaultItems;
      const hidden = isDocHidden(doc);
      return [
        {
          name: "Edit Details",
          icon: iconHtml(EditOutlined),
          action: () => setContextEditDetailsDoc(doc),
        },
        {
          name: "Preview File",
          icon: iconHtml(VisibilityOutlined),
          action: () => handleContextPreview(doc),
        },
        {
          name: "Create Condition from Document",
          icon: iconHtml(PlaylistAddCheckOutlined),
          action: () => openConditionForDocument(doc),
        },
        "separator",
        {
          name: "Download File",
          icon: iconHtml(DownloadOutlined),
          action: () => handleContextDownload(doc),
        },
        {
          name: "Open File in New Tab",
          icon: iconHtml(OpenInNewOutlined),
          action: () => handleContextOpenInNewTab(doc),
        },
        "separator",
        {
          name: "Add Comment",
          icon: iconHtml(ModeCommentOutlined),
          action: () => handleContextAddComment(doc),
        },
        {
          name:
            doc?.reportEffectiveDate || doc?.reportGuidelineExpirationDays
              ? "Edit Validity/Expiration Duration"
              : "Set Validity/Expiration Duration",
          icon: iconHtml(EventOutlined),
          action: () => setContextValidityDoc(doc),
        },
        "separator",
        {
          name: hidden ? "Unhide File" : "Hide File",
          icon: iconHtml(hidden ? VisibilityOutlined : VisibilityOffOutlined),
          action: () => handleContextToggleHidden(doc),
        },

        "separator",
        // Surface AG Grid's defaults too (copy, export, etc.) so the
        // right-click menu is a strict superset of what users had before.
        ...(params?.defaultItems || []),
      ];
    },
    [
      handleContextPreview,
      handleContextDownload,
      handleContextOpenInNewTab,
      handleContextAddComment,
      handleContextToggleHidden,
      openConditionForDocument,
    ],
  );

  const onCellClicked = useCallback(
    (params) => {
      // Skip if the click came from the inline rename UI (pencil button,
      // text field, or save/cancel buttons). React's stopPropagation on
      // those handlers can't reach AG Grid's native cell listener in time,
      // so we have to detect via target.closest on the native event.
      const target = params?.event?.target;
      if (
        target &&
        typeof target.closest === "function" &&
        target.closest('[data-rename-ui="true"]')
      ) {
        return;
      }

      // Group rows: handled by the inner renderer's onClick
      // (handleToggleRow). Don't toggle here too — AG Grid's native cell
      // click and React's onClick both fired previously, double-toggling
      // and netting to no-op (which is why a single click felt like a
      // dead click and users had to double-click).
      const doc = params.data;
      if (!doc) return;
      const colId = params?.colDef?.colId || params?.colDef?.field;

      // Filename click → preview the file. By default the click routes
      // through the LoanDrilldownScreen sidebar
      // (DrilldownFilePreviewSidebar). When the user has opted into modal
      // previews, the inline LoanFilePreviewModal popup is shown instead.
      if (colId === "file_display_name") {
        // Caller override (the Parsed view opens the extract viewer), else
        // the improved pop-out preview sidebar.
        if (onOpenFile) onOpenFile(doc);
        else setPreviewFile(doc);
        return;
      }

      // Status / docType / Associations cells handle their own click
      // (inline edit popover / picker / editor) — bail so the row
      // click doesn't double-trigger.
      if (
        colId === "documentStatus" ||
        colId === "docType" ||
        colId === "associations"
      ) {
        return;
      }

      // Any other cell → forward to the optional row-click handler.
      onRowClicked?.(doc);
    },
    [onRowClicked, onOpenFile, setPreviewFile],
  );

  // ── Currently-previewed file id ─────────────────────────────────────
  // The preview can be open in either of two surfaces and the table
  // should highlight the active row regardless of which is active:
  //   - File preview sidebar: redux `filePreview` slice (`data`), now mounted
  //     at the screen level so it persists across tabs
  //   - Comment sidebar: redux `sidebar` slice — type=FILE_PREVIEW, state=doc
  // A single `previewedDocId` is consumed by getRowClass below.
  const filePreviewDocId = useSelector((s) => s.filePreview?.data?._id || null);
  const sidebarPreviewedDocId = useSelector((s) => {
    const sb = s.sidebar;
    if (
      sb?.open &&
      sb?.type === loanDrilldownSidebarTypes.FILE_PREVIEW &&
      sb?.state?._id
    ) {
      return sb.state._id;
    }
    return null;
  });
  const previewedDocId = filePreviewDocId || sidebarPreviewedDocId || null;

  // CSS class for leaf rows under a grouped layout — used by the sx rule on
  // the Box wrapping AgGridReact to indent the first cell of each leaf row,
  // making files visually nest under their parent group(s).
  const getRowClass = useCallback(
    (params) => {
      // `dmt-tree-N` = how many ancestor guide lines this row draws.
      if (params.node?.group) {
        return `dmt-tree-${Math.min(params.node.level || 0, 3)}`;
      }
      const classes = [];
      const depth = layoutFields.length;
      if (depth > 0) classes.push(`dmt-leaf-indent-${Math.min(depth, 2)}`);
      if (depth > 0) classes.push(`dmt-tree-${Math.min(depth, 3)}`);
      // Highlight the row whose doc is currently open in the preview
      // (sidebar OR modal). Combines with the existing indent class.
      if (previewedDocId && params.data?._id === previewedDocId) {
        classes.push("dmt-row-previewed");
      }
      return classes.length ? classes.join(" ") : undefined;
    },
    [layoutFields, previewedDocId],
  );

  // AG Grid's `getRowClass` only *adds* classes — it doesn't remove a class
  // it previously assigned when the next evaluation returns undefined. With
  // row reuse keyed by `_id` (`getRowId`), going from a grouped layout back
  // to "All Files" leaves the prior `dmt-leaf-indent-1` class on each leaf
  // row, which zeros the cell's paddingLeft via the sx rule even though the
  // inner Box no longer adds any indent. Force a redraw on layout change so
  // classes get rebuilt from scratch.
  //
  // ALSO force the pinned bulk-select column to its layout-driven width. AG Grid
  // keeps an existing column's runtime width across columnDefs changes, so the
  // new width in columnDefs is ignored on a group toggle — leaving the column
  // stale-sized while the cellStyle padding grows, which clips the indented
  // checkbox (it vanished on toggle, only reappearing after a full refresh) and
  // left the widened column back in table view. Setting it explicitly fixes both.
  const layoutDepthRef = useRef(layoutFields.length);
  layoutDepthRef.current = layoutFields.length;
  const enforceBulkSelectWidth = useCallback(() => {
    const api = gridRef.current?.api;
    if (!api) return;
    api.setColumnWidths?.([
      {
        key: `__bulk_select_d${layoutDepthRef.current}`,
        newWidth: bulkSelectColumnWidth(layoutDepthRef.current),
      },
    ]);
  }, []);
  useEffect(() => {
    const api = gridRef.current?.api;
    if (!api) return undefined;
    enforceBulkSelectWidth();
    api.redrawRows();
    // AG Grid applies the rebuilt columnDefs after this effect, and keeps the
    // column's old runtime width when it does — so set it once more on the
    // next frame (ungrouping otherwise left the wide grouped column behind).
    const raf = requestAnimationFrame(enforceBulkSelectWidth);
    return () => cancelAnimationFrame(raf);
  }, [layoutMode, layoutFields, enforceBulkSelectWidth]);

  // ── Currently-previewed file id ─────────────────────────────────────
  // The preview can be open in either of two surfaces and the table
  // should highlight the active row regardless of which is active:
  // Moved above getRowClass so its closure can read it.
  const baseRowStyle = useCallback((params) => {
    if (params.node?.group) {
      // Nested docType under docGroup gets a slightly subdued treatment so
      // the visual hierarchy (docGroup > docType) is obvious. Font sizing
      // / weight is driven by the inner renderer below; this just controls
      // the row container. Re-enable alongside background/boxShadow below.
      // const isNestedDocType =
      //   params.node.field === "docType" &&
      //   params.node.parent?.field === "docGroup";
      return {
        // color: "red",
        color: "#1A1A19",
        cursor: "pointer",
        // Background + boxShadow temporarily disabled — keeping the
        // values around (commented) so we can flip back if the flat
        // look doesn't read well.
        // background: isNestedDocType ? "#fbfcfd" : "#f8fafc",
        // background: isNestedDocType ? "#eef2f600" : "#eef2f6",
        // boxShadow: "inset 0px 1px 0 #d8d4ca7e",
        // boxShadow: isNestedDocType
        //   ? "inset 0px -2px 0 #eef2f6"
        //   : // ? "inset 0px -2px 0 #eef2f6"
        //     "none",
        // "inset 0px 4px 0 #eef2f6",
        // : "inset 0px 4px 0 #d8d4ca7e",
        // borderLeft: isNestedDocType
        //   ? `2px solid #f1f5f9`
        //   : `3px solid #f1f5f9`,
        // marginTop: isNestedDocType ? "0px" : "24px",
        // borderTop: isNestedDocType
        //   ? `4px solid #f1f5f9`
        //   : `12px solid #f1f5f9`,

        // borderTopRightRadius: isNestedDocType ? "0px" : "12px",
        // borderTopLeftRadius: isNestedDocType ? "0px" : "12px",
        // borderLeft: isNestedDocType
        //   ? `2px solid #f1f5f9`
        //   : `3px solid #e2e8f0`,
      };
    }
    if (isDocHidden(params.data)) {
      // Soft amber tint indicates the file is marked hidden. Paired
      // with the eye-off badge in FilenameCell so the state reads at a
      // glance without the (default-hidden) Is Hidden column.
      return {
        // backgroundColor (not the shorthand) so the tree lines / category
        // rule, drawn as background images, survive on hidden rows.
        backgroundColor: "#fff05035",
        boxShadow: "inset 2px 0 0 #ca8a04",
      };
    }
    return undefined;
  }, []);

  // When rows are grouped by category, every row inside a category (its
  // header, any nested type headers, its files) carries that category's
  // colour as --dmt-group-color — the sx below tints that category's guide
  // line with it.
  const getRowStyle = useCallback(
    (params) => {
      const base = baseRowStyle(params);
      if (!layoutFields.includes("docGroup")) return base;
      const node = params.node;
      let docGroup;
      if (node?.group) {
        let n = node;
        while (n && n.field !== "docGroup") n = n.parent;
        if (!n) return base;
        docGroup = n.key;
      } else {
        docGroup = params.data?.docGroup;
      }
      return {
        ...(base || {}),
        "--dmt-group-color": getDocGroupColor(docGroup),
      };
    },
    [baseRowStyle, layoutFields],
  );

  // Force a redraw whenever the previewed doc changes so the
  // active-row highlight (added in the wrapper Box's sx below) lands
  // on the right row without waiting for the next user action.
  useEffect(() => {
    gridRef.current?.api?.redrawRows();
  }, [previewedDocId]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // fillHeight mode pins a definite height so the grid has a
        // bounded scroll region to virtualize inside. Otherwise the
        // table grows with its content (`domLayout="autoHeight"`) and
        // `minHeight` is just a floor.
        ...(fillHeight ? { height: minHeight } : { minHeight }),
        // No outer frame and no radius: the table runs full-bleed into the
        // section above it, which supplies the only rule between them. The
        // header row and body dividers below carry all the internal structure.
        // `overflow: clip` (not `hidden`) — both clip to the border-radius,
        // but `hidden` establishes a scroll container, which traps the
        // sticky toolbar + .ag-header inside this Box and prevents them
        // from sticking to the page viewport. `clip` clips without
        // creating a scroll container, so sticky descendants resolve up to
        // the page-level scroll.
        overflow: "clip",
        // bgcolor: "#fff",
        minWidth: 0,
      }}
    >
      {/* Toolbar — sticky to the top of the table's scroll container so
            the search and Columns button stay visible while the user
            scrolls through long doc lists. The white background covers
            the table rows that pass behind it during scroll. We use Box
            (instead of Flx) here so a ref can be attached to measure the
            toolbar height and stick the AG Grid header just beneath it. */}
      <Box
        ref={toolbarRef}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          // px: 1.25,
          // py: 1.25,
          ...(typeof toolbarPadding === "object"
            ? toolbarPadding
            : { p: toolbarPadding }),
          // p: 1.5,
          borderBottom: HEADER_BAND_RULE,
          position: "sticky",
          // Below the drilldown's pinned tab nav (see LoanDrilldownScreen
          // NavigationBar) by default; 0px when there is no nav above us.
          top: stickyTop,
          zIndex: 4,
          // borderTopLeftRadius: "24px",
          // borderTopRightRadius: "24px",
          // bgcolor: "#fafafb",
          bgcolor: "#fff",
        }}
      >
        {/* Search shrinks (down to 160px) before the toolbar buttons wrap. */}
        <Box sx={{ position: "relative", flex: "0 1 320px", minWidth: 160 }}>
          <SearchInput
            value={search}
            onChange={setSearch}
            placeholder={`Search ${(displayedRowData || []).length} files...`}
            sx={{
              background: "#ffffff",
              width: "100%",
              maxWidth: "100%",
            }}
          />
        </Box>
        {/* Grouping toggles — two independent on/off switches to the right of
            the search. Neither = flat Table View; Categories = group by
            docGroup; Types = group by docType; both = nested Category & Type
            (same as the old combined layout). */}
        {showGroupToggles && (
          <GroupByChips
            sx={{ ml: 1 }}
            groupByStatus={groupByStatus}
            groupByCategory={groupByCategory}
            groupByType={groupByType}
            onToggleStatus={onToggleGroupStatus}
            onToggleCategory={onToggleGroupCategory}
            onToggleType={onToggleGroupType}
          />
        )}
        {/* Sort moved to the right toolbar (next to Select Multiple). */}
        {layoutFields.length > 0 && (
          <Flx ac sx={{ ml: 1.5, pl: 1.5, borderLeft: "1px solid #eeeeee" }}>
            {/* Expand / Collapse every group — two separate buttons. */}
            <Flx ac g={1}>
              <Tooltip title="Expand all groups" arrow placement="top">
                <Button
                  size="small"
                  variant="outlined"
                  sx={toolbarBtnSx}
                  onClick={() => gridRef.current?.api?.expandAll()}
                  startIcon={<UnfoldMoreOutlined />}
                >
                  Expand
                </Button>
              </Tooltip>
              <Tooltip title="Collapse all groups" arrow placement="top">
                <Button
                  size="small"
                  variant="outlined"
                  sx={toolbarBtnSx}
                  onClick={() => gridRef.current?.api?.collapseAll()}
                  startIcon={<UnfoldLessOutlined />}
                >
                  Collapse
                </Button>
              </Tooltip>
            </Flx>
          </Flx>
        )}
        <Box
          sx={{ flex: 1, ".MuiSvgIcon-root": { fontSize: "14px !important" } }}
        />
        {/* Reset to default — only when the user has a saved, non-default
            layout (column order / visibility / width, a custom sort or a
            grouping). Sits left of Sort, behind a divider. */}
        {hasSavedTableState && (
          <>
            <Tooltip
              title="Reset column layout, sort and grouping to default"
              placement="top"
            >
              <Button
                size="small"
                variant="outlined"
                sx={toolbarBtnSx}
                startIcon={<RestartAltOutlined />}
                onClick={handleResetTableDefaults}
              >
                Reset
              </Button>
            </Tooltip>
            <Divider orientation="vertical" flexItem sx={{ my: 0.75 }} />
          </>
        )}
        {/* Sort — right toolbar button matching Columns / Settings. Shows the
            active preset, or "Custom" after a column-header sort. */}
        <Tooltip title="Sort documents" placement="top">
          <Button
            size="small"
            variant="outlined"
            sx={{
              ...toolbarBtnSx,
              ...(sortMenuAnchor ? toolbarBtnActiveSx : {}),
            }}
            startIcon={<SortRounded />}
            onClick={(e) => setSortMenuAnchor(e.currentTarget)}
          >
            <span style={{ fontWeight: 400, paddingRight: 4, opacity: 0.55 }}>
              Sort:
            </span>{" "}
            {currentSortLabel || "Sort"}
          </Button>
        </Tooltip>
        <Menu
          anchorEl={sortMenuAnchor}
          open={Boolean(sortMenuAnchor)}
          onClose={() => setSortMenuAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          slotProps={STYLED_MENU_PAPER_SLOT_PROPS()}
        >
          <Box sx={STYLED_MENU_HEADER_SX}>
            <Txt sx={STYLED_MENU_HEADER_TXT_SX}>Sort by</Txt>
          </Box>
          {sortOptions.map((o) => (
            <MenuItem
              key={o.label}
              selected={currentSortLabel === o.label}
              onClick={() => {
                handleSortFilterChange(o.value);
                setSortMenuAnchor(null);
              }}
              sx={STYLED_MENU_ITEM_SX}
            >
              {o.icon && (
                <ListItemIcon sx={{ minWidth: 30 }}>{o.icon}</ListItemIcon>
              )}
              {o.label}
            </MenuItem>
          ))}
          <Divider sx={{ my: 0.5 }} />
          <MenuItem
            onClick={() => {
              handleSortFilterChange({ state: [] });
              setSortMenuAnchor(null);
            }}
            sx={STYLED_MENU_ITEM_SX}
          >
            Clear sort
          </MenuItem>
        </Menu>
        <Tooltip
          title={columnsPanelOpen ? "Hide columns panel" : "Edit columns"}
          placement="top"
        >
          <Button
            size="small"
            variant="outlined"
            aria-label={
              columnsPanelOpen ? "Hide columns panel" : "Edit columns"
            }
            sx={{
              ...toolbarBtnSx,
              ...toolbarIconBtnSx,
              ...(columnsPanelOpen ? toolbarBtnActiveSx : {}),
            }}
            onClick={handleToggleColumnsPanel}
          >
            <ViewColumnOutlined />
          </Button>
        </Tooltip>
        {enableUserSettings && (
          <>
            <Tooltip title="Table settings" placement="top">
              <Button
                size="small"
                variant="outlined"
                aria-label="Table settings"
                aria-haspopup="true"
                aria-expanded={Boolean(settingsAnchor)}
                sx={{
                  ...toolbarBtnSx,
                  ...toolbarIconBtnSx,
                  ...(settingsAnchor ? toolbarBtnActiveSx : {}),
                }}
                onClick={(e) => setSettingsAnchor(e.currentTarget)}
              >
                <TuneRounded />
              </Button>
            </Tooltip>
            <TableSettingsPopover
              anchorEl={settingsAnchor}
              onClose={() => setSettingsAnchor(null)}
              compactRows={compactRows}
              showCategoryIcons={!hideGroupIcons}
              showGroupPanel={showGroupPanel}
              canGroup={showGroupToggles}
              onToggle={handleToggleTableSetting}
            />
            <Divider orientation="vertical" flexItem sx={{ my: 0.75 }} />
          </>
        )}
        {/* Share packages — build the flag-filtered zip for each
            selector. Only mounts when the table is bound to a loan
            (the manager table is also used in loan-less contexts).
            Temporarily hidden via SHOW_PACKAGES_BUTTON. */}
        {SHOW_PACKAGES_BUTTON && !!tableLoanId && (
          <>
            <Tooltip
              title={
                activePackageFlag
                  ? `Table filtered to the ${activePackageFlag.packageLabel} package`
                  : "Build a third-party / counterparty package"
              }
              placement="top"
            >
              <Button
                size="small"
                variant="outlined"
                sx={{
                  ...toolbarBtnSx,
                  ...(packageMenuAnchor || activePackageFlag
                    ? toolbarBtnActiveSx
                    : {}),
                }}
                startIcon={<Inventory2Outlined />}
                onClick={(e) => setPackageMenuAnchor(e.currentTarget)}
              >
                Packages
                {/* Applied-filter badge: which package the table is narrowed
                    to, with an × that clears it without opening the menu. */}
                {activePackageFlag && (
                  <Box
                    component="span"
                    sx={{
                      ml: 0.75,
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.25,
                      fontSize: 10.5,
                      fontWeight: 600,
                      color: teal[700],
                      background: teal[50],
                      border: `1px solid ${teal[200]}`,
                      borderRadius: "10px",
                      pl: 0.75,
                      pr: 0.25,
                      lineHeight: 1.5,
                    }}
                  >
                    {activePackageFlag.packageLabel}
                    <CloseRounded
                      role="button"
                      aria-label="Clear package filter"
                      onClick={(e) => {
                        e.stopPropagation();
                        setPackageFilter(null);
                      }}
                      sx={{
                        fontSize: "12px !important",
                        borderRadius: "50%",
                        cursor: "pointer",
                        "&:hover": { background: teal[100] },
                      }}
                    />
                  </Box>
                )}
              </Button>
            </Tooltip>
            <SharePackagesPopover
              anchorEl={packageMenuAnchor}
              onClose={() => setPackageMenuAnchor(null)}
              docs={packageSourceDocs}
              users={tableUsers}
              busySelector={packageBusySelector}
              busyAction={packageBusyAction}
              onDownload={handleDownloadPackage}
              onStage={handleStagePackage}
              activeFilter={packageFilter}
              onToggleFilter={(field) => {
                setPackageFilter((cur) => (cur === field ? null : field));
                setPackageMenuAnchor(null);
              }}
            />
          </>
        )}
        {/* Download All — whole-loan zip. Sits to the left of the settings gear.
            Only on the main Documents tab, where the table shows the full loan
            (enableUserSettings). */}
        {enableUserSettings && (
          <Tooltip title="Download all loan documents (.zip)" placement="top">
            <span>
              <Button
                size="small"
                variant="outlined"
                sx={toolbarBtnSx}
                startIcon={
                  downloadingAll ? (
                    <CircularProgress size={14} color="inherit" />
                  ) : (
                    <DownloadOutlined />
                  )
                }
                onClick={handleDownloadAll}
                disabled={downloadingAll}
              >
                {downloadingAll ? "Preparing…" : "Download"}
              </Button>
            </span>
          </Tooltip>
        )}
      </Box>

      <Box
        ref={gridContainerRef}
        sx={{
          flex: 1,
          minWidth: 0,
          // fillHeight mode: this Box is the bounded flex child the grid
          // scrolls inside. `minHeight: 0` lets it shrink below its
          // content height so AG Grid's own viewport scrolls (and
          // virtualizes rows) instead of the whole page.
          ...(fillHeight && { minHeight: 0 }),
          // When grouped, keep the pinned checkbox's left gutter but flush the
          // FILENAME cell to the left (no group indent) so the file's actions
          // sit right up against the checkbox column.
          "& .ag-row.dmt-leaf-indent-1 .ag-cell[col-id='file_display_name'], & .ag-row.dmt-leaf-indent-2 .ag-cell[col-id='file_display_name']":
            {
              paddingLeft: "0 !important",
            },
          ".ag-group-value": {
            width: "100%",
            overflow: "visible",
          },
          // Drop AG Grid's pinned-column border so the checkbox column has no
          // right separator against the filename cell.
          "--ag-pinned-column-border": "none",
          // Documents tab: the grid always reaches at least the bottom of the
          // screen (and never less than DOCUMENTS_TABLE_MIN_HEIGHT), so a
          // short list — e.g. collapsed groups — still gives the Columns panel
          // room instead of clipping it.
          ...(enableUserSettings &&
            !fillHeight && {
              "& .ag-root-wrapper, & .ag-root-wrapper-body": {
                minHeight: `${gridFillMinHeight}px !important`,
              },
            }),
          // Grouped tree chrome: a guide line under each ancestor group's
          // chevron (the category's one lightly tinted in its colour). Drawn
          // on the full-width group rows and on the pinned (checkbox) part of
          // each file row, so both line up from the grid's left edge.
          ...Object.fromEntries(
            [1, 2, 3].map((n) => [
              `& .ag-full-width-container .ag-row.dmt-tree-${n}, & .ag-pinned-left-cols-container .ag-row.dmt-tree-${n}`,
              {
                backgroundImage: treeRowBackground(
                  n,
                  layoutFields.indexOf("docGroup"),
                ),
              },
            ]),
          ),
          // Keep group-row indent steps equal to the checkbox indent math.
          "--ag-row-group-indent-size": `${GROUP_INDENT_PX}px`,
          // The status fill runs the full width of its cell (the renderer's
          // wrapper would otherwise shrink to the label).
          // …and its full height too, so the status colour fills the whole cell
          // (in compact rows the wrapper otherwise sizes to the one-line label).
          "& .ag-cell[col-id='documentStatus'] > *, & .ag-cell[col-id='documentStatus'] .ag-cell-value, & .ag-cell[col-id='documentStatus'] .ag-cell-wrapper":
            {
              flex: "1 1 auto",
              width: "100%",
              height: "100%",
              alignSelf: "stretch",
              minWidth: 0,
            },
          "& .ag-cell[col-id='documentStatus']": {
            alignItems: "stretch !important",
            lineHeight: "normal",
          },
          // Compact rows: tighter cell padding to go with the 32px rows.
          ...(compactRows && {
            "--ag-cell-horizontal-padding": "8px",
            "& .ag-cell": { lineHeight: "16px" },
          }),
          // ── Table chrome ───────────────────────────────────────────────
          // Body row dividers are DELIBERATELY softer than the outer frame:
          // the frame defines the table's edge, the internal rules only need
          // to keep long rows trackable. Matching them would read as a grid.
          "--ag-row-border-color": "#f0f1f3",
          "& .ag-row": { borderBottomColor: "#f0f1f3" },
          // Header row: its own fill, a single rule beneath it (the frame
          // colour, since this IS a structural edge), and a heavier, slightly
          // tighter label than the 11px body cells.
          // NOTE: this is the ONLY "& .ag-header" key in this object. sx is a
          // plain object — a second one further down would not merge with this,
          // it would REPLACE it. (It did: the autoHeight sticky block below used
          // to declare its own, which silently dropped this background + rule on
          // every consumer that scrolls the page instead of the grid.)
          "& .ag-header": {
            background: "#f9fafb",
            borderBottom: `${HEADER_BAND_RULE} !important`,
            // autoHeight mode only: the page (not the grid) scrolls, so the
            // column header is pinned below the sticky toolbar. In fillHeight
            // mode the grid scrolls internally and AG Grid's native sticky
            // header handles it.
            ...(!fillHeight && {
              position: "sticky",
              top: `calc(${stickyTop} + ${toolbarHeight}px)`,
              zIndex: 3,
            }),
          },
          "& .ag-header-row": { background: "transparent" },
          "& .ag-header-cell": {
            fontSize: "12.5px",
            fontWeight: 600,
            letterSpacing: "0.01em",
            color: "#374151",
          },
          "& .ag-header-cell .ag-header-cell-text": { color: "inherit" },
          // The two states a header can be "engaged" in — pointed at, or
          // actually driving the sort — read the same: one step darker.
          "& .ag-header-cell:hover, & .ag-header-cell.ag-header-cell-sorted-asc, & .ag-header-cell.ag-header-cell-sorted-desc":
            {
              color: "#1f2937",
            },
          // Sort arrow stays a quiet grey while it's just an affordance, and
          // only takes the action colour once it's the live sort.
          "& .ag-header-cell .ag-sort-indicator-icon, & .ag-header-cell .ag-icon":
            {
              color: "#9ca3af",
            },
          "& .ag-header-cell.ag-header-cell-sorted-asc .ag-sort-indicator-icon, & .ag-header-cell.ag-header-cell-sorted-desc .ag-sort-indicator-icon, & .ag-header-cell.ag-header-cell-sorted-asc .ag-icon, & .ag-header-cell.ag-header-cell-sorted-desc .ag-icon":
            {
              color: teal[600],
            },
          // Row action icons sit at 72% until the pointer is on the row. The
          // reveal has to live here rather than on the cell — only the grid
          // knows what "this row is hovered" means.
          "& .ag-row:hover .dmt-fname-actions .MuiButtonBase-root": {
            opacity: 1,
          },
          "& .ag-cell.ag-cell-last-left-pinned, & .ag-header-cell.ag-header-cell-last-left-pinned":
            {
              borderRight: "none !important",
            },
          // Active-preview row highlight — tinted background + a bold
          // left-edge stripe so the user can tell at a glance which row
          // the open preview corresponds to. The `!important` on the
          // background beats AG Grid's own row-state styles (selected /
          // hover) without disabling them entirely.
          "& .ag-row.dmt-row-previewed": {
            background: "#dbeafe !important",
            boxShadow: `inset 3px 0 0 ${level1.indicator}`,
          },
          // Bulk-select HEADER — small left gutter for the select-all checkbox
          // (no right border / column separator).
          // (BulkSelectHeader sets its own left gutter.)
          "& .ag-header-cell.dmt-bulk-select-header": {
            paddingLeft: "0 !important",
            paddingRight: "0 !important",
            overflow: "visible",
          },
          // Grouped, that header also carries the "Filename" label, which can
          // be wider than the checkbox column — let it run on over the
          // Filename column's (empty) header instead of being cut off.
          "& .ag-pinned-left-header, & .ag-pinned-left-header .ag-header-row, & .ag-header-cell.dmt-bulk-select-header .ag-header-cell-comp-wrapper, & .ag-header-cell.dmt-bulk-select-header .ag-cell-label-container, & .ag-header-cell.dmt-bulk-select-header .ag-header-cell-label, & .ag-header-cell.dmt-bulk-select-header .ag-header-cell-text":
            {
              overflow: "visible !important",
              textOverflow: "clip !important",
            },
          "& .ag-pinned-left-header": { position: "relative", zIndex: 2 },
          // Bulk-select CELLS — zero the right padding here; the LEFT padding
          // is set by the column's `cellStyle` so a grouped leaf's checkbox
          // indents to sit under its parent group's checkbox. Let the checkbox
          // overflow the (indented) content box instead of being clipped — the
          // column is widened to hold it, so nothing spills into other columns.
          "& .ag-cell.dmt-bulk-select-cell, & .ag-cell.dmt-bulk-select-cell .ag-cell-wrapper":
            {
              paddingRight: "0 !important",
              overflow: "visible !important",
            },
          "& .ag-header-cell.dmt-bulk-select-header .ag-header-cell-comp-wrapper, & .ag-header-cell.dmt-bulk-select-header .ag-header-select-all":
            {
              display: "flex",
              justifyContent: "flex-start",
              width: "100%",
              margin: 0,
            },
          // autoHeight mode only: the page (not the grid) scrolls, so AG Grid's
          // default `overflow: hidden` on `.ag-root-wrapper` / `.ag-root` has to
          // be defeated for the sticky header above to resolve up to the page
          // viewport. In fillHeight mode the grid scrolls internally and AG
          // Grid's native sticky header handles this — applying these overrides
          // there would break the internal scroll container, so they're gated off.
          ...(!fillHeight && {
            "& .ag-root-wrapper, & .ag-root, & .ag-root-wrapper-body": {
              overflow: "visible !important",
            },
          }),
          ...gridSx,
        }}
      >
        {/* Multi-select bar — floats at the bottom of the viewport while ≥1
            file is checked, so the toolbar above (search, group by) never
            moves. Status / Type / Link / Validity / Edit all / Download /
            More live there; see BulkSelectionBar. */}
        {bulkSelectMode && (
          <BulkSelectionBar
            loan={tableLoan}
            loanId={tableLoanId}
            docs={freshSelectedDocs}
            shownCount={displayedRowData.length}
            onSelectAllShown={handleBulkSelectAll}
            onClearSelection={handleBulkClearSelection}
            showSelectedOnly={showSelectedOnly}
            onToggleShowSelectedOnly={setShowSelectedOnly}
            onDownload={handleBulkDownload}
            downloading={bulkDownloading}
            maxDownload={MAX_BULK_DOWNLOAD}
            onExtract={() => setConfirmAction("extract")}
            onSendToOcrolus={(eligible) => {
              setOcrolusDocs(eligible);
              setConfirmAction("ocrolus");
            }}
          />
        )}

        {/* Confirmation for the external / batch actions (Extract data, Send
            to Ocrolus). */}
        <Dialog
          open={!!confirmAction}
          onClose={() => setConfirmAction(null)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ fontSize: 16, fontWeight: 600 }}>
            {confirmAction === "ocrolus" ? "Send to Ocrolus?" : "Extract data?"}
          </DialogTitle>
          <DialogContent>
            <Txt sx={{ fontSize: 13.5, color: "#475569", lineHeight: 1.55 }}>
              {confirmAction === "ocrolus"
                ? `Send ${ocrolusDocs.length} bank statement${
                    ocrolusDocs.length === 1 ? "" : "s"
                  } to Ocrolus for analysis? This creates or updates the loan's Ocrolus book.`
                : `Queue ${selectedDocs.length} selected document${
                    selectedDocs.length === 1 ? "" : "s"
                  } for data extraction? Results will appear in the Parsed / Extracted tab.`}
            </Txt>
            {confirmAction === "ocrolus" &&
              ocrolusDocs.length < selectedDocs.length && (
                <Box
                  sx={{
                    mt: 2,
                    p: 1.5,
                    borderRadius: "8px",
                    bgcolor: colors.warningBg,
                    color: colors.warningFg,
                    fontSize: 12.5,
                    lineHeight: 1.5,
                  }}
                >
                  {OCROLUS_PDF_ONLY_MESSAGE} The other{" "}
                  {selectedDocs.length - ocrolusDocs.length} selected file
                  {selectedDocs.length - ocrolusDocs.length === 1
                    ? ""
                    : "s"}{" "}
                  will not be sent.
                </Box>
              )}
          </DialogContent>
          <Flx jc="flex-end" g={1} sx={{ px: 3, pb: 2.5, pt: 1 }}>
            <Button
              variant="text"
              color="gray"
              onClick={() => setConfirmAction(null)}
              sx={{ textTransform: "none" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                if (confirmAction === "ocrolus") handleSendToOcrolus();
                else handleBulkParseExtract();
                setConfirmAction(null);
              }}
              disabled={confirmAction === "ocrolus" && !ocrolusDocs.length}
              sx={{ textTransform: "none" }}
            >
              {confirmAction === "ocrolus" ? "Send to Ocrolus" : "Extract data"}
            </Button>
          </Flx>
        </Dialog>

        <AgGridTableWrapper
          compactTable
          // suppressMinHeightWhenPopulated={displayedRowData}
          noBorder
          noBorderRadius
          fullHeight={fillHeight}
          // Base cell font: 11px everywhere. The MuiTypography rule is needed
          // because MUI Txt renders a <p> with its own body1 font-size that
          // wouldn't inherit the .ag-cell size otherwise.
          sx={{
            ".ag-cell": { fontSize: "11px" },
            ".ag-cell .MuiTypography-root": { fontSize: "11px" },
          }}
        >
          <AgGridReact
            ref={gridRef}
            rowData={displayedRowData}
            columnDefs={columnDefs}
            // Multi-row selection is only meaningful while the
            // "Select Multiple" toggle is on — gate both the row mode and
            // the change listener so they have no effect otherwise.
            rowSelection={bulkSelectMode ? "multiple" : undefined}
            suppressRowClickSelection={true}
            onSelectionChanged={
              bulkSelectMode ? handleBulkSelectionChanged : undefined
            }
            columnTypes={columnTypes}
            defaultColDef={defaultColDef}
            getRowId={getRowId}
            onCellClicked={onCellClicked}
            getRowStyle={getRowStyle}
            getRowClass={getRowClass}
            tooltipMouseTrack={false}
            getRowHeight={getRowHeight}
            quickFilterText={search}
            // fillHeight (Documents tab) → `normal`: the grid fills its
            // bounded container and only renders the ~visible rows. Other
            // consumers stay on `autoHeight`, where the grid grows to fit
            // its content (and renders every row — fine for the small,
            // scoped doc subsets they show).
            domLayout={fillHeight ? "normal" : "autoHeight"}
            // Skip AG Grid's default row-animation on grouping / sorting /
            // filtering changes — without animation the layout switcher
            // and quick filter feel snappier and don't jitter under
            // autoHeight (where each row's transition repeatedly resizes
            // the page).
            animateRows={false}
            // Shared values for the inline-edit cell renderers (status /
            // docType / associations) — read off `params.context` so the
            // cells don't each open their own Redux subscription, and so
            // these values don't sit in `columnDefs` (which would force a
            // full column reconcile whenever the loan changes).
            context={gridContext}
            // tooltipShowDelay={1100}
            tooltipShowDelay={100}
            enableCellTextSelection
            suppressCellFocus
            // Pagination kicks in only when the loan has more than 100
            // documents. With row virtualization the rendered-row count
            // is already bounded; pagination on top keeps the grouped
            // tree from getting unwieldy to scroll on very large loans.
            pagination={paginationEnabled}
            rowGroupPanelShow={showGroupPanel ? "always" : "never"}
            onColumnRowGroupChanged={handleColumnRowGroupChanged}
            onNewColumnsLoaded={enforceBulkSelectWidth}
            paginationPageSize={PAGINATION_PAGE_SIZE}
            paginationPageSizeSelector={PAGINATION_PAGE_SIZE_OPTIONS}
            groupDisplayType="groupRows"
            // Category and type groups list A→Z unless the user sorts the
            // grouped column itself; status groups follow the status dropdown.
            initialGroupOrderComparator={groupOrderComparator}
            groupRowRendererParams={groupRowRendererParams}
            // When user settings are enabled (Documents tab), the
            // setting maps to AG Grid's three-state expand model:
            //   "collapsed" → 0  (everything closed)
            //   "topLevel"  → 1  (only the outermost group expanded)
            //   "all"       → -1 (everything open)
            // For nested grouping (Category → Type), "topLevel"
            // expands Categories but keeps Types collapsed. For
            // single-axis grouping it just opens that one level.
            // Other consumers fall back to the `groupDefaultExpanded`
            // prop they passed in.
            //
            // Special case: Category & Type (docGroupAndType) auto-
            // expands docGroups but keeps docTypes collapsed — that's
            // the most useful default for scanning categories without
            // drowning in type-level rows. Toolbar Expand-All /
            // Collapse-All still work if the user wants a different view.
            groupDefaultExpanded={
              layoutMode === "docGroupAndType"
                ? 1
                : enableUserSettings
                  ? 1 // Documents tab: top level open, the rest closed
                  : groupDefaultExpanded
            }
            sideBar={sideBar}
            onGridReady={handleGridReady}
            onSortChanged={handleSortChanged}
            onColumnMoved={persistColumnState}
            onColumnVisible={persistColumnState}
            onColumnPinned={persistColumnState}
            onColumnResized={persistColumnState}
            // Right-click menu mirrors the filename cell's 3-dot file
            // actions menu so the same operations are reachable on any
            // cell in the row.
            getContextMenuItems={getContextMenuItems}
          />
        </AgGridTableWrapper>
      </Box>
      {/* The file preview sidebar is mounted once at the screen level
          (GlobalLoanFilePreviewSidebar, driven by the `filePreview` redux
          slice) so it persists across drilldown tabs and stays pinned right.
          Opening it from here is `setPreviewFile(doc)` →
          dispatch(filePreviewSetData(doc)). */}
      {/* Table-level Edit Details dialog driven by the right-click menu.
          The filename cell's 3-dot menu owns its own instance for the
          in-cell trigger; both eventually call the same backend save. */}
      <EditDocumentDetailsDialog
        open={!!contextEditDetailsDoc}
        file={contextEditDetailsDoc}
        loanId={tableLoanId}
        onClose={() => setContextEditDetailsDoc(null)}
        onSaved={() => setContextEditDetailsDoc(null)}
      />
      {/* Set / Edit Validity Period from the right-click menu. The 3-dot
          menu in the filename cell uses a Popover anchored to that
          button; the right-click path has no element to anchor to, so we
          render the same form as a Dialog at the table level. */}
      <ContextValidityPeriodDialog
        doc={contextValidityDoc}
        loanId={tableLoanId}
        onClose={() => setContextValidityDoc(null)}
      />
    </Box>
  );
};

// =================================================================
// STATUS STYLING (used by inspector status pill + popover)
// =================================================================

// Validity-period editor rendered as a Dialog at the table level — used
// by the right-click menu's Set/Edit Validity Period item. Mirrors the
// fields and save semantics of the Popover variant inside FilenameCell
// (which stays put for the in-cell 3-dot menu trigger that does have a
// natural anchor element).
//
// Declared above `LoanDocumentManagerTable` so the const binding is
// guaranteed to be initialized by the time the main component renders.
// (When it lived after the main component, HMR was occasionally racing
// on partial updates and throwing a ReferenceError on re-render.)
const ContextValidityPeriodDialog = ({ doc, loanId, onClose }) => {
  const dispatch = useDispatch();
  const { updateLoanDocMetadata } = useLoanFilesHook();
  const [formDate, setFormDate] = useState("");
  const [formDays, setFormDays] = useState("");
  const [saving, setSaving] = useState(false);
  const open = !!doc;

  // Seed the form from the doc's current values whenever the dialog
  // opens against a new doc. Without this the dialog would show stale
  // values from the previously-edited row.
  useEffect(() => {
    if (!doc) return;
    setFormDate(
      doc.reportEffectiveDate
        ? String(doc.reportEffectiveDate).slice(0, 10)
        : "",
    );
    setFormDays(
      doc.reportGuidelineExpirationDays != null
        ? String(doc.reportGuidelineExpirationDays)
        : "",
    );
  }, [doc]);

  if (!doc) return null;

  const handleSave = () => {
    if (!doc?._id) return;
    setSaving(true);
    const daysStr = (formDays ?? "").toString().trim();
    const daysNum = daysStr === "" ? null : Number(daysStr);
    updateLoanDocMetadata({
      loanId,
      data: [
        {
          _id: doc._id,
          reportEffectiveDate: formDate || null,
          reportGuidelineExpirationDays: Number.isFinite(daysNum)
            ? daysNum
            : null,
        },
      ],
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
        setSaving(false);
        onClose?.();
      },
      onFailFn: () => setSaving(false),
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      onClick={(e) => e.stopPropagation()}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          border: "1px solid",
          borderColor: "divider",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Txt sx={{ fontSize: "15px", fontWeight: 600 }}>Validity period</Txt>
        <Txt sx={{ fontSize: "12px", color: grey[600], display: "block" }}>
          {doc.file_display_name}
        </Txt>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2.5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >
          <Txt sx={{ fontSize: 11, color: grey[600], mb: -1 }}>
            Set how long this document is considered valid — the effective date
            plus the number of days it remains good for.
          </Txt>
          <Box>
            <Txt
              sx={{
                fontSize: 11,
                fontWeight: 600,
                color: grey[700],
                mb: 0.5,
                display: "block",
              }}
            >
              Effective date
            </Txt>
            <TextField
              type="date"
              size="small"
              fullWidth
              value={formDate}
              onChange={(e) => setFormDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
          <Box>
            <Txt
              sx={{
                fontSize: 11,
                fontWeight: 600,
                color: grey[700],
                mb: 0.5,
                display: "block",
              }}
            >
              Valid for (days)
            </Txt>
            <TextField
              type="number"
              size="small"
              fullWidth
              value={formDays}
              onChange={(e) => setFormDays(e.target.value)}
              inputProps={{ min: 0 }}
              placeholder="e.g. 90"
            />
          </Box>
          <Flx jb g={1} sx={{ pt: 1 }}>
            <Button
              size="small"
              variant="outlined"
              color="gray"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={handleSave}
              disabled={saving}
              startIcon={
                saving ? (
                  <CircularProgress size={12} sx={{ color: "inherit" }} />
                ) : null
              }
            >
              {saving ? "Saving..." : "Save"}
            </Button>
          </Flx>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

// Per-docGroup icons rendered next to the group label when the table is
// grouped by docGroup. Keys must match the docGroup strings from the
// backend (see fileDocGroupAndTypesFallback.js for the canonical list).
// Anything not in the map falls back to FolderOutlined.
const DOC_GROUP_ICONS = {
  Appraisal: AssessmentOutlined,
  "Borrower Documents": PersonOutline,
  "Closed Loan Package Scans": TaskAltOutlined,
  "Closing Package": HandshakeOutlined,
  "Construction Documents": ConstructionOutlined,
  "Entity Docs": ApartmentOutlined,
  "Exceptions & Approvals": WarningAmberOutlined,
  "Insurance Docs": ShieldOutlined,
  "Leases & Rents": ReceiptLongOutlined,
  "Letter of Explanation & Exceptions": EmailOutlined,
  Liquidity: PaidOutlined,
  Memos: StickyNote2Outlined,
  "Parsed Document Outputs": AutoAwesomeOutlined,
  "Property Documents": HouseOutlined,
  Questionnaires: QuizOutlined,
  "Terms & Sizer": CalculateOutlined,
  "Third Party Reports": GroupsOutlined,
  "Title Docs": GavelOutlined,
};

const getDocGroupIcon = (docGroup) =>
  DOC_GROUP_ICONS[docGroup] || FolderOutlined;

// Group row inner renderer — controls the label/count/affordances rendered
// inside the group row's chevron + indent shell that AG Grid provides.
//   - docGroup level (top): bold 14px label, plus right-aligned
//     "Expand all" / "Collapse all" buttons that toggle every child docType
//     group under it (only meaningful in the docGroupAndType layout).
//   - docType nested under docGroup: smaller 12.5px / weight-600 label, no
//     buttons. Indented further from the left for visual hierarchy.
// The toolbar's Table settings popover. Every option is a display preference
// stored in the table settings (localStorage, Documents tab only).
const TableSettingsPopover = ({
  anchorEl,
  onClose,
  compactRows,
  showCategoryIcons,
  showGroupPanel,
  canGroup,
  onToggle,
}) => (
  <Popover
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
    slotProps={{
      paper: {
        sx: {
          mt: "6px",
          width: 340,
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow:
            "0 12px 32px rgba(16,24,32,.16), 0 2px 6px rgba(16,24,32,.08)",
          py: 1,
        },
      },
    }}
  >
    <Txt
      component="div"
      sx={{ fontSize: 12.5, color: grey[500], px: 2, pt: 0.5, pb: 1 }}
    >
      Table settings
    </Txt>
    <Box sx={{ px: 2, pb: 1.25 }}>
      <Txt component="div" sx={{ fontSize: 13.5, fontWeight: 600, mb: 0.75 }}>
        Row density
      </Txt>
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        value={compactRows ? "compact" : "comfortable"}
        onChange={(_e, v) => {
          if (!v) return;
          if ((v === "compact") !== !!compactRows) onToggle("compactRows");
        }}
        sx={segmentedGroupSx()}
      >
        <ToggleButton value="comfortable">Comfortable</ToggleButton>
        <ToggleButton value="compact">Compact</ToggleButton>
      </ToggleButtonGroup>
      <Txt
        component="div"
        sx={{ fontSize: 12, color: grey[500], mt: 0.75, lineHeight: 1.45 }}
      >
        Compact keeps each row to one line. Hover a status or validity for
        details.
      </Txt>
    </Box>
    <Divider />
    <SettingSwitchRow
      checked={showCategoryIcons}
      onChange={() => onToggle("hideGroupIcons")}
      title="Show category icons"
      description="The icon next to each category name on grouped rows."
    />
    {canGroup && (
      <SettingSwitchRow
        checked={showGroupPanel}
        onChange={() => onToggle("showGroupPanel")}
        title="Show row-group bar"
        description="A bar above the table you can drag the Status, Category or Type column into to group by it."
      />
    )}
  </Popover>
);
TableSettingsPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  compactRows: PropTypes.bool,
  showCategoryIcons: PropTypes.bool,
  showGroupPanel: PropTypes.bool,
  canGroup: PropTypes.bool,
  onToggle: PropTypes.func,
};

// One on/off row in the Table settings popover.
const SettingSwitchRow = ({ checked, onChange, title, description }) => (
  <Box sx={{ px: 2, py: 1 }}>
    <FormControlLabel
      sx={{
        m: 0,
        alignItems: "flex-start",
        width: "100%",
        // Label fills the row so a short description doesn't push it
        // over against the switch.
        justifyContent: "space-between",
        "& .MuiFormControlLabel-label": { flex: 1 },
      }}
      control={
        <Switch
          size="small"
          checked={!!checked}
          onChange={onChange}
          sx={{ mt: "-2px" }}
        />
      }
      labelPlacement="start"
      label={
        <Box sx={{ flex: 1, pr: 1.5 }}>
          <Txt sx={{ fontSize: "13px", fontWeight: 500 }}>{title}</Txt>
          <Txt
            sx={{
              fontSize: "11px",
              color: grey[600],
              display: "block",
              mt: 0.25,
            }}
          >
            {description}
          </Txt>
        </Box>
      }
    />
  </Box>
);

export const GroupRowInnerRenderer = (params) => {
  const { node, value, api } = params || {};
  // Subscribe to AG Grid's expandedChanged event so the renderer re-renders
  // when the user toggles this group. Without this hook AG Grid would
  // rotate the chevron but our inner content (specifically the
  // Expand/Collapse-all buttons) would render against stale state.
  const [isExpanded, setIsExpanded] = useState(!!node?.expanded);
  useEffect(() => {
    if (!node) return undefined;
    const handler = () => setIsExpanded(!!node.expanded);
    node.addEventListener?.("expandedChanged", handler);
    return () => node.removeEventListener?.("expandedChanged", handler);
  }, [node]);
  // Re-render the group's select-all checkbox whenever the grid selection
  // changes (from a leaf checkbox, another group's toggle, or Clear/Select-all),
  // so its checked / indeterminate state always mirrors the rows underneath.
  const [, forceSelectionTick] = useState(0);
  useEffect(() => {
    if (!api) return undefined;
    const handler = () => forceSelectionTick((n) => n + 1);
    api.addEventListener?.("selectionChanged", handler);
    return () => api.removeEventListener?.("selectionChanged", handler);
  }, [api]);
  // Re-render when a child type row opens / closes, so the category's
  // Expand all / Collapse all toggle flips with it.
  const [, forceChildTick] = useState(0);
  useEffect(() => {
    const kids = (node?.childrenAfterGroup || []).filter((c) => c.group);
    if (!kids.length) return undefined;
    const handler = () => forceChildTick((n) => n + 1);
    kids.forEach((c) => c.addEventListener?.("expandedChanged", handler));
    return () =>
      kids.forEach((c) => c.removeEventListener?.("expandedChanged", handler));
  }, [node, node?.childrenAfterGroup]);
  if (!node) return null;
  const isDocGroup = node.field === "docGroup";
  const isDocType = node.field === "docType";
  const isNestedDocType = isDocType && node.parent?.field === "docGroup";
  const leafCount = node.allLeafChildren?.length || 0;
  // Status group headers display the same friendly label as the pills
  // (e.g. "Accepted" → "Underwriter Accepted").
  const label =
    node.field === "documentStatus"
      ? documentStatusLabel(value) || "(uncategorized)"
      : (value ?? "(uncategorized)");

  // True only when this docGroup row has nested docType children — i.e. the
  // current layout is docGroupAndType. In docGroup-only layout there are no
  // children to bulk-expand, so the buttons would be no-ops.
  const childGroups = (node.childrenAfterGroup || []).filter((c) => c.group);
  const hasChildGroups = isDocGroup && childGroups.length > 0;
  // Only show the per-group Expand/Collapse-all buttons when the group is
  // currently expanded. While collapsed there's nothing visible to act on,
  // so the buttons would just be visual noise.
  const showChildGroupActions = hasChildGroups && isExpanded;
  const allChildrenExpanded =
    hasChildGroups && childGroups.every((c) => c.expanded);

  const handleExpandAllChildren = (e) => {
    e.stopPropagation();
    // Make sure the docGroup itself is open before expanding its children —
    // otherwise clicking "Expand all" while collapsed wouldn't reveal
    // anything.
    if (!node.expanded) node.setExpanded(true);
    childGroups.forEach((c) => c.setExpanded(true));
  };
  const handleCollapseAllChildren = (e) => {
    e.stopPropagation();
    childGroups.forEach((c) => c.setExpanded(false));
  };

  // Toggle expand/collapse on a single click anywhere inside the renderer
  // (label, count, empty middle). The Expand/Collapse-all buttons inside
  // call stopPropagation, so they won't fire this. AG Grid's chevron lives
  // outside the inner renderer, so clicking the chevron stays a clean
  // single-toggle handled by AG Grid itself — no double-toggle here.
  const handleToggleRow = (e) => {
    e.stopPropagation();
    node.setExpanded(!node.expanded);
  };

  // Select-all-in-group checkbox state, derived from the group's leaf rows.
  const leafNodes = node.allLeafChildren || [];
  const selectedLeafCount = leafNodes.reduce(
    (n, lc) => n + (lc.isSelected() ? 1 : 0),
    0,
  );
  const allLeavesSelected =
    leafNodes.length > 0 && selectedLeafCount === leafNodes.length;
  const someLeavesSelected = selectedLeafCount > 0 && !allLeavesSelected;
  const handleToggleGroupSelection = (e) => {
    e.stopPropagation();
    const next = !allLeavesSelected;
    leafNodes.forEach((lc) => lc.setSelected(next));
  };

  return (
    <Flx
      ac
      // jb={hasChildGroups}
      fw
      g={1}
      onClick={handleToggleRow}
      sx={{
        width: "100%",
        minWidth: 0,
        cursor: "pointer",
        // Right padding so the buttons sit close to but not jammed against
        // the row's right edge.
        pr: hasChildGroups ? 2 : 0,
        // Indent nested docType rows further from the left so the hierarchy
        // is obvious even when the chevron column is narrow.
        // pl: isNestedDocType ? 1 : 0,
      }}
    >
      {/* Select-all-in-group: checks/unchecks every file under this group.
          stopPropagation so it doesn't also toggle the group's expand/collapse. */}
      {/* AG Grid's own checkbox markup, so the theme styles it exactly like
          the file rows' selection checkbox. */}
      <Box
        className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper${
          allLeavesSelected ? " ag-checked" : ""
        }${someLeavesSelected ? " ag-indeterminate" : ""}`}
        onClick={(e) => e.stopPropagation()}
        // A little room on the left so the checked state (and its focus ring)
        // isn't clipped by the group cell.
        sx={{ flexShrink: 0, ml: "2px" }}
      >
        <input
          type="checkbox"
          className="ag-input-field-input ag-checkbox-input"
          checked={allLeavesSelected}
          onChange={handleToggleGroupSelection}
          aria-label={`Select all in ${label}`}
        />
      </Box>
      {isDocGroup && !params?.context?.hideGroupIcons && (
        <LoanDocumentGroupIcon
          docGroup={label}
          styled
          size={22}
          // No frame, and pulled 4px toward the label.
          sx={{ flexShrink: 0, border: "none", mr: -0.5 }}
        />
      )}
      <Txt
        sx={{
          // docGroup and docType render at the same size when nested so the
          // tree reads as a single hierarchy; weight + color carry the
          // parent/child distinction. 11px !important to beat the
          // `.compact-table .ag-cell { font-size: 12.5px !important }` rule.
          fontSize: "11px !important",
          fontWeight: isNestedDocType ? 500 : 700,
          color: "#1A1A19",
          // color: isNestedDocType ? grey[800] : "#1A1A19",
          letterSpacing: isNestedDocType ? "0.15px" : "0.3px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Txt>
      <Txt
        sx={{
          fontSize: 11,
          fontWeight: 500,
          color: grey[500],
          flexShrink: 0,
        }}
      >
        ({leafCount})
      </Txt>
      {showChildGroupActions && (
        // One toggle for the whole category: expands every type under it, or
        // collapses them all once they are all open.
        <Tooltip
          title={
            allChildrenExpanded
              ? `Collapse all ${value} types`
              : `Expand all ${value} types`
          }
          placement="top"
        >
          <IconButton
            size="small"
            aria-label={
              allChildrenExpanded
                ? `Collapse all ${value} types`
                : `Expand all ${value} types`
            }
            onClick={
              allChildrenExpanded
                ? handleCollapseAllChildren
                : handleExpandAllChildren
            }
            sx={{
              p: "2px",
              flexShrink: 0,
              borderRadius: "6px",
              border: "1px solid #e2e8f0",
              color: grey[600],
              "&:hover": { bgcolor: "#f1f5f9", color: grey[900] },
            }}
          >
            {allChildrenExpanded ? (
              <UnfoldLessOutlined sx={{ fontSize: "15px !important" }} />
            ) : (
              <UnfoldMoreOutlined sx={{ fontSize: "15px !important" }} />
            )}
          </IconButton>
        </Tooltip>
      )}
    </Flx>
  );
};

// Filename-cell validity badge. Same geometry as the "Parsed" badge beside it
// (icon only, 3px pad, 6px radius, 12px glyph) — the tooltip carries the
// meaning, so a row with several markers stays a row of markers rather than a
// row of sentences.
//
// Colors track the urgency buckets `getDocExpiration` returns, matching the
// Expires column's pill so the same document reads the same in both places.
// Expired takes the solid fill the pill uses: at 18px there isn't room for a
// tinted background to register, and expired is the one state worth shouting.
const VALIDITY_BADGE_TONES = {
  ok: { bg: "#ecfdf5", color: "#047857", border: "#a7f3d0" },
  warning: { bg: "#fffbeb", color: "#b45309", border: "#fcd34d" },
  critical: { bg: "#fef2f2", color: "#b91c1c", border: "#fca5a5" },
  expired: { bg: "#dc2626", color: "#ffffff", border: "#dc2626" },
  noStart: { bg: grey[100], color: grey[600], border: grey[300] },
};

// Plain-language state, used as the tooltip's lead line under the header.
const validityStatusLine = (exp) => {
  if (exp?.noStart) return "No effective date set";
  const rem = exp?.remaining ?? 0;
  if (rem < 0)
    return `Expired ${Math.abs(rem)} day${Math.abs(rem) === 1 ? "" : "s"} ago`;
  if (rem === 0) return "Expires today";
  return `Valid — expires in ${rem} day${rem === 1 ? "" : "s"}`;
};

// Short date used in the filename cell's report-info chip. Numeric
// (e.g. "6/5/2025") so it can sit on a single subline without dwarfing
// the docType + comments badges. These are DATE-ONLY report fields
// (effective / expiration), so format with `formatDate` (UTC-stable calendar
// date) — NOT `formatDateTime`, which applies an Eastern-timezone shift and
// renders a date-only value one day early in negative-offset zones.
const formatReportDate = (iso) => formatDate(iso, "—", "M/d/yyyy");

// Single-line "{datetime} by {user}" renderer used by the combined
// Last Updated / Uploaded columns. Truncates with ellipsis when the cell
// is too narrow and shows the full text in a tooltip on hover. The user
// name is resolved against Redux's `users` slice — falls back to the raw
// email when the user isn't in the list.
const DateUserCombinedCell = ({ date, userEmail, fallbackLabel, users }) => {
  const dateText = date ? formatDateTime(date) : "";
  const userName = userEmail
    ? getUserFullNameFromEmail(users, userEmail) || userEmail
    : "";

  // Cell shows the datetime only; the "by {user}" attribution moves to a
  // tooltip anchored on the trailing info icon. When there's no date but
  // we still know the user, fall back to showing the user inline.
  const visibleText = dateText || userName || fallbackLabel || "—";
  const tooltipText =
    dateText && userName ? `${dateText} by ${userName}` : visibleText;

  return (
    <Flx
      ac
      g={0.5}
      sx={{
        overflow: "hidden",
        minWidth: 0,
        maxWidth: "100%",
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          minWidth: 0,
          fontSize: 11,
        }}
      >
        {visibleText}
      </Box>
      {userName && (
        <Tooltip title={tooltipText} placement="top" enterDelay={400}>
          <InfoOutlined
            sx={{
              fontSize: 14,
              color: grey[500],
              flexShrink: 0,
              cursor: "help",
              "&:hover": { color: grey[700] },
            }}
          />
        </Tooltip>
      )}
    </Flx>
  );
};

// Cell renderers below are wrapped in `memo` with a comparator keyed on
// `data` + `context` — AG Grid hands a fresh `params` object on every
// refresh, but when neither the row's data nor the shared grid context
// changed there's nothing to re-render. `users` rides along on `context`.
const sameDataAndContext = (prev, next) =>
  prev?.data === next?.data && prev?.context === next?.context;

const LastUpdatedCombinedCell = memo((params) => {
  if (params?.node?.group) return null;
  return (
    <DateUserCombinedCell
      date={params?.data?.modifiedDate}
      userEmail={params?.data?.updatedBy}
      users={params?.context?.users}
    />
  );
}, sameDataAndContext);

const UploadedCombinedCell = memo((params) => {
  if (params?.node?.group) return null;
  return (
    <DateUserCombinedCell
      date={params?.data?.uploadDate}
      userEmail={params?.data?.uploadedBy}
      users={params?.context?.users}
    />
  );
}, sameDataAndContext);

// Value getters for string/boolean fields whose backend sometimes stores
// strings instead of booleans (matches LoanFilesTable behavior).
const getBooleanValue = (params, field) => {
  const v = params?.data?.[field];
  if (isBoolean(v)) return v;
  if (isString(v)) {
    if (v === "true" || v === "True") return true;
    if (v === "false" || v === "False") return false;
  }
  return false;
};

// =================================================================
// COLUMN CONFIG
// =================================================================
//
// Each entry carries its AG Grid colId + the label shown in the columns
// popover + whether it should be on by default. Non-togglable columns
// (Filename) are just omitted from OPTIONAL_COLUMNS.

const OPTIONAL_COLUMNS = [
  { key: "documentStatus", label: "Status", defaultVisible: true },
  { key: "docType", label: "Document Type", defaultVisible: true },
  { key: "associations", label: "Associations", defaultVisible: true },
  // Combined "{datetime} by {user}" columns. The independent date / user
  // columns below stay registered (so users can opt them in) but default
  // to hidden — these two cover the common case in a single column.
  {
    key: "lastUpdatedCombined",
    label: "Updated",
    defaultVisible: true,
  },
  { key: "uploadedCombined", label: "Uploaded", defaultVisible: true },
  { key: "uploadDate", label: "Upload Date", defaultVisible: false },
  { key: "docGroup", label: "Category", defaultVisible: true },
  { key: "uploadedBy", label: "Uploaded By", defaultVisible: true },
  { key: "modifiedDate", label: "Updated Date", defaultVisible: false },
  { key: "updatedBy", label: "Updated By", defaultVisible: false },
  // Combined validity column — default view; the three individual columns
  // below default hidden (users can opt them back in via Edit Columns).
  { key: "validity", label: "Validity", defaultVisible: true },
  {
    key: "reportEffectiveDate",
    label: "Valid From",
    defaultVisible: false,
  },
  {
    key: "reportGuidelineExpirationDays",
    label: "Valid For",
    defaultVisible: false,
  },
  { key: "isHidden", label: "Is Hidden", defaultVisible: false },
  {
    key: "excludeFromExport",
    label: "Exclude From Export",
    defaultVisible: false,
  },
  // Share flags (TPR / counterparty packages). Generated from the shared
  // registry so the columns, the bulk-edit popover, and the package menu
  // can't drift apart — see utils/documents/documentShareFlags.js.
  ...DOCUMENT_SHARE_FLAGS.map((f) => ({
    key: f.field,
    label: f.columnLabel,
    defaultVisible: false,
  })),
  // Read-only "staged" badge written by the last package build (doc.shareStamp).
  { key: "shareStamp", label: "Package", defaultVisible: false },
  // Raw document object in a modal (same as the Loan Pipeline's JSON column).
  { key: "json", label: "JSON", defaultVisible: false },
  // Computed validity window (reportEffectiveDate + reportGuidelineExpirationDays).
  // Rendered as a date + progress bar + live countdown. Default-visible, and
  // positioned last in buildColumnDefs.
  { key: "expiration", label: "Expires", defaultVisible: false },
];

const DEFAULT_COLUMN_VISIBILITY = OPTIONAL_COLUMNS.reduce((acc, c) => {
  acc[c.key] = c.defaultVisible;
  return acc;
}, {});

// Persists AG Grid's full column state (visibility + order + width +
// pinning) so the user's column preferences survive page reloads.
// Bumped to _v2 when the combined "Last Updated" / "Uploaded" columns were
// introduced — saved state from v1 referenced columns whose visibility had
// shifted, so old state would have hidden the new defaults. Toggling the
// "Preserve column order" setting in the toolbar is what reads/writes here
// at runtime; off by default, so v2 starts clean for everyone.
const COLUMN_STATE_STORAGE_KEY = nsKey("loanDocumentManagerColumnState_v2");

// Persists user-facing table settings (currently just the "preserve column
// order" toggle). Kept separate from COLUMN_STATE_STORAGE_KEY so settings
// survive even if column state is cleared.
export const TABLE_SETTINGS_STORAGE_KEY = nsKey("loanDocumentManagerSettings");
export const DEFAULT_TABLE_SETTINGS = {
  preserveColumnOrder: false,
  // Table settings → display toggles (see the derivations in the component).
  showGroupPanel: false,
  hideGroupIcons: false,
  compactRows: false,
  // Controls how rows appear when grouping is first applied or the grid
  // is reloaded. One of:
  //   - "collapsed"  → AG Grid groupDefaultExpanded = 0  (everything closed)
  //   - "topLevel"   → groupDefaultExpanded = 1
  //                    (with Category & Type: Categories open, Types closed;
  //                     with single-axis grouping: that one level open)
  //   - "all"        → groupDefaultExpanded = -1 (everything open)
  //
  // The legacy boolean `defaultGroupsExpanded` (true | false) is migrated
  // to "all" / "collapsed" at read time — see the derivation in the
  // component below — so existing users keep their preference.
  defaultGroupExpansion: "topLevel",
  // Persisted sort choice — mirrors the original loan files table's
  // "Sort By" dropdown. Shape: { colId, sort } | { state: [...] } | null.
  // Default is the multi-column "Category & Type" option — Category
  // (docGroup) A→Z with Document Type (docType) A→Z as the secondary
  // tiebreaker. Matches LoanFilesTable, which defaults docGroup +
  // docType to "asc" when no sortFilter is set.
  sortFilter: {
    state: [
      { colId: "docGroup", sort: "asc", sortIndex: 0 },
      { colId: "docType", sort: "asc", sortIndex: 1 },
    ],
  },
};

// Sort dropdown options shown in the toolbar — labels, icons, and the
// AG Grid `{ colId, sort }` shape applied when the user picks one. Kept
// at module scope so the array reference is stable across renders.
// Normalize a persisted/selected sortFilter into the `state` array that
// AG Grid's applyColumnState expects. Supports two value shapes for
// backwards compatibility:
//   - { colId, sort }                       → legacy single-column sort
//   - { state: [{ colId, sort, sortIndex }] } → multi-column sort
// Returns null when there's no sort to apply.
const resolveSortState = (sortFilter) => {
  if (!sortFilter) return null;
  if (Array.isArray(sortFilter.state) && sortFilter.state.length > 0) {
    return sortFilter.state;
  }
  if (sortFilter.colId) {
    return [{ colId: sortFilter.colId, sort: sortFilter.sort }];
  }
  return null;
};

const SORT_OPTIONS_FACTORY = () => [
  {
    label: "Category & Type A→Z",
    icon: <TocOutlined />,
    // Multi-column sort: Category (docGroup) A→Z first, with Document
    // Type (docType) A→Z as the secondary tiebreaker within each
    // category. `sortIndex` controls precedence — 0 sorts first.
    value: {
      state: [
        { colId: "docGroup", sort: "asc", sortIndex: 0 },
        { colId: "docType", sort: "asc", sortIndex: 1 },
      ],
    },
  },
  {
    label: "Filename A→Z",
    icon: <SortByAlphaOutlined />,
    value: { colId: "file_display_name", sort: "asc" },
  },
  {
    label: "Upload Date (Newest)",
    icon: <UploadFileOutlined />,
    value: { colId: "uploadedCombined", sort: "desc" },
  },
  {
    label: "Upload Date (Oldest)",
    icon: <UploadFileOutlined />,
    value: { colId: "uploadedCombined", sort: "asc" },
  },
  {
    label: "Status",
    icon: <PublishedWithChangesOutlined />,
    value: { colId: "documentStatus", sort: "asc" },
  },
  {
    label: "Filename Z→A",
    icon: <SwapVertOutlined />,
    value: { colId: "file_display_name", sort: "desc" },
  },
];

// `isHidden` may come back from the backend as a real boolean OR as the
// string "true" / "True" / "false" / "False" — mirrors the same
// inconsistency `getBooleanValue` handles for AG Grid value getters.
export const isDocHidden = (doc) => {
  const v = doc?.isHidden;
  if (typeof v === "boolean") return v;
  if (typeof v === "string") return v === "true" || v === "True";
  return false;
};

// `borrowerPortalUpload` follows the same pattern as `isHidden`: the field
// may be absent, a real boolean, or the string "true"/"True" today. The
// backend will normalize to a real boolean eventually — this helper
// accepts both so the FE works either way without a follow-up patch.
export const isBorrowerPortalUpload = (doc) => {
  const v = doc?.borrowerPortalUpload;
  if (typeof v === "boolean") return v;
  if (typeof v === "string") return v === "true" || v === "True";
  return false;
};

// Layout options — drive AG Grid row grouping. `fields` maps to the
// column colIds that get `rowGroup: true` (in order). Single-field options
// produce one group level; the combined option nests Document Type under
// Category. `shortLabel` is rendered next to the layout button.
export const LAYOUT_OPTIONS = [
  {
    key: "none",
    label: "Table List",
    shortLabel: "List",
    toggleLabel: "Table List",
    icon: ViewListOutlined,
    fields: [],
  },

  {
    key: "docGroup",
    label: "Group Categories",
    shortLabel: "Category Only",
    toggleLabel: "Group Categories",
    icon: CategoryOutlined,
    fields: ["docGroup"],
  },
  {
    key: "docType",
    label: "Group Types",
    shortLabel: "Document Type Only",
    toggleLabel: "Group Types",
    icon: SchemaOutlined,
    fields: ["docType"],
  },
  {
    key: "docGroupAndType",
    label: "Group Categories & Types",
    shortLabel: "Category & Type",
    toggleLabel: "Group Categories & Types",
    icon: AccountTreeOutlined,
    fields: ["docGroup", "docType"],
  },
  // Status-first grouping — `documentStatus` always leads so Status is the top
  // level regardless of which other axes are combined with it.
  {
    key: "status",
    label: "Group By Status",
    shortLabel: "Status Only",
    toggleLabel: "Group By Status",
    icon: FlagOutlined,
    fields: ["documentStatus"],
  },
  {
    key: "statusDocGroup",
    label: "Group By Status & Categories",
    shortLabel: "Status & Category",
    toggleLabel: "Group By Status & Categories",
    icon: FlagOutlined,
    fields: ["documentStatus", "docGroup"],
  },
  {
    key: "statusDocType",
    label: "Group By Status & Types",
    shortLabel: "Status & Type",
    toggleLabel: "Group By Status & Types",
    icon: FlagOutlined,
    fields: ["documentStatus", "docType"],
  },
  {
    key: "statusDocGroupAndType",
    label: "Group By Status, Categories & Types",
    shortLabel: "Status · Category · Type",
    toggleLabel: "Group By Status, Categories & Types",
    icon: FlagOutlined,
    fields: ["documentStatus", "docGroup", "docType"],
  },
  {
    key: "hiddenFiles",
    label: "Hidden Files",
    shortLabel: "Hidden",
    toggleLabel: "Hidden Files",
    icon: VisibilityOffOutlined,
    fields: [],
  },
  {
    key: "borrowerPortalUploads",
    label: "External Uploads",
    shortLabel: "Borrower",
    toggleLabel: "External Uploads",
    icon: UploadFileOutlined,
    fields: [],
  },
];

// Layout key that swaps the displayed-row filter from "hide hidden docs"
// (the default for every other layout) to "show ONLY hidden docs". When
// the user picks this option the table becomes a Hidden-Files-only view —
// no grouping, no other documents.
export const HIDDEN_FILES_LAYOUT_KEY = "hiddenFiles";

// Layout key that filters the table to ONLY files uploaded through the
// borrower portal (`doc.borrowerPortalUpload === true`, after the helper's
// string-vs-boolean normalization). Same pattern as HIDDEN_FILES_LAYOUT_KEY.
export const BORROWER_PORTAL_UPLOADS_LAYOUT_KEY = "borrowerPortalUploads";

export const DEFAULT_LAYOUT = "none";
export const LAYOUT_STORAGE_KEY = nsKey("loanDocumentManagerLayout");

// Pagination kicks in only once a loan exceeds this row count — under
// the threshold the table renders the full list scrollably (preserves
// the current UX on the typical small loan). On large loans it caps
// the rendered row count at PAGINATION_PAGE_SIZE per page, which is
// the dominant cost when domLayout="autoHeight".
const PAGINATION_THRESHOLD = 100;
const PAGINATION_PAGE_SIZE = 50;
const PAGINATION_PAGE_SIZE_OPTIONS = [25, 50, 100, 200];

// Plural noun for each row-group field, used by the toolbar's per-level
// Expand / Collapse buttons (e.g. "Expand Categories", "Collapse Types").
export const LAYOUT_FIELD_LABELS = {
  docGroup: "Categories",
  docType: "Types",
  documentStatus: "Statuses",
};

/**
 * LoanDocumentLayoutToggle
 *
 * Tab-style row of layout choices, mirroring the LayoutToggle in
 * LoanDrilldownFilesTab. Designed to sit *above* the table — its bottom
 * edge is borderless / un-rounded so the table reads as continuous
 * with the active toggle. The parent owns layoutMode state (typically
 * via `useLocalStorageState(LAYOUT_STORAGE_KEY, ...)`) and passes
 * `value` + `onChange`; the table receives the same value via its
 * `forcedLayout` prop.
 */
export const LoanDocumentLayoutToggle = ({
  value,
  onChange,
  hiddenCount = 0,
  borrowerPortalUploadCount = 0,
  sx,
}) => {
  return (
    <Flx
      sx={{
        ml: 0,
        overflowX: "auto",
        flexGrow: 0,
        border: `1px solid #e5e3df`,
        // border: `1px solid #DBE7F8`,
        borderBottom: "none",
        width: "fit-content",
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
        borderTopLeftRadius: "8px",
        borderTopRightRadius: "8px",
        ".MuiButtonBase-root": {
          borderBottom: "none",
          border: "none",
          borderBottomRightRadius: 0,
          flexShrink: 0,
        },
        ...sx,
      }}
    >
      <ToggleButtonGroup
        value={value}
        exclusive
        size="small"
        onChange={(_, next) => {
          // ToggleButtonGroup fires with `null` when the user clicks the
          // already-selected button. Treat that as a no-op so the layout
          // can never end up undefined.
          if (next == null) return;
          onChange?.(next);
        }}
        sx={{
          // Inactive (default) state — quiet, transparent background with
          // grey text/icon. Subtle warm hover background.
          "& .MuiToggleButton-root": {
            borderBottomLeftRadius: 0,
            background: "#ffffff",
            // background: "transparent",
            textTransform: "none",
            color: "#6B7280",
            fontWeight: 400,
            fontSize: "11px",
            px: 1.5,
            py: 1,
            m: 0,
            "& svg": { color: "#6B7280" },
            "&:hover": {
              background: "#F7F7F5",
            },
          },
          // Active state — the level-1 (place) recipe: teal tint, teal-700
          // text + icon, teal-500 underline. See src/theme/activeStates.js.
          "& .Mui-selected": {
            fontWeight: 600,
            color: `${level1.text} !important`,
            background: `${level1.tint} !important`,
            borderBottom: `2px solid ${level1.indicator} !important`,
            "& svg": { color: level1.text },
            "&:hover": {
              background: `${teal[200]} !important`,
            },
          },
        }}
      >
        {LAYOUT_OPTIONS.map((opt, i) => {
          const Icon = opt.icon;
          const isHidden = opt.key === HIDDEN_FILES_LAYOUT_KEY;
          const isBorrowerUploads =
            opt.key === BORROWER_PORTAL_UPLOADS_LAYOUT_KEY;
          const isLast = i === LAYOUT_OPTIONS.length - 1;
          const count = isHidden
            ? hiddenCount
            : isBorrowerUploads
              ? borrowerPortalUploadCount
              : null;
          return (
            <ToggleButton
              key={opt.key}
              value={opt.key}
              sx={{
                borderRight: isLast ? "none" : `1px solid #DBE7F8 !important`,
              }}
            >
              {Icon && (
                <Icon className="thin" sx={{ fontSize: "16px", mr: 0.5 }} />
              )}
              {opt.toggleLabel || opt.shortLabel}
              {count != null && (
                <Box
                  component="span"
                  sx={{
                    ml: 0.5,
                    color: "inherit",
                  }}
                >
                  ({count})
                </Box>
              )}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Flx>
  );
};

// The Documents-tab "view" tabs — which subset of documents to show. This is
// the FILTER axis (grouping is a separate pair of toolbar toggles). Missing
// pulls checklist requirements; Parsed/Extracted is the extracts surface.
// `path` is the view's sub-route under the Documents tab
// (`<loan base>/documents/<path>`) — the URL is the source of truth for which
// view is open. Uploaded is the tab's own root (`…/documents`, path ""). `key`
// stays the internal view id the tab + table branch on.
export const DOC_VIEW_OPTIONS = [
  { key: "visible", path: "", label: "Uploaded", icon: ViewListOutlined },
  {
    key: "parsed",
    path: "parsed",
    label: "Parsed / Extracted",
    icon: AutoAwesomeOutlined,
  },
  { key: "missing", path: "missing", label: "Missing", icon: ErrorOutline },
  {
    key: "hidden",
    path: "hidden",
    label: "Hidden",
    icon: VisibilityOffOutlined,
  },
  // Ocrolus (bank-statement analysis) — the book lifecycle, status, the
  // system-written analysis note and the account-wide book browser.
  {
    key: "ocrolus",
    path: "ocrolus",
    label: "Ocrolus",
    icon: AccountBalanceOutlined,
  },
  // Document Validity — every dated document on one timeline, judged on today
  // and the loan's upcoming closing (or the frozen close). See DocValidityPanel.
  {
    key: "validity",
    path: "validity",
    label: "Document Validity",
    icon: EventBusyOutlined,
  },
  // DocGroup Coverage — taxonomy-first: the whole doc-group → doc-type catalog
  // with the loan's files overlaid, so gaps read as clearly as what exists.
  {
    key: "coverage",
    path: "coverage",
    label: "Document Group Coverage",
    icon: GridViewOutlined,
  },
  // { key: "external", label: "External Uploads", icon: UploadFileOutlined },
];

// Title shown beneath the view tabs, reflecting the current tab.
export const DOC_VIEW_TITLES = {
  visible: "Uploaded Documents",
  parsed: "Parsed / Extracted",
  ocrolus: "Ocrolus",
  missing: "Missing Documents",
  validity: "Document Validity",
  hidden: "Hidden Documents",
  coverage: "Document Group Coverage",
  external: "External Uploads",
};

/**
 * LoanDocumentViewToggle
 *
 * Tab-style row of document VIEWS (Visible / Hidden / Missing / External /
 * Parsed) — same look as the old LoanDocumentLayoutToggle but it selects a
 * filter rather than a grouping. Grouping moved to the toolbar's two
 * GroupToggleButtons. Parent owns `value` + `onChange` and passes the derived
 * `viewFilter` to the table (for the file views) or renders a different body
 * (Missing / Parsed).
 */
export const LoanDocumentViewToggle = ({
  value,
  onChange,
  // Acquisitions loans have no checklist requirements — drop the Missing tab.
  hideMissing = false,
  uploadedCount = 0,
  hiddenCount = 0,
  missingCount = 0,
  externalCount = 0,
  extractedCount = 0,
  // Files sent to the loan's Ocrolus book. `null` renders no badge at all —
  // which is what a loan with no book should show.
  ocrolusCount = null,
  // Docs to replace (expired, or lapsing before closing). null = no badge.
  validityCount = null,
  sx,
}) => {
  const counts = {
    validity: validityCount,
    visible: uploadedCount,
    hidden: hiddenCount,
    missing: missingCount,
    external: externalCount,
    parsed: extractedCount,
    ocrolus: ocrolusCount,
  };
  const options = DOC_VIEW_OPTIONS.filter(
    (o) => !(hideMissing && o.key === "missing"),
  ).map((o) => ({ ...o, count: counts[o.key] ?? null }));
  // The strip itself is shared with the other sub-view tabs (Closing) so they
  // all read as one family — see components/DrilldownSubTabStrip.js.
  return (
    <DrilldownSubTabStrip
      options={options}
      value={value}
      onChange={onChange}
      sx={sx}
    />
  );
};

// Multi-select grouping options for LoanDocumentGroupToggle. Each entry
// maps to a row-group field — combinations of these get nested in
// pinned order (docGroup → docType → documentStatus) by the table.
export const GROUP_FIELD_OPTIONS = [
  { key: "docGroup", label: "Group Category", icon: CategoryOutlined },
  { key: "docType", label: "Group Type", icon: SchemaOutlined },
  { key: "documentStatus", label: "Group Status", icon: RuleOutlined },
];

/**
 * LoanDocumentGroupToggle
 *
 * Multi-select replacement for LoanDocumentLayoutToggle. Each grouping
 * field can be toggled independently — the table nests them in a pinned
 * order. With no selections, the table is ungrouped (the old "All Files"
 * state). A separator-marked "Show Hidden Files" toggle with the current
 * hidden-file count rounds out the bar; off by default.
 *
 * Parent owns `groupFields` + `showHiddenFiles` state and passes them
 * to the table directly. No grouping = no rowGroup columns.
 */
export const LoanDocumentGroupToggle = ({
  groupFields = [],
  onGroupFieldsChange,
  showHiddenFiles = false,
  onShowHiddenFilesChange,
  hiddenCount = 0,
  sx,
}) => {
  const handleGroupChange = (_, next) => {
    onGroupFieldsChange?.(Array.isArray(next) ? next : []);
  };
  const handleHiddenToggle = () => {
    onShowHiddenFilesChange?.(!showHiddenFiles);
  };
  return (
    <Flx
      sx={{
        ml: 0,
        overflowX: "auto",
        flexGrow: 0,
        border: `1px solid #dde1e7`,
        borderBottom: "none",
        width: "fit-content",
        // borderTopLeftRadius: "8px",
        // borderTopRightRadius: "8px",
        ".MuiButtonBase-root": {
          borderBottom: "none",
          border: "none",
          borderBottomRightRadius: 0,
          flexShrink: 0,
        },
        ...sx,
      }}
    >
      <ToggleButtonGroup
        value={groupFields}
        size="small"
        onChange={handleGroupChange}
        sx={{
          "& .MuiToggleButton-root": {
            borderBottomLeftRadius: 0,
            background: "#ffffff",
            textTransform: "none",
            fontSize: "11px",
            px: 2,
            py: 1.5,
            gap: 0.5,
          },
          "& .Mui-selected": {
            background: `${blue[50]} !important`,
          },
        }}
      >
        {GROUP_FIELD_OPTIONS.map((opt) => {
          const Icon = opt.icon;
          const selected = groupFields.includes(opt.key);
          return (
            <ToggleButton key={opt.key} value={opt.key}>
              {selected && (
                <CheckRounded
                  sx={{ fontSize: "14px", color: blue[700], mr: 0.25 }}
                />
              )}
              {Icon && (
                <Icon className="thin" sx={{ fontSize: "16px", mr: 0.5 }} />
              )}
              {opt.label}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
      {/* Visual divider between groupings (structural) and the
          Show-Hidden filter (visibility) so the two concepts read
          distinctly even though they share the bar. */}
      <Box
        sx={{
          width: "1px",
          alignSelf: "stretch",
          bgcolor: "#dde1e7",
          mx: 0.5,
        }}
      />
      <ToggleButtonGroup
        value={showHiddenFiles ? ["showHidden"] : []}
        size="small"
        onChange={handleHiddenToggle}
        sx={{
          "& .MuiToggleButton-root": {
            borderBottomLeftRadius: 0,
            background: "#ffffff",
            textTransform: "none",
            fontSize: "11px",
            px: 2,
            py: 1.5,
            gap: 0.5,
          },
          "& .Mui-selected": {
            background: `${blue[50]} !important`,
          },
        }}
      >
        <ToggleButton value="showHidden">
          {showHiddenFiles && (
            <CheckRounded
              sx={{ fontSize: "14px", color: blue[700], mr: 0.25 }}
            />
          )}
          <VisibilityOffOutlined
            className="thin"
            sx={{ fontSize: "16px", mr: 0.5 }}
          />
          Show Hidden Files
          <Box component="span" sx={{ ml: 0.5, color: grey[600] }}>
            ({hiddenCount})
          </Box>
        </ToggleButton>
      </ToggleButtonGroup>
    </Flx>
  );
};

// =================================================================
// MAIN COMPONENT
// =================================================================

// =================================================================
// CELL RENDERERS
// =================================================================

// Rich tooltip body for the file-details hover on each filename row. Shows
// the filename in a small header (with the file extension as a colored
// badge) plus a label/value list of metadata.
//
// CURRENTLY UNMOUNTED: the info icon it hung off was replaced by the
// "Open in New Tab" action in FilenameCell. Kept (rather than deleted)
// because it's the only rich file-metadata card in the tab and is the
// obvious body for a future info affordance — re-point a Tooltip `title`
// at it to bring it back.
const EXTENSION_BADGE_TONES = {
  pdf: "#c1382e",
  doc: "#1f5fb0",
  docx: "#1f5fb0",
  xls: "#1f7a3a",
  xlsx: "#1f7a3a",
  csv: "#1f7a3a",
  png: "#7c3aed",
  jpg: "#7c3aed",
  jpeg: "#7c3aed",
  gif: "#7c3aed",
  txt: "#475569",
  zip: "#a16207",
};

// eslint-disable-next-line no-unused-vars
const FileInfoTooltipContent = ({ doc }) => {
  if (!doc) return null;
  const ext = getDocExtension(doc);
  const tone = EXTENSION_BADGE_TONES[ext] || "#475569";
  const rows = [];
  if (doc.docGroup) rows.push(["Doc Group", doc.docGroup]);
  if (doc.docType) rows.push(["Doc Type", doc.docType]);
  if (doc.reportEffectiveDate) {
    rows.push(["Effective Date", formatReportDate(doc.reportEffectiveDate)]);
  }
  if (doc.reportGuidelineExpirationDays != null) {
    const n = doc.reportGuidelineExpirationDays;
    rows.push(["Valid For", `${n} day${n === 1 ? "" : "s"}`]);
  }
  if (doc?.uploadDate)
    rows.push(["Upload Date", formatDateTime(doc.uploadDate)]);
  if (doc?.uploadedBy) rows.push(["Uploaded By", doc.uploadedBy]);
  if (doc?.modifiedDate)
    rows.push(["Modified Date", formatDateTime(doc.modifiedDate)]);
  if (doc?.updatedBy) rows.push(["Modified By", doc.updatedBy]);
  return (
    <Flx
      column
      g={0.5}
      sx={{
        background: "#ffffff",
        border: `1px solid ${grey[300]}`,
        borderRadius: 1,
        p: 2,
        maxWidth: 360,
        boxShadow: 2,
      }}
    >
      <Flx
        ac
        g={0.75}
        sx={{
          pt: 0.4,
          pb: 1,
          borderBottom: `1px solid ${grey[200]}`,
          mb: 1,
        }}
      >
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 9,
            fontWeight: 600,
            color: "#fff",
            background: tone,
            flexShrink: 0,
          }}
        >
          {(ext || "FILE").toUpperCase()}
        </Box>
        <Txt
          sx={{
            fontSize: 13,
            fontWeight: 600,
            color: grey[900],
            wordBreak: "break-word",
          }}
        >
          {doc.file_display_name}
        </Txt>
      </Flx>
      {rows.map(([label, value]) => (
        <Flx key={label} g={1.2} sx={{ fontSize: 11, mt: 0.5 }}>
          <Txt
            sx={{
              fontSize: 11,
              color: grey[600],
              minWidth: "70px",
              textAlign: "right",
            }}
          >
            {label}:
          </Txt>
          <Txt sx={{ fontSize: 11, color: grey[900], fontWeight: 600 }}>
            {value}
          </Txt>
        </Flx>
      ))}
    </Flx>
  );
};

// Pulls the file extension from a doc — prefers the explicit `file_extension`
// field, falls back to whatever sits after the last dot in the display name.
const getDocExtension = (doc) => {
  const fromField = (doc?.file_extension || "").trim().toLowerCase();
  if (fromField) return fromField.replace(/^\./, "");
  const name = doc?.file_display_name || "";
  const m = name.match(/\.([^./]+)$/);
  return m ? m[1].toLowerCase() : "";
};

// Remove a trailing ".<ext>" only when it is the file's actual extension
// (case-insensitive). Stripping "everything after the last dot" turned
// "Background Report - 10.1.26 - James Oliva" into "Background Report - 10.1".
const stripFileExtension = (name, ext) => {
  const str = String(name || "");
  if (!ext) return str;
  const suffix = `.${String(ext).toLowerCase()}`;
  return str.toLowerCase().endsWith(suffix)
    ? str.slice(0, -suffix.length)
    : str;
};

// Stable AG Grid cell renderer for the Filename column. Defined at
// module scope so the cellRenderer reference stays the same across
// columnDefs rebuilds — AG Grid will reuse the existing React subtree
// instead of remounting on every layout switch.
const EMPTY_COMMENTS_ARRAY = [];
export const FilenameColumnCellRenderer = memo(
  (params) => {
    if (params.node?.group) return params.value;
    // Indent leaf rows to align under their parent group label so the
    // table reads like a file tree. AG Grid's group column owns the
    // chevron/level indent on group rows; data columns don't get it for
    // free, so we mirror it here. 28px per level matches the alpine
    // theme's default `--ag-row-group-indent-size`.
    const treeIndent = params.disableLeafIndent
      ? 0
      : (params.node?.level || 0) * 28;
    const docId = params.data?._id;
    const commentsForDoc =
      (docId && params.commentsByDocId?.get(docId)) || EMPTY_COMMENTS_ARRAY;
    return (
      <Box
        sx={{
          pl: treeIndent ? `${treeIndent}px` : 0,
          height: "100%",
          // AG Grid lays the cell out as a flex container, so this indent
          // wrapper is a flex ITEM. Without an explicit grow it shrink-wraps
          // its content, and FilenameCell's `width: 100%` then resolves to the
          // filename's own width — which is why the inline rename input only
          // ever got a stub of the column. Claim the cell here too.
          display: "flex",
          flexGrow: 1,
          width: "100%",
          minWidth: 0,
        }}
      >
        <FilenameCell
          doc={params.data}
          hideExtensionBox={params.hideExtensionBox}
          hideDocTypeSubline={params.hideDocTypeSubline}
          minimalActions={params.minimalActions}
          loanId={params.tableLoanId}
          commentsForDoc={commentsForDoc}
          gridApi={params.api}
          rowNode={params.node}
          parsedDocKeys={params.parsedDocKeys}
          onOpenParsedDoc={params.onOpenParsedDoc}
          validityNowMs={params.validityNowMs}
        />
      </Box>
    );
  },
  (prev, next) =>
    prev?.data === next?.data &&
    prev?.value === next?.value &&
    prev?.commentsByDocId === next?.commentsByDocId &&
    prev?.hideExtensionBox === next?.hideExtensionBox &&
    prev?.hideDocTypeSubline === next?.hideDocTypeSubline &&
    prev?.disableLeafIndent === next?.disableLeafIndent &&
    prev?.minimalActions === next?.minimalActions &&
    prev?.tableLoanId === next?.tableLoanId &&
    prev?.parsedDocKeys === next?.parsedDocKeys &&
    prev?.onOpenParsedDoc === next?.onOpenParsedDoc &&
    prev?.validityNowMs === next?.validityNowMs,
);

const FilenameCell = ({
  doc,
  hideExtensionBox = false,
  hideDocTypeSubline = false,
  // When true, the inline hover action icons (Download / Add Comment / Info)
  // are suppressed — only the 3-dot "More actions" menu remains. Used by the
  // stripped-down EntityFilesTable.
  minimalActions = false,
  // Hoisted from the parent table so each cell doesn't run its own
  // useSelector for these. With hundreds of rows that previously meant
  // hundreds of subscriptions firing on every redux update.
  loanId,
  commentsForDoc = EMPTY_COMMENTS_ARRAY,
  // AG Grid plumbing — used to force the row to re-render after an
  // inline metadata save. With `getRowId` set, AG Grid reuses the
  // existing row node by ID and (in practice) doesn't always pick up
  // updated fields off the new Redux state without an explicit nudge.
  gridApi,
  rowNode,
  // Extracted-artifact affordance — see the table's `parsedDocKeys` prop.
  parsedDocKeys = null,
  onOpenParsedDoc = null,
  // Day the validity chip is measured against — today, or the loan's closing
  // date once it's Closed (see utils/documents/validityReference).
  validityNowMs = Date.now(),
}) => {
  const dispatch = useDispatch();
  // Store (not a selector) so we can read the full loanDocuments list at save
  // time for rename de-duplication WITHOUT subscribing every row's cell.
  const store = useStore();
  const { getFileById, updateLoanDocMetadata } = useLoanFilesHook();
  const { openForDocument: openConditionForDocument } =
    useCreateConditionFromDocument();

  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState("");
  const [saving, setSaving] = useState(false);
  // Rename validation message (duplicate name). Shown under the field and
  // blocks the save until the operator picks a free name.
  const [nameError, setNameError] = useState(null);
  // 3-dot file action menu (revealed on hover of the extension badge area).
  const [actionAnchor, setActionAnchor] = useState(null);
  // Inline-edit popover for reportEffectiveDate + reportGuidelineExpirationDays.
  // Opens from either the report-info chip in the subline (when the doc
  // already has values) or the "Edit Report Info" 3-dot menu item.
  const [reportAnchor, setReportAnchor] = useState(null);
  const [reportFormDate, setReportFormDate] = useState("");
  const [reportFormDays, setReportFormDays] = useState("");
  const [reportSaving, setReportSaving] = useState(false);
  // "Edit Details" dialog (full metadata form). Lifted above the
  // early-return to keep hook order stable.
  const [editDetailsOpen, setEditDetailsOpen] = useState(false);
  // In-flight state for the two file-fetch hover actions. Both pull the
  // whole blob down before the browser does anything visible (save dialog /
  // new tab), which on a large scan is several seconds of nothing — so each
  // button swaps its icon for a spinner and stops accepting clicks until the
  // request settles. `fetchingAction` is a single slot rather than two flags
  // because the two actions are mutually exclusive per row.
  const [fetchingAction, setFetchingAction] = useState(null); // "download" | "newTab" | null

  // commentsForDoc is pre-filtered by the parent table (one Redux
  // subscription, one Map build) — just read length here.
  const associatedComments = commentsForDoc;
  const commentCount = associatedComments.length;

  if (!doc) return null;

  const ext = getDocExtension(doc);
  const baseName = stripFileExtension(doc.file_display_name, ext);
  const hidden = isDocHidden(doc);
  const reportEffectiveDate = doc?.reportEffectiveDate;
  const reportDurationDays = doc?.reportGuidelineExpirationDays;
  const hasReportInfo = !!(reportEffectiveDate || reportDurationDays);
  // This doc has extracted artifacts if either its storage name or its id is
  // in the parsed-keys set (built from the extracts index by the parent).
  const isParsed = !!(
    parsedDocKeys &&
    (parsedDocKeys.has(doc?.file_storage_name) || parsedDocKeys.has(doc?._id))
  );

  // Apply a fresh loan-doc payload back into AG Grid's row node and
  // refresh that row's cells. Without this nudge, the getRowId-driven
  // row reuse leaves the cell rendering against the previous data
  // reference until the user reloads — saving from an inline editor
  // appears to do nothing.
  const refreshRowAfterSave = (data) => {
    if (!doc?._id) return;
    const updatedDoc = (data?.loanDocuments || []).find(
      (d) => d?._id === doc._id,
    );
    if (rowNode && updatedDoc) rowNode.setData(updatedDoc);
    gridApi?.refreshCells({
      rowNodes: rowNode ? [rowNode] : undefined,
      force: true,
    });
  };

  const handleStartEdit = (e) => {
    e?.stopPropagation();
    setEditValue(baseName);
    setNameError(null);
    setIsEditing(true);
  };

  const handleCancel = (e) => {
    e?.stopPropagation();
    setIsEditing(false);
    setEditValue("");
    setNameError(null);
  };

  // Typing clears a standing duplicate error — the operator is fixing it.
  const handleEditValueChange = (e) => {
    setEditValue(e.target.value);
    if (nameError) setNameError(null);
  };

  const handleSave = (e) => {
    e?.stopPropagation();
    const trimmed = (editValue || "").trim();
    // No-op if empty or unchanged.
    if (!trimmed || trimmed === baseName) {
      setIsEditing(false);
      setNameError(null);
      return;
    }
    // Drop the file's own extension if the user typed it, then re-append it
    // so the suffix is always preserved. Only the REAL extension is stripped:
    // a dot inside the name ("10.1.26 - James Oliva") is part of the name.
    const newValueWithoutExt = stripFileExtension(trimmed, ext);
    const newDisplayName = ext
      ? `${newValueWithoutExt}.${ext}`
      : newValueWithoutExt;
    // Block a name another file on this loan already uses. Read the full doc
    // list from the store (not a selector) so this cell doesn't subscribe
    // every row to Redux — see utils/documents/duplicateDisplayName.js for
    // why duplicates are refused rather than silently suffixed.
    const allDocs = store.getState()?.loanDrilldown?.loanDocuments || [];
    if (findDuplicateDisplayName(allDocs, doc._id, newDisplayName)) {
      setNameError(DUPLICATE_NAME_MESSAGE);
      return;
    }
    setSaving(true);
    updateLoanDocMetadata({
      loanId,
      data: [{ _id: doc._id, file_display_name: newDisplayName }],
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
        // Push the saved name into this row's node. Redux alone doesn't
        // repaint the reused row, which is what made a successful rename look
        // like it silently reverted.
        refreshRowAfterSave(data);
        setSaving(false);
        setIsEditing(false);
        setEditValue("");
        setNameError(null);
      },
      onFailFn: () => setSaving(false),
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    } else if (e.key === "Escape") {
      e.preventDefault();
      handleCancel();
    }
    // Always stop propagation so AG Grid keyboard nav doesn't steal focus.
    e.stopPropagation();
  };

  // 3-dot menu actions. Each handler stops propagation so the click
  // doesn't also trigger the cell's preview/inspector handlers, then
  // closes the menu.
  const stopAndClose = (e) => {
    e?.stopPropagation();
    setActionAnchor(null);
  };
  const handleOpenActions = (e) => {
    e.stopPropagation();
    setActionAnchor(e.currentTarget);
  };
  // Both file fetches clear `fetchingAction` from BOTH callbacks — the axios
  // hook calls `onSuccessFn` or `onFailFn`, never both, and a spinner left
  // running on a failed fetch would look like the row is permanently stuck.
  //
  // The missing-arg guard mirrors `getFileById`'s own early return: it bails
  // BEFORE calling either callback, so starting a spinner for a doc with no
  // `file_storage_name` would spin forever. Don't start one.
  const canFetchFile = !!(doc?.file_storage_name && (doc?.dealId || loanId));
  const handleDownloadFile = (e) => {
    stopAndClose(e);
    if (fetchingAction || !canFetchFile) return;
    setFetchingAction("download");
    getFileById({
      loanId: doc?.dealId || loanId,
      file_storage_name: doc?.file_storage_name,
      fileDownloadName: doc?.file_display_name,
      fileDownload: true,
      onSuccessFn: () => setFetchingAction(null),
      onFailFn: () => setFetchingAction(null),
    });
  };
  const handleOpenInNewTab = (e) => {
    stopAndClose(e);
    if (fetchingAction || !canFetchFile) return;
    setFetchingAction("newTab");
    getFileById({
      loanId: doc?.dealId || loanId,
      file_storage_name: doc?.file_storage_name,
      fileDownloadName: doc?.file_display_name,
      openInNewTab: true,
      onSuccessFn: () => setFetchingAction(null),
      onFailFn: () => setFetchingAction(null),
    });
  };
  const handleAddComment = (e) => {
    stopAndClose(e);
    // Open the drilldown sidebar's file preview with the comments pane
    // pre-opened — same path used by other "comment on file" affordances
    // (DrilldownFilePreviewSidebar reads `params.openComments`).
    dispatch(
      sidebarSetValues({
        type: loanDrilldownSidebarTypes.FILE_PREVIEW,
        state: doc,
        params: { openComments: true },
      }),
    );
  };

  // Report-info edit popover handlers. Both entry points (chip click and
  // 3-dot menu item) seed the form from the current doc values and
  // anchor the popover to the clicked element so it positions sensibly.
  const seedReportForm = () => {
    setReportFormDate(
      reportEffectiveDate ? String(reportEffectiveDate).slice(0, 10) : "",
    );
    setReportFormDays(
      reportDurationDays != null ? String(reportDurationDays) : "",
    );
  };
  const handleOpenReportFromChip = (e) => {
    e.stopPropagation();
    seedReportForm();
    setReportAnchor(e.currentTarget);
  };
  const handleOpenReportFromMenu = (e) => {
    e.stopPropagation();
    const target = actionAnchor;
    setActionAnchor(null);
    seedReportForm();
    // Anchor the popover to the 3-dot button so it lands in roughly the
    // same spot as the menu it's replacing.
    setReportAnchor(target);
  };
  const handleSaveReportInfo = (e) => {
    e?.stopPropagation();
    if (!doc?._id) return;
    setReportSaving(true);
    const daysStr = (reportFormDays ?? "").toString().trim();
    const daysNum = daysStr === "" ? null : Number(daysStr);
    updateLoanDocMetadata({
      loanId,
      data: [
        {
          _id: doc._id,
          reportEffectiveDate: reportFormDate || null,
          reportGuidelineExpirationDays: Number.isFinite(daysNum)
            ? daysNum
            : null,
        },
      ],
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
        refreshRowAfterSave(data);
        setReportSaving(false);
        setReportAnchor(null);
      },
      onFailFn: () => setReportSaving(false),
    });
  };

  // Quick-toggle Hide / Unhide from the 3-dot menu. Backend returns the
  // updated loan, same flow as every other inline edit on this cell.
  const handleToggleHidden = (e) => {
    stopAndClose(e);
    if (!doc?._id) return;
    updateLoanDocMetadata({
      loanId,
      data: [{ _id: doc._id, isHidden: !hidden }],
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
        refreshRowAfterSave(data);
      },
    });
  };

  // Edit Details — opens a dialog with the full editable-fields form
  // (UpdateLoanDocumentMetadataForm). The state itself is declared
  // above the early-return; these handlers use it.
  const handleOpenEditDetails = (e) => {
    stopAndClose(e);
    setEditDetailsOpen(true);
  };
  const handleCloseEditDetails = () => setEditDetailsOpen(false);
  const handleEditDetailsSaved = (data) => {
    refreshRowAfterSave(data);
    setEditDetailsOpen(false);
  };

  return (
    <Flx
      ac
      g={0.75}
      sx={{
        minWidth: 0,
        // AG Grid lays the cell out as a flex container, which makes this
        // wrapper a flex ITEM — so without an explicit width it shrink-wraps
        // its content and the rename input only ever gets as wide as the
        // filename it started with. Claim the column.
        width: "100%",
        flexGrow: 1,
        height: "100%",
        // Anchor for the rename pencil, which floats at the cell's right edge
        // rather than trailing the filename — so nothing reserves a gutter.
        position: "relative",
        // Reveal the rename pencil on hover anywhere in the cell. It's
        // absolutely positioned (see below) so fading it in never reflows the
        // filename's trailing chips.
        "&:hover .filename-edit-btn": { opacity: 1, pointerEvents: "auto" },
      }}
    >
      <Box
        className="dmt-fname-actions"
        data-rename-ui="true"
        onClick={(e) => e.stopPropagation()}
        sx={{
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
          // While renaming, the action cluster steps aside so the input gets
          // the cell's full content width — long filenames are the norm here
          // and typing into a stub of a field is the whole complaint.
          // (Popovers anchored here portal to <body>, so hiding the anchor
          // doesn't hide an open menu.)
          ...(isEditing && { display: "none" }),
          // gap: 1,
          // 20px square hit targets holding a 15px icon — the glyph nearly
          // fills the button, so the target reads as the icon itself rather
          // than a box around it. They rest at 72% opacity — present enough to
          // find, quiet enough that a long list doesn't read as a wall of
          // controls — and come to full strength when the pointer enters the
          // row (that rule lives on the grid container, which is the only
          // thing that knows about row hover).
          ".MuiButtonBase-root": {
            width: "20px",
            height: "20px",
            borderRadius: "4px",
            p: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#6b7280",
            opacity: 0.72,
            transition:
              "opacity .12s, color .12s, background .12s, box-shadow .12s",
          },
          // Hovering an individual icon lifts it out of the row: action teal
          // on white, ringed by the same hairline the table is framed with.
          ".MuiButtonBase-root:hover": {
            opacity: 1,
            color: teal[600],
            background: "#ffffff",
            boxShadow: "inset 0 0 0 1px #e5e7eb",
          },
          ".MuiSvgIcon-root": {
            fontSize: "15px",
          },
        }}
      >
        <Tooltip title="More actions" placement="top">
          <IconButton size="small" color="primary" onClick={handleOpenActions}>
            <MoreVert
              className="thin-7"
              //

              // sx={{ fontSize: "17px !important" }}
            />
          </IconButton>
        </Tooltip>
        {/* Inline hover actions, left to right after the 3-dot menu:
            Add Comment / Download / Open in New Tab.
            The last slot used to be an info icon whose hover rendered the
            rich `FileInfoTooltipContent` card; the same details are still
            reachable from the 3-dot menu, and opening the file in a tab is
            the affordance the desk actually reaches for. */}

        {!minimalActions && (
          <>
            <Tooltip title="Add Comment" placement="top">
              <IconButton
                size="small"
                color="primary"
                onClick={handleAddComment}
              >
                <AddCommentOutlined
                  className="thin-5"
                  // sx={{ fontSize: "15px !important" }}
                />
              </IconButton>
            </Tooltip>
            {/* The two file-fetch actions swap their icon for a spinner while
                the blob is downloading. They stay enabled (rather than taking
                `disabled`) so the Tooltip keeps working — MUI can't anchor a
                tooltip to a disabled button — and the handlers themselves
                no-op on a second click. */}
            <Tooltip
              title={
                fetchingAction === "download" ? "Downloading…" : "Download File"
              }
              placement="top"
            >
              <IconButton
                size="small"
                color="primary"
                onClick={handleDownloadFile}
              >
                {fetchingAction === "download" ? (
                  <CircularProgress size={16} sx={{ color: "inherit" }} />
                ) : (
                  <DownloadOutlined className="thin-7" />
                )}
              </IconButton>
            </Tooltip>
            <Tooltip
              title={
                fetchingAction === "newTab" ? "Opening…" : "Open in New Tab"
              }
              placement="top"
            >
              <IconButton
                size="small"
                color="primary"
                onClick={handleOpenInNewTab}
              >
                {fetchingAction === "newTab" ? (
                  <CircularProgress size={15} sx={{ color: "inherit" }} />
                ) : (
                  <OpenInNewOutlined className="thin-5" />
                )}
              </IconButton>
            </Tooltip>
          </>
        )}
        {hidden && (
          <Tooltip title="This file is marked hidden" placement="top">
            <VisibilityOffOutlined
              sx={{ fontSize: "16px !important", color: grey[500], ml: 0.25 }}
            />
          </Tooltip>
        )}
        {/* Menu / Dialog / Popover below are mounted only while open.
            Previously every row's FilenameCell eagerly constructed all
            three (each an MUI portal component) even though they're
            inactive on ~every row — a big chunk of the per-row render
            cost on large loans. */}
        {!!actionAnchor && (
          <Menu
            anchorEl={actionAnchor}
            open={!!actionAnchor}
            onClose={() => setActionAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            // Same StyledMenu treatment as the table's Settings menu.
            slotProps={STYLED_MENU_PAPER_SLOT_PROPS({ minWidth: 220 })}
            // The Menu and its items are inside the AG Grid cell DOM, so
            // clicks elsewhere in the cell would otherwise trigger the
            // table's onCellClicked. Stop the synthetic event from
            // bubbling up — the data-rename-ui attribute on the anchor
            // wrapper also covers AG Grid's native listener.
            onClick={(e) => e.stopPropagation()}
            MenuListProps={{
              sx: {
                py: 0.5,
                display: "flex",
                flexDirection: "column",
                gap: 0.25,
              },
            }}
          >
            <Box sx={STYLED_MENU_HEADER_SX}>
              <Txt sx={STYLED_MENU_HEADER_TXT_SX}>File actions</Txt>
            </Box>
            <Divider sx={{ mb: 0.5 }} />
            <MenuItem onClick={handleDownloadFile} sx={STYLED_MENU_ITEM_SX}>
              <ListItemIcon sx={{ minWidth: 32, color: "text.secondary" }}>
                <DownloadOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Download File"
                primaryTypographyProps={{ fontSize: 13 }}
              />
            </MenuItem>
            <MenuItem onClick={handleOpenInNewTab} sx={STYLED_MENU_ITEM_SX}>
              <ListItemIcon sx={{ minWidth: 32, color: "text.secondary" }}>
                <OpenInNewOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Open File in New Tab"
                primaryTypographyProps={{ fontSize: 13 }}
              />
            </MenuItem>
            <MenuItem onClick={handleOpenEditDetails} sx={STYLED_MENU_ITEM_SX}>
              <ListItemIcon sx={{ minWidth: 32, color: "text.secondary" }}>
                <EditOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Edit Details"
                primaryTypographyProps={{ fontSize: 13 }}
              />
            </MenuItem>
            <MenuItem onClick={handleAddComment} sx={STYLED_MENU_ITEM_SX}>
              <ListItemIcon sx={{ minWidth: 32, color: "text.secondary" }}>
                <ModeCommentOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Add Comment"
                primaryTypographyProps={{ fontSize: 13 }}
              />
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                setActionAnchor(null);
                openConditionForDocument(doc);
              }}
              sx={STYLED_MENU_ITEM_SX}
            >
              <ListItemIcon sx={{ minWidth: 32, color: "text.secondary" }}>
                <PlaylistAddCheckOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Create Condition from Document"
                primaryTypographyProps={{ fontSize: 13 }}
              />
            </MenuItem>
            <MenuItem
              onClick={handleOpenReportFromMenu}
              sx={STYLED_MENU_ITEM_SX}
            >
              <ListItemIcon sx={{ minWidth: 32, color: "text.secondary" }}>
                <EventOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  hasReportInfo
                    ? "Edit Validity/Expiration Duration"
                    : "Set Validity/Expiration Duration"
                }
                primaryTypographyProps={{ fontSize: 13 }}
              />
            </MenuItem>
            <MenuItem onClick={handleToggleHidden} sx={STYLED_MENU_ITEM_SX}>
              <ListItemIcon sx={{ minWidth: 32, color: "text.secondary" }}>
                {hidden ? (
                  <VisibilityOutlined fontSize="small" />
                ) : (
                  <VisibilityOffOutlined fontSize="small" />
                )}
              </ListItemIcon>
              <ListItemText
                primary={hidden ? "Unhide" : "Hide"}
                primaryTypographyProps={{ fontSize: 13 }}
              />
            </MenuItem>
          </Menu>
        )}
        {/* Full-form edit dialog. Wraps UpdateLoanDocumentMetadataForm
              (extended in this branch to cover every editable doc
              field) so users can change everything in one place
              instead of using the targeted inline editors. */}
        {editDetailsOpen && (
          <EditDocumentDetailsDialog
            open={editDetailsOpen}
            file={doc}
            loanId={loanId}
            onClose={handleCloseEditDetails}
            onSaved={handleEditDetailsSaved}
          />
        )}
        {/* Inline edit popover for reportEffectiveDate +
              reportGuidelineExpirationDays. Reachable from either the
              chip in the subline (when info already exists) or the
              "Edit / Add Report Info" 3-dot menu item. */}
        {!!reportAnchor && (
          <Popover
            open={!!reportAnchor}
            anchorEl={reportAnchor}
            onClose={() => setReportAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            slotProps={STYLED_MENU_PAPER_SLOT_PROPS({ minWidth: 280 })}
            onClick={(e) => e.stopPropagation()}
          >
            <Box sx={STYLED_MENU_HEADER_SX}>
              <Txt sx={STYLED_MENU_HEADER_TXT_SX}>Validity period</Txt>
            </Box>
            <Divider />
            <Box
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
              }}
            >
              <Txt
                sx={{
                  fontSize: 11,
                  color: grey[600],
                  display: "block",
                  mt: -0.5,
                }}
              >
                Set how long this document is considered valid — the effective
                date plus the number of days it remains good for.
              </Txt>
              <Box>
                <Txt
                  sx={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: grey[700],
                    mb: 0.5,
                    display: "block",
                  }}
                >
                  Effective date
                </Txt>
                <TextField
                  type="date"
                  size="small"
                  fullWidth
                  value={reportFormDate}
                  onChange={(e) => setReportFormDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
              <Box>
                <Txt
                  sx={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: grey[700],
                    mb: 0.5,
                    display: "block",
                  }}
                >
                  Valid for (days)
                </Txt>
                <TextField
                  type="number"
                  size="small"
                  fullWidth
                  value={reportFormDays}
                  onChange={(e) => setReportFormDays(e.target.value)}
                  inputProps={{ min: 0 }}
                  placeholder="e.g. 90"
                />
              </Box>
              <Flx jb g={1} sx={{ pt: 0.5 }}>
                <Button
                  size="small"
                  variant="outlined"
                  color="gray"
                  onClick={() => setReportAnchor(null)}
                  disabled={reportSaving}
                >
                  Cancel
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={handleSaveReportInfo}
                  disabled={reportSaving}
                  startIcon={
                    reportSaving ? (
                      <CircularProgress size={12} sx={{ color: "inherit" }} />
                    ) : null
                  }
                >
                  {reportSaving ? "Saving..." : "Save"}
                </Button>
              </Flx>
            </Box>
          </Popover>
        )}
      </Box>
      {isEditing ? (
        // Edit mode — `data-rename-ui` is read by the table's onCellClicked
        // to bail before opening the file-preview modal. Native event order
        // means React's stopPropagation alone isn't enough.
        <Flx
          ac
          g={0.5}
          data-rename-ui="true"
          sx={{ flex: 1, minWidth: 0, width: "600px" }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Duplicate-name refusal rides in a tooltip rather than helperText:
              the cell is one grid row tall, so there's no room to grow a
              message under the field without shifting the row. */}
          <Tooltip
            title={nameError || ""}
            open={!!nameError}
            arrow
            placement="top"
          >
            <TextField
              size="small"
              autoFocus
              value={editValue}
              onChange={handleEditValueChange}
              onKeyDown={handleKeyDown}
              onClick={(e) => e.stopPropagation()}
              disabled={saving}
              error={!!nameError}
              placeholder="Filename"
              slotProps={{
                input: {
                  endAdornment: ext ? (
                    <InputAdornment position="end" sx={{ mr: 0.25 }}>
                      <Txt
                        sx={{
                          fontSize: 11,
                          color: grey[500],
                          whiteSpace: "nowrap",
                        }}
                      >
                        .{ext}
                      </Txt>
                    </InputAdornment>
                  ) : null,
                },
              }}
              sx={{
                flex: 1,
                minWidth: 0,
                "& .MuiInputBase-root": { fontSize: 12, py: 0 },
                "& .MuiInputBase-input": { fontSize: 12, py: 0.5 },
              }}
            />
          </Tooltip>
          {saving ? (
            <CircularProgress size={16} />
          ) : (
            <>
              <Tooltip title="Save (Enter)">
                <IconButton
                  size="small"
                  onClick={handleSave}
                  sx={{ p: 0.25, color: "#185FA5" }}
                >
                  <CheckRounded sx={{ fontSize: 16 }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel (Esc)">
                <IconButton
                  size="small"
                  onClick={handleCancel}
                  sx={{ p: 0.25, color: grey[600] }}
                >
                  <CloseRounded sx={{ fontSize: 16 }} />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Flx>
      ) : (
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Flx ac g={0.5}>
            {/* Name only. The rename pencil is NOT in this box — it floats at
                the right edge of the whole cell (see below), so the filename
                keeps every pixel and no empty gutter is reserved for it. */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                minWidth: 0,
                flexShrink: 1,
                position: "relative",
                mr: 0.5,
              }}
            >
              <Tooltip title="Preview file" placement="top" arrow>
                <Box
                  component={"p"}
                  sx={{
                    display: "block",
                    fontSize: "11px",
                    fontWeight: 400,
                    lineHeight: 1.3,
                    minWidth: 0,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    "&:hover": {
                      color: "#185FA5",
                      textDecoration: "underline",
                    },
                  }}
                >
                  {doc.file_display_name}
                </Box>
              </Tooltip>
              <Tooltip title="Rename file">
                <IconButton
                  className="filename-edit-btn"
                  data-rename-ui="true"
                  size="small"
                  color="primary"
                  onClick={handleStartEdit}
                  sx={{
                    position: "absolute",
                    right: -4,
                    top: "50%",
                    transform: "translateY(-50%)",
                    p: 0.25,
                    opacity: 0,
                    pointerEvents: "none",
                    transition: "opacity 0.08s",
                    bgcolor: "#fff",
                    border: `1px solid ${grey[200]}`,
                    borderRadius: "4px",
                    boxShadow: "0 1px 3px rgba(15,23,42,0.12)",
                    "&:hover": { color: "#185FA5", bgcolor: "#fff" },
                  }}
                >
                  <EditOutlined sx={{ fontSize: 14 }} />
                </IconButton>
              </Tooltip>
            </Box>
            {isParsed && (
              <Tooltip title="View parsed extract (OCR · JSON · images)">
                {/* Icon-only badge — the "Parsed" label is dropped; the tooltip
                    carries the meaning. data-rename-ui bails the row's
                    file-preview click so the chip opens the trifold instead. */}
                <Box
                  data-rename-ui="true"
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpenParsedDoc?.(doc);
                  }}
                  sx={{
                    flexShrink: 0,
                    p: "3px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "6px",
                    bgcolor: "#fce7f3",
                    color: "#db2777",
                    border: "1px solid #fbcfe8",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#fbcfe8" },
                  }}
                >
                  <AutoAwesomeOutlined sx={{ fontSize: "12px !important" }} />
                </Box>
              </Tooltip>
            )}
            {commentCount > 0 && (
              <CommentThreadPreviewTooltip
                loan={{ comments: associatedComments }}
                comments={associatedComments}
              >
                <Flx
                  ac
                  g={0.4}
                  sx={{
                    flexShrink: 0,
                    px: 0.75,
                    py: "1px",
                    borderRadius: "10px",
                    bgcolor: blue[50],
                    color: blue[800],
                    border: `1px solid ${blue[100]}`,
                    cursor: "help",
                    "&:hover": { bgcolor: blue[100] },
                  }}
                >
                  <ModeCommentOutlined sx={{ fontSize: "11px !important" }} />
                  <Txt
                    sx={{
                      fontSize: "10px",
                      fontWeight: 600,
                      color: blue[800],
                      lineHeight: 1.2,
                    }}
                  >
                    {commentCount}
                  </Txt>
                </Flx>
              </CommentThreadPreviewTooltip>
            )}
            {/* Subline only renders when the doc has a validity / report
              effective period — keeps rows compact otherwise. docType,
              comment indicator, and association icons no longer live
              here (moved to dedicated columns / inline next to the
              filename respectively). */}
            {hasReportInfo &&
              (() => {
                // Validity chip — the SAME countdown pill shown in the Expires
                // column ("N days left" / "Expires today" / "Exp. Nd ago",
                // colored by urgency), so the filename subline matches the
                // column exactly. `getDocExpiration` reuses the column's own
                // computation. When there's a duration but no effective date
                // yet, fall back to a neutral "No start date" prompt.
                const exp = getDocExpiration(doc, validityNowMs);
                if (!exp) return null;
                const endDate = exp.expiration
                  ? formatReportDate(exp.expiration)
                  : null;
                const toneKey = exp.noStart ? "noStart" : exp.kind;
                const tone =
                  VALIDITY_BADGE_TONES[toneKey] || VALIDITY_BADGE_TONES.ok;
                // Past due and nearly-due earn the warning glyph; everything
                // else keeps the hourglass, so the badge still reads as "this
                // document has a shelf life" at a glance.
                const BadgeIcon =
                  exp.kind === "expired" || exp.kind === "critical"
                    ? WarningAmberOutlined
                    : HourglassEmptyOutlined;
                const detailRows = [
                  reportEffectiveDate
                    ? `Effective: ${formatReportDate(reportEffectiveDate)}`
                    : "Effective: not set",
                  reportDurationDays != null
                    ? `Duration: ${reportDurationDays} day${reportDurationDays === 1 ? "" : "s"}`
                    : null,
                  endDate ? `Expires: ${endDate}` : null,
                ].filter(Boolean);
                return (
                  <Tooltip
                    placement="top"
                    title={
                      <Box sx={{ py: 0.25 }}>
                        {/* Header first — with the label gone from the badge,
                            the tooltip has to say WHAT it's describing before
                            it says anything about the state. */}
                        <Box
                          sx={{
                            fontSize: 10,
                            fontWeight: 700,
                            letterSpacing: "0.06em",
                            textTransform: "uppercase",
                            opacity: 0.7,
                            mb: "2px",
                          }}
                        >
                          Document validity
                        </Box>
                        <Box sx={{ fontSize: 12, fontWeight: 600 }}>
                          {validityStatusLine(exp)}
                        </Box>
                        {detailRows.map((line) => (
                          <Box key={line} sx={{ fontSize: 11, opacity: 0.85 }}>
                            {line}
                          </Box>
                        ))}
                      </Box>
                    }
                  >
                    {/* data-rename-ui bails the row's file-preview click so the
                        badge opens the validity editor instead. */}
                    <Box
                      data-rename-ui="true"
                      onClick={handleOpenReportFromChip}
                      sx={{
                        flexShrink: 0,
                        p: "3px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "6px",
                        bgcolor: tone.bg,
                        color: tone.color,
                        border: `1px solid ${tone.border}`,
                        cursor: "pointer",
                        "&:hover": { filter: "brightness(0.95)" },
                      }}
                    >
                      <BadgeIcon sx={{ fontSize: "12px !important" }} />
                    </Box>
                  </Tooltip>
                );
              })()}
          </Flx>
          {/* Rename pencil — floats over the far right of the filename cell
              instead of trailing the name, so nothing reserves a gutter for it
              while it's hidden. `pointerEvents: none` while faded out keeps it
              from swallowing clicks meant for whatever sits underneath. */}
        </Box>
      )}
    </Flx>
  );
};

// Inline-editable status cell — visually matches the old documents
// table (full-cell colored fill + colored left border + leading status
// icon + "By <user> on <date>" byline), but adds a chevron and click-
// to-edit popover so users can change the status without leaving the
// row. Lives only in the documents table because the shared cell
// renderer (`LoanFileStatusCell`) stays a pill for other tables.
const STATUS_CELL_STYLES = {
  "Pending Review": {
    bgcolor: amber[50],
    color: "inherit",
    borderLeft: orange[100],
  },
  "Initial Reviewed": {
    bgcolor: amber[50],
    color: "inherit",
    borderLeft: orange[100],
  },
  "Legal Reviewed": {
    bgcolor: amber[50],
    color: "inherit",
    borderLeft: orange[100],
  },
  "Processor Reviewed": {
    bgcolor: deepPurple[50],
    color: "inherit",
    borderLeft: deepPurple[100],
  },
  Expired: { bgcolor: red[50], color: red[900], borderLeft: red[100] },
  Rejected: { bgcolor: red[50], color: red[900], borderLeft: red[100] },
  // Same red family as Rejected / Expired, nudged toward orange so the two
  // read as different statuses at a glance (see LoanFileStatusCell).
  Incomplete: {
    bgcolor: deepOrange[50],
    color: deepOrange[900],
    borderLeft: deepOrange[100],
  },
  Accepted: { bgcolor: green[50], color: green[900], borderLeft: green[100] },
};
const STATUS_CELL_DEFAULT = {
  bgcolor: "transparent",
  color: "inherit",
  borderLeft: "transparent",
};

const STATUS_CELL_ICONS = {
  "New Upload": AutoAwesomeOutlined,
  "Initial Reviewed": ManageSearchOutlined,
  "Legal Reviewed": GavelOutlined,
  "Pending Review": GavelOutlined,
  "Processor Reviewed": FactCheckOutlined,
  Expired: HourglassEmptyOutlined,
  Rejected: ErrorOutline,
  Incomplete: ErrorOutline,
  Accepted: CheckOutlined,
};

const InlineEditableStatusCell = (params) => {
  const dispatch = useDispatch();
  // loanId / users come from AG Grid `context` (set once on the grid)
  // rather than a per-cell useSelector.
  const loanId = params?.context?.loanId;
  const users = params?.context?.users;
  const { updateLoanDocMetadata } = useLoanFilesHook();
  const [anchor, setAnchor] = useState(null);
  // Per-cell saving state so only the row being updated shows the
  // spinner — the hook's shared `loading` would dim every status cell
  // whenever any loan-files request was in flight.
  const [saving, setSaving] = useState(false);
  // The status we're optimistically rendering during a save, so the user
  // sees the new value immediately (not the stale one) while the request
  // is in flight.
  const [pendingStatus, setPendingStatus] = useState(null);
  const doc = params?.data;
  if (!doc) return null;

  const status = pendingStatus || doc.documentStatus || "Uncategorized";
  const styleSet = STATUS_CELL_STYLES[status] || STATUS_CELL_DEFAULT;
  const StatusIcon = STATUS_CELL_ICONS[status] || null;

  const updatedByEmail = doc.documentStatusUpdateBy;
  const updatedAt = doc.documentStatusUpdateDate || doc.modifiedDate;
  const formattedUserName = getUserFullNameFromEmail(users, updatedByEmail);
  const showByline =
    status !== "New Upload" &&
    !isNil(formattedUserName) &&
    !isNil(updatedByEmail);
  const bylineText = showByline
    ? `By ${formattedUserName} on ${formatDateTime(updatedAt)}`
    : "";
  // Compact rows: one line — the column's own status tooltip carries the byline.
  const compact = !!params?.context?.compact;

  const handleSelect = (newStatus) => {
    if (!doc?._id || newStatus === doc.documentStatus) {
      setAnchor(null);
      return;
    }
    setSaving(true);
    setPendingStatus(newStatus);
    setAnchor(null);
    updateLoanDocMetadata({
      loanId,
      data: [{ _id: doc._id, documentStatus: newStatus }],
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
        setSaving(false);
        setPendingStatus(null);
      },
      onFailFn: () => {
        setSaving(false);
        setPendingStatus(null);
      },
    });
  };

  return (
    <>
      <Box
        onClick={(e) => {
          if (saving) return;
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
        sx={{
          cursor: saving ? "progress" : "pointer",
          pointerEvents: saving ? "none" : "auto",
          width: "100%",
          height: "100%",
          flex: "1 1 auto",
          // The grid's font, not the MUI theme's — matches every other cell.
          fontFamily: "inherit",
          "& .MuiTypography-root": { fontFamily: "inherit" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 0.25,
          px: compact ? 1 : 1.25,
          py: compact ? 0 : 0.5,
          bgcolor: styleSet.bgcolor,
          color: styleSet.color,
          borderLeft: `2px solid ${styleSet.borderLeft}`,
          minWidth: 0,
          position: "relative",
          // While saving, lift the cell slightly and outline it so the
          // in-flight write is obvious at a glance — no more silent dim.
          ...(saving
            ? {
                outline: "1.5px solid rgba(0, 0, 0, 0.35)",
                outlineOffset: "-1px",
                boxShadow: "0 1px 6px rgba(0, 0, 0, 0.15)",
              }
            : {}),
          "&:hover": saving ? {} : { filter: "brightness(0.96)" },
        }}
      >
        <Flx ac g={0.4} sx={{ minWidth: 0 }}>
          {StatusIcon && (
            <StatusIcon
              className="thin"
              sx={{
                fontSize: "13px !important",
                color: "inherit",
                flexShrink: 0,
              }}
            />
          )}
          <Txt
            sx={{
              fontSize: "11px",
              fontWeight: 500,
              color: "inherit",
              lineHeight: "16px",
              flex: 1,
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {documentStatusLabel(status)}
          </Txt>
          {saving ? (
            <Flx
              ac
              g={0.4}
              sx={{
                flexShrink: 0,
                fontSize: "10.5px",
                fontWeight: 600,
                color: "inherit",
                opacity: 0.85,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              <CircularProgress
                size={12}
                thickness={5}
                sx={{ color: "inherit" }}
              />
              <Box component="span">Saving</Box>
            </Flx>
          ) : (
            <KeyboardArrowDown
              sx={{
                fontSize: 16,
                opacity: 0.7,
                color: "inherit",
                flexShrink: 0,
              }}
            />
          )}
        </Flx>
        {showByline && !compact && (
          <Txt
            sx={{
              fontSize: "9.4px",
              fontWeight: 400,
              color: "inherit",
              opacity: 0.85,
              lineHeight: "14px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {bylineText}
          </Txt>
        )}
      </Box>
      <StatusEditPopover
        anchor={anchor}
        onClose={() => setAnchor(null)}
        currentStatus={doc.documentStatus}
        onSelect={handleSelect}
      />
    </>
  );
};

// Inline associations cell — reuses the same DocumentAssociations component
// the inspector uses, so chips + "+" button + editor modal all behave the
// same way. Loan / loanId are pulled from AG Grid `context` so the cell
// stays self-contained.
const InlineAssociationsCell = (params) => {
  // loan comes from AG Grid `context` — previously this opened a
  // useSelector on the *entire* loanDrilldown slice in every rendered
  // associations cell.
  const loan = params?.context?.loan;
  const doc = params?.data;
  if (!doc) return null;
  return (
    <Flx
      ac
      g={0.5}
      onClick={(e) => e.stopPropagation()}
      sx={{
        width: "100%",
        flexWrap: "nowrap",
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      {/* Condition chip comes FIRST (before any association chips) so a
          document's linked condition reads at the start of the column. The
          row does not wrap. */}
      <ConditionChips doc={doc} map={params?.context?.conditionsByDocId} />
      <DocumentAssociations
        doc={doc}
        loan={loan}
        loanId={loan?._id}
        iconsOnly
        compactEmpty
      />
    </Flx>
  );
};

// Status palette for the Condition cell — mirrors the condition sidebar's
// STATUS_TONE so the chip reads the same here as in the conditions view.
const CONDITION_STATUS_TONE = {
  Open: { fg: "#475569", bg: "#f1f5f9", bd: "#e2e8f0" },
  "In Progress": { fg: "#b45309", bg: "#fffbeb", bd: "#fde68a" },
  "Second Level Review": { fg: "#9a3412", bg: "#fff7ed", bd: "#fed7aa" },
  Accepted: { fg: "#15803d", bg: "#f0fdf4", bd: "#bbf7d0" },
  Rejected: { fg: "#b91c1c", bg: "#fef2f2", bd: "#fecaca" },
};

const conditionTitle = (c) =>
  sharedConditionTitle(c, c?.requirementType || "Condition");

// Condition status chip(s) for a document, rendered inside the Associations
// cell. Shows a chip when a condition references this document (via
// uploadedDocumentIds / associations.loanDocuments); the map is pre-bucketed by
// docId and passed through AG Grid `context`. Clicking the chip opens that
// condition in the condition sidebar. Renders nothing when there's no condition.
const ConditionChips = ({ doc, map }) => {
  const dispatch = useDispatch();
  if (!doc) return null;
  const conditions = (map && map.get && map.get(doc._id)) || [];
  if (!conditions.length) return null;

  const isResolved = (s) => s === "Accepted" || s === "Rejected";
  // Surface the most actionable condition first (an open one over a resolved one).
  const primary =
    conditions.find((c) => !isResolved(c?.status)) || conditions[0];
  const status = primary?.status || "Open";
  const tone = CONDITION_STATUS_TONE[status] || CONDITION_STATUS_TONE.Open;
  const extra = conditions.length - 1;

  const open = (e, condition) => {
    e.stopPropagation();
    dispatch(
      sidebarTypeSet(
        loanDrilldownSidebarTypes.ADD_EDIT_LOAN_CONDITION_REDESIGN,
      ),
    );
    dispatch(sidebarSetStateValue(condition));
  };

  const tooltip =
    conditions.length === 1
      ? `${conditionTitle(primary)}\nStatus: ${status}`
      : conditions
          .map((c) => `${conditionTitle(c)}\nStatus: ${c?.status || "Open"}`)
          .join("\n\n");

  return (
    <Flx
      ac
      g={0.5}
      onClick={(e) => e.stopPropagation()}
      sx={{ flexWrap: "nowrap", flexShrink: 0 }}
    >
      <Tooltip
        title={<span style={{ whiteSpace: "pre-line" }}>{tooltip}</span>}
        placement="top"
      >
        <Box
          component="button"
          type="button"
          onClick={(e) => open(e, primary)}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            height: 22,
            boxSizing: "border-box",
            cursor: "pointer",
            border: `1px solid ${tone.bd}`,
            background: tone.bg,
            color: tone.fg,
            borderRadius: "999px",
            px: 1,
            py: 0,
            fontSize: 11,
            fontWeight: 600,
            lineHeight: 1,
            maxWidth: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            "&:hover": { filter: "brightness(0.97)" },
          }}
        >
          {/* Always reads "Condition" — the status is conveyed by the chip's
              color tone and the hover tooltip. */}
          Condition
        </Box>
      </Tooltip>
      {extra > 0 && (
        <Box sx={{ fontSize: 11, fontWeight: 600, color: "#64748b" }}>
          +{extra}
        </Box>
      )}
    </Flx>
  );
};

// Inline-editable docType cell. Click opens a popover with the
// SelectFileAssignmentInput so the user can change docType (and the
// implicitly-selected docGroup at the same time). When the docGroup column
// isn't visible (and isn't a row group), the docGroup is shown beneath the
// docType so the user still has that context.
const InlineEditableDocTypeCell = (params) => {
  const dispatch = useDispatch();
  // loanId comes from AG Grid `context` rather than a per-cell useSelector.
  const loanId = params?.context?.loanId;
  const { updateLoanDocMetadata, loading } = useLoanFilesHook();
  const [anchor, setAnchor] = useState(null);
  const [pending, setPending] = useState({ docGroup: null, docType: null });
  const doc = params?.data;
  // Read docGroup visibility from the api at render time so changes to the
  // user's persisted column state don't ripple back into columnDefs and
  // reset the table. `persistColumnState` calls `refreshCells` on the
  // docType column whenever the user toggles columns, so this stays fresh.
  const layoutFields = params?.colDef?.cellRendererParams?.layoutFields || [];
  const docGroupCol = params?.api?.getColumn?.("docGroup");
  const docGroupColumnVisible = docGroupCol ? docGroupCol.isVisible() : true;
  const compact = !!params?.context?.compact;
  const showDocGroup =
    !docGroupColumnVisible && !layoutFields.includes("docGroup");

  // Each time the popover opens, seed the pending state from the current doc.
  useEffect(() => {
    if (anchor && doc) {
      setPending({ docGroup: doc.docGroup, docType: doc.docType });
    }
  }, [anchor, doc]);

  if (!doc) return null;

  const docTypeText = isNil(doc.docType) ? "N/A" : doc.docType;
  const docTypeIsMissing = isNil(doc.docType);

  const isDirty =
    pending.docType !== doc.docType || pending.docGroup !== doc.docGroup;

  const handleSelect = ({ docGroup, docType }) => {
    setPending({ docGroup, docType });
  };

  const handleReset = () => {
    setPending({ docGroup: doc.docGroup, docType: doc.docType });
  };

  const handleSave = () => {
    if (!doc?._id) return;
    if (!isDirty) {
      setAnchor(null);
      return;
    }
    updateLoanDocMetadata({
      loanId,
      data: [
        { _id: doc._id, docType: pending.docType, docGroup: pending.docGroup },
      ],
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
        setAnchor(null);
      },
    });
  };

  return (
    <>
      <Box
        onClick={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
        sx={{
          cursor: "pointer",
          opacity: loading ? 0.6 : 1,
          pointerEvents: loading ? "none" : "auto",
          minWidth: 0,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 0.25,
          py: 0.25,
        }}
      >
        <Flx ac g={0.5} sx={{ minWidth: 0 }}>
          <Txt
            sx={{
              fontSize: "11px",
              // fontSize: "12px",
              fontWeight: 400,
              color: docTypeIsMissing ? grey[500] : "#1A1A19",
              fontStyle: docTypeIsMissing ? "italic" : "normal",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              flex: 1,
              minWidth: 0,
            }}
          >
            {compact && showDocGroup && doc.docGroup ? (
              <Tooltip title={doc.docGroup} placement="top" arrow>
                <span>{docTypeText}</span>
              </Tooltip>
            ) : (
              docTypeText
            )}
          </Txt>
          <KeyboardArrowDown
            sx={{
              fontSize: 14,
              color: grey[500],
              flexShrink: 0,
            }}
          />
        </Flx>
        {showDocGroup && doc.docGroup && !compact && (
          <Txt
            sx={{
              fontSize: "10px",
              color: grey[600],
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: 1.2,
            }}
          >
            {doc.docGroup}
          </Txt>
        )}
      </Box>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            border: "1px solid #e5e3df",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            mt: 0.5,
            minWidth: 360,
            p: 1.25,
          },
        }}
      >
        <Flx column g={1.25}>
          <SelectFileAssignmentInput
            placeholder="Search categories and types…"
            docGroup={pending.docGroup}
            docType={pending.docType}
            size="small"
            onChange={handleSelect}
          />
          <Flx ac jb g={1}>
            <Button
              size="small"
              variant="text"
              onClick={handleReset}
              disabled={loading || !isDirty}
              sx={{
                textTransform: "none",
                fontSize: "12px",
                color: grey[700],
                minWidth: 0,
              }}
            >
              Reset
            </Button>
            <Flx ac g={1}>
              <Button
                size="small"
                variant="text"
                onClick={() => setAnchor(null)}
                disabled={loading}
                sx={{
                  textTransform: "none",
                  fontSize: "12px",
                  color: grey[700],
                }}
              >
                Cancel
              </Button>
              <Button
                size="small"
                variant="contained"
                onClick={handleSave}
                disabled={loading || !isDirty}
                sx={{
                  textTransform: "none",
                  fontSize: "12px",
                }}
              >
                {loading ? "Saving…" : "Save"}
              </Button>
            </Flx>
          </Flx>
        </Flx>
      </Popover>
    </>
  );
};

// Inline effective start date + duration editor. The cell shows the date as
// text with a calendar icon (or a muted "mm/dd/yyyy" placeholder when unset);
// clicking opens a small popover — like the doc-type cell — where the user
// sets BOTH the effective start date and the validity duration. Duration
// follows the auto-date logic: hard doc types show a fixed (read-only) window
// pill; soft / unmapped types expose an editable day count. Saving writes both
// Compact combined validity display for the "Validity" column: start → expires
// dates with the live countdown pill (or the duration + "requires start date"
// prompt when there's no effective date yet). Read-only content; the enclosing
// editor cell makes it clickable and opens the same popover as Valid From /
// Expires.
// Pill palette for the two-line Validity cell — mirrors the Expires column's
// CountdownPill colors (ok green / warning amber / critical + expired red).
const VALIDITY_PILL_STYLES = {
  ok: { bg: "#ecfdf5", color: "#047857", border: "#a7f3d0" },
  warning: { bg: "#fffbeb", color: "#b45309", border: "#fcd34d" },
  critical: { bg: "#fef2f2", color: "#b91c1c", border: "#fca5a5" },
  expired: { bg: "#dc2626", color: "#ffffff", border: "#dc2626" },
};

// The status pill on the Validity cell's second line: "✓ 86d left" (ok),
// "21d left" (warning), "⚠ Exp. 20d ago" (expired/critical).
const ValidityStatusPill = ({ kind, remaining }) => {
  const s = VALIDITY_PILL_STYLES[kind] || VALIDITY_PILL_STYLES.ok;
  const label =
    kind === "expired"
      ? `Exp. ${Math.abs(remaining)}d ago`
      : remaining === 0
        ? "Expires today"
        : `${remaining}d left`;
  const Icon =
    kind === "ok"
      ? CheckRounded
      : kind === "expired" || kind === "critical"
        ? WarningAmberOutlined
        : null;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "3px",
        borderRadius: "999px",
        border: `1px solid ${s.border}`,
        background: s.bg,
        color: s.color,
        px: "6px",
        py: "1px",
        fontSize: 10,
        fontWeight: 600,
        lineHeight: 1.5,
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
    >
      {Icon && <Icon sx={{ fontSize: 11 }} />}
      {label}
    </Box>
  );
};

const windowLabel = (days) => (days ? `${days}-day window` : "");

const ValidityCompactDisplay = ({ doc, nowMs, closingMs, oneLine = false }) => {
  const exp = getDocExpiration(doc, nowMs);
  const outlook = getDocClosingOutlook(doc, nowMs, closingMs);

  // Compact rows: the first line only, everything else in the tooltip.
  if (oneLine && exp) {
    const isExpired = !exp.noStart && exp.kind === "expired";
    const tip = exp.noStart
      ? `${windowLabel(exp.days)}. Set a start date to begin it.`
      : [
          windowLabel(exp.days),
          isExpired
            ? `Expired ${Math.abs(exp.remaining)}d ago`
            : `${exp.remaining}d left`,
          outlook?.lapsesBeforeClosing ? "Expires before closing" : null,
        ]
          .filter(Boolean)
          .join(" · ");
    return (
      <Tooltip title={tip} placement="top" arrow disableInteractive>
        <Flx ac g={0.5} sx={{ minWidth: 0, height: "100%" }}>
          {exp.noStart ? (
            <>
              <WarningAmberOutlined
                sx={{ fontSize: 12, color: "#b45309", flexShrink: 0 }}
              />
              <Txt
                sx={{ fontSize: 10, color: "#b45309", whiteSpace: "nowrap" }}
              >
                Set start date
              </Txt>
            </>
          ) : (
            <>
              <Txt
                sx={{
                  fontSize: 10,
                  fontWeight: isExpired ? 400 : 500,
                  color: isExpired ? "#94a3b8" : "#1e293b",
                  textDecoration: isExpired ? "line-through" : "none",
                  whiteSpace: "nowrap",
                }}
              >
                {formatDateShortYy(doc?.reportEffectiveDate)} →{" "}
                {formatDateShortYy(exp.expiration)}
              </Txt>
              {(isExpired ||
                exp.kind === "critical" ||
                outlook?.lapsesBeforeClosing) && (
                <WarningAmberOutlined
                  sx={{
                    fontSize: 12,
                    color: isExpired ? "#b91c1c" : "#b45309",
                    flexShrink: 0,
                  }}
                />
              )}
            </>
          )}
        </Flx>
      </Tooltip>
    );
  }

  // No expiration window: a classified doc simply "Doesn't expire"; an
  // unclassified one has nothing to say yet, so it reads as a plain dash.
  if (!exp) {
    const classified = !!doc?.docType;
    return (
      <Txt
        sx={{
          fontSize: 10,
          color: classified ? grey[500] : grey[400],
          whiteSpace: "nowrap",
        }}
      >
        {classified ? "Doesn't expire" : "—"}
      </Txt>
    );
  }

  // Has a window but no effective date yet — prompt for the start date.
  if (exp.noStart) {
    return (
      <Flx column g={0} sx={{ minWidth: 0 }}>
        <Txt
          sx={{
            fontSize: 10,
            color: "#475569",
            whiteSpace: "nowrap",
          }}
        >
          Not started{" "}
          <Box component="span" sx={{ color: "#94a3b8" }}>
            → +{exp.days}d
          </Box>
        </Txt>
        <Box
          component="span"
          sx={{
            alignSelf: "flex-start",
            display: "inline-flex",
            alignItems: "center",
            gap: "3px",
            borderRadius: "999px",
            border: "1px dashed #f59e0b",
            background: "#fffbeb",
            color: "#b45309",
            px: "6px",
            py: "1px",
            fontSize: 10,
            fontWeight: 600,
            lineHeight: 1.5,
            whiteSpace: "nowrap",
          }}
        >
          <WarningAmberOutlined sx={{ fontSize: 11 }} />
          Set start date
        </Box>
      </Flx>
    );
  }

  // Full window with an effective date — dates on top, window + status below.
  const isExpired = exp.kind === "expired";
  return (
    <Flx column g={0} sx={{ minWidth: 0 }}>
      <Txt
        sx={{
          fontSize: 10,
          fontWeight: isExpired ? 400 : 500,
          color: isExpired ? "#94a3b8" : "#1e293b",
          textDecoration: isExpired ? "line-through" : "none",
          whiteSpace: "nowrap",
        }}
      >
        {formatDateShortYy(doc?.reportEffectiveDate)} →{" "}
        {formatDateShortYy(exp.expiration)}
      </Txt>
      <Flx ac g={0.6} sx={{ minWidth: 0 }}>
        <Txt sx={{ fontSize: 10, color: "#94a3b8", whiteSpace: "nowrap" }}>
          {windowLabel(exp.days)}
        </Txt>
        <ValidityStatusPill kind={exp.kind} remaining={exp.remaining} />
        {outlook?.lapsesBeforeClosing && <BeforeClosingPill />}
      </Flx>
    </Flx>
  );
};

// fields via updateLoanDocMetadata. `loanId` comes from AG Grid `context`.
// `variant="combined"` (the Validity column) swaps the effective-date-only
// display for the compact combined view while keeping the same edit popover.
const InlineEditableEffectiveDateCell = (params) => {
  const dispatch = useDispatch();
  const loanId = params?.context?.loanId;
  const variant = params?.variant;
  const cellNowMs = params?.nowMs;
  const cellClosingMs = params?.closingMs;
  const { updateLoanDocMetadata, loading } = useLoanFilesHook();
  const doc = params?.data;
  const [anchor, setAnchor] = useState(null);
  const [pendingDate, setPendingDate] = useState("");
  const [pendingDays, setPendingDays] = useState("");

  const docType = doc?.docType;
  const isHard = isHardDurationDocType(docType);
  const isDual = isDualDateDocType(docType);
  const autoDays = getExpirationDaysForDocType(docType);
  const effective = doc?.reportEffectiveDate
    ? String(doc.reportEffectiveDate).slice(0, 10)
    : "";

  // Seed the popover from the current doc each time it opens.
  useEffect(() => {
    if (anchor && doc) {
      setPendingDate(
        doc.reportEffectiveDate
          ? String(doc.reportEffectiveDate).slice(0, 10)
          : "",
      );
      setPendingDays(
        doc.reportGuidelineExpirationDays == null
          ? ""
          : doc.reportGuidelineExpirationDays,
      );
    }
  }, [anchor, doc]);

  if (!doc) return null;

  // Explicit-expiration types (license/passport) derive their effective date
  // from the picked expiration date — this column is N/A; it's edited in the
  // Expiration column instead.
  if (isExplicitExpirationDocType(docType)) {
    return (
      <Flx ac sx={{ height: "100%" }}>
        <Txt sx={{ fontSize: 12, color: grey[400] }}>N/A</Txt>
      </Flx>
    );
  }

  const handleSave = () => {
    if (!doc?._id) return;
    let fields;
    if (isDual) {
      // Dual-date (statements): only the start date is edited here; preserve
      // the currently-picked expiration and re-derive the duration from it.
      const currentExp = computeExpirationDate(
        doc.reportEffectiveDate,
        doc.reportGuidelineExpirationDays,
      );
      fields = deriveDualDateFields(pendingDate || null, currentExp);
    } else {
      // Hard types persist their fixed window; soft / unmapped types use the
      // entered value (blank → null).
      let daysToSave;
      if (isHard) {
        daysToSave = autoDays ?? null;
      } else if (pendingDays === "" || pendingDays == null) {
        daysToSave = null;
      } else {
        const n = Number(pendingDays);
        daysToSave = Number.isFinite(n) && n >= 0 ? n : null;
      }
      fields = {
        reportEffectiveDate: pendingDate || null,
        reportGuidelineExpirationDays: daysToSave,
      };
    }
    updateLoanDocMetadata({
      loanId,
      data: [{ _id: doc._id, ...fields }],
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
        setAnchor(null);
      },
    });
  };

  return (
    <>
      <Flx
        ac
        g={0.5}
        onClick={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
        sx={{
          height: "100%",
          width: "100%",
          cursor: "pointer",
          opacity: loading ? 0.6 : 1,
        }}
      >
        {variant === "combined" ? (
          <ValidityCompactDisplay
            doc={doc}
            nowMs={cellNowMs}
            closingMs={cellClosingMs}
            oneLine={!!params?.context?.compact}
          />
        ) : (
          <>
            <EventOutlined
              sx={{ fontSize: 15, color: grey[500], flexShrink: 0 }}
            />
            <Txt
              sx={{
                fontSize: 12,
                color: effective ? "#1A1A19" : grey[500],
                fontStyle: effective ? "normal" : "italic",
              }}
            >
              {effective
                ? formatDate(effective, "mm/dd/yyyy", "MM/dd/yyyy")
                : "mm/dd/yyyy"}
            </Txt>
          </>
        )}
      </Flx>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            border: "1px solid #e5e3df",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            mt: 0.5,
            minWidth: 280,
            p: 1.5,
          },
        }}
      >
        <Flx column g={1.5}>
          <Box>
            <Txt
              sx={{ fontSize: 11, fontWeight: 600, color: grey[700], mb: 0.5 }}
            >
              Effective Start Date
            </Txt>
            <TextField
              type="date"
              size="small"
              fullWidth
              value={pendingDate}
              onChange={(e) => setPendingDate(e.target.value)}
              sx={{ "& .MuiInputBase-input": { fontSize: 13 } }}
            />
          </Box>
          {/* Dual-date (statements) edit only the start date here — the
              expiration (and thus the derived duration) is set in the
              Expiration column. */}
          {!isDual && (
            <Box>
              <Txt
                sx={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: grey[700],
                  mb: 0.5,
                }}
              >
                Duration
              </Txt>
              {isHard ? (
                <AutoDurationPill days={autoDays} />
              ) : (
                <Flx ac g={0.75}>
                  <TextField
                    type="number"
                    size="small"
                    placeholder="—"
                    value={pendingDays}
                    onChange={(e) => setPendingDays(e.target.value)}
                    inputProps={{ min: 0, step: 1 }}
                    sx={{
                      width: 90,
                      "& .MuiInputBase-input": {
                        fontSize: 13,
                        textAlign: "center",
                      },
                    }}
                  />
                  <Txt sx={{ fontSize: 12, color: grey[500] }}>days</Txt>
                </Flx>
              )}
            </Box>
          )}
          <Flx ac end g={1}>
            <Button
              size="small"
              variant="text"
              onClick={() => setAnchor(null)}
              disabled={loading}
              sx={{ textTransform: "none", fontSize: "12px", color: grey[700] }}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={handleSave}
              disabled={loading}
              sx={{ textTransform: "none", fontSize: "12px" }}
            >
              {loading ? "Saving…" : "Save"}
            </Button>
          </Flx>
        </Flx>
      </Popover>
    </>
  );
};

// Inline expiration editor for the Documents table, used only for explicit-
// expiration doc types (license/passport). Shows the expiration date as text
// + calendar icon; clicking opens the popover where the user picks the
// expiration date directly. We back into the stored model (effective = today,
// duration = expiration − today) and save via updateLoanDocMetadata.
const InlineEditableExpirationCell = (params) => {
  const dispatch = useDispatch();
  const loanId = params?.context?.loanId;
  const variant = params?.variant;
  const cellNowMs = params?.nowMs;
  const cellClosingMs = params?.closingMs;
  const { updateLoanDocMetadata, loading } = useLoanFilesHook();
  const doc = params?.data;
  if (!doc) return null;
  const expiration =
    computeExpirationDate(
      doc?.reportEffectiveDate,
      doc?.reportGuidelineExpirationDays,
    ) || "";
  const handleSave = (ymd) => {
    if (!doc?._id) return;
    // Dual-date (statements) preserve the picked start date; explicit-
    // expiration (license/passport) set effective=today.
    const fields = isDualDateDocType(doc?.docType)
      ? deriveDualDateFields(doc?.reportEffectiveDate, ymd)
      : deriveFromExpirationDate(ymd);
    updateLoanDocMetadata({
      loanId,
      data: [{ _id: doc._id, ...fields }],
      onSuccessFn: (data) => dispatch(loanDrilldownSet(data)),
    });
  };
  return (
    <InlineDatePopoverField
      label="Expiration Date"
      value={expiration}
      onSave={handleSave}
      loading={loading}
      renderTrigger={
        variant === "combined" ? (
          <ValidityCompactDisplay
            doc={doc}
            nowMs={cellNowMs}
            closingMs={cellClosingMs}
            oneLine={!!params?.context?.compact}
          />
        ) : undefined
      }
    />
  );
};

// =================================================================
// COLUMN DEFINITIONS
// =================================================================

const buildColumnDefs = (visibility, layoutMode, options = {}) => {
  // `filenameCellRendererParams` is the single merged params object the
  // component builds — it carries the comment map, loan id, the hide
  // flags, AND `layoutFields` (the row-group field list for the current
  // layoutMode, which the docType cell reads to decide whether to inline
  // the docGroup label). `filenameHideExtBox` / `filenameHideDocTypeSubline`
  // are pre-gated by the component (true only when the consumer opted in
  // AND layout is docGroupAndType), so the cell renderer just respects
  // them as-is.
  // `validityNowMs` is the day expirations are measured against — today for a
  // live loan, the closing date once the loan is Closed.
  // `validityClosingMs` is the loan's upcoming closing date (null once
  // closed), for the "Before closing" flag.
  const { filenameCellRendererParams, validityNowMs, validityClosingMs } =
    options;
  const groupFields =
    LAYOUT_OPTIONS.find((o) => o.key === layoutMode)?.fields || [];
  const groupIndex = (colId) => groupFields.indexOf(colId);
  const isGrouped = (colId) => groupIndex(colId) !== -1;
  return [
    {
      colId: "file_display_name",
      headerName: "Filename",
      // Grouped, the label is shown in the checkbox column's header instead
      // (still named in the Columns panel).
      headerValueGetter: (p) =>
        groupFields.length && p?.location === "header" ? "" : "Filename",
      field: "file_display_name",
      // Stretch to fill remaining row width so the table never leaves an
      // empty gap on the right (e.g. after a tab re-mount). `minWidth`
      // keeps the column readable when the viewport is narrow.
      flex: 1,
      minWidth: 400,
      // Cap the filename column so it doesn't grow into a large empty
      // gap before the status column on wide screens. Long filenames
      // still wrap to ellipsis at 560px and fall back to the tooltip.
      // maxWidth: 560,
      // File-details box is now opt-in via the info-icon hover in
      // FilenameCell (next to the 3-dot menu), not a tooltip on every
      // cell hover. AG Grid tooltip handlers are removed accordingly.
      cellStyle: {
        cursor: "pointer",
        paddingTop: 8,
        paddingBottom: 8,
        paddingRight: 0,
        paddingLeft: 0,
        // paddingLeft: 8,
      },
      // Named cellRenderer + memoized cellRendererParams so AG Grid
      // doesn't have to remount cells when columnDefs are rebuilt
      // (layout switching). React's reconciliation reuses the existing
      // FilenameCell instances; only the param values shift.
      cellRenderer: FilenameColumnCellRenderer,
      cellRendererParams: filenameCellRendererParams,
    },
    {
      colId: "docType",
      headerName: "Document Type",
      field: "docType",
      minWidth: 200,
      width: 200,
      maxWidth: 320,
      flex: 1,
      hide: !visibility?.docType,
      enableRowGroup: true,
      rowGroup: isGrouped("docType"),
      rowGroupIndex: isGrouped("docType") ? groupIndex("docType") : null,
      // Only set `sort` when grouping — see note on documentStatus above.
      ...(isGrouped("docType") ? { sort: "asc" } : {}),
      cellRenderer: InlineEditableDocTypeCell,
      // Shares the merged params object — it carries `layoutFields`, which
      // the docType cell reads to decide whether to inline the docGroup.
      cellRendererParams: filenameCellRendererParams,
    },
    {
      colId: "docGroup",
      headerName: "Category",
      field: "docGroup",
      minWidth: 160,
      maxWidth: 320,
      // cellStyle: {
      //   fontSize: "11px",
      // },
      // minWidth: 200,
      flex: 1,
      hide: !visibility?.docGroup,
      enableRowGroup: true,
      rowGroup: isGrouped("docGroup"),
      rowGroupIndex: isGrouped("docGroup") ? groupIndex("docGroup") : null,
      // Only set `sort` when grouping — see note on documentStatus above.
      ...(isGrouped("docGroup") ? { sort: "asc" } : {}),
      valueGetter: (p) => {
        const v = p.data?.docGroup;
        return v === undefined || v === null || v === "" ? "Uncategorized" : v;
      },
    },
    loanFileStatusColumnDef({
      hide: !visibility?.documentStatus,
      enableRowGroup: true,
      rowGroup: isGrouped("documentStatus"),
      rowGroupIndex: isGrouped("documentStatus")
        ? groupIndex("documentStatus")
        : null,
      // Only set `sort` when this column is the active grouping column.
      // Writing `sort: null` here clobbers any api-applied sort state when
      // columnDefs rebuild (e.g. after a loan refresh from saving a status).
      ...(isGrouped("documentStatus") ? { sort: "asc" } : {}),
      // Override the shared factory's `autoHeight: true` — this table
      // runs fixed row heights, so the off-screen measure pass would be
      // pure overhead.
      autoHeight: false,
      width: 160,
      minWidth: 160,
      // Let the renderer paint the cell edge-to-edge — old-table look
      // wants a full-width colored fill + colored left border, so we
      // zero the AG Grid cell padding here and let
      // `InlineEditableStatusCell` own its own padding.
      cellStyle: {
        padding: 0,
        display: "flex",
        alignItems: "stretch",
      },
      cellRenderer: InlineEditableStatusCell,
    }),

    {
      colId: "associations",
      headerName: "Associations",
      width: 160,
      minWidth: 160,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      flex: 0,
      hide: !visibility?.associations,
      sortable: false,
      cellStyle: {
        display: "flex",
        alignItems: "center",
        paddingTop: 8,
        paddingBottom: 8,
        cursor: "default",
      },
      cellRenderer: InlineAssociationsCell,
      cellRendererParams: filenameCellRendererParams,
    },
    // Combined "Validity" — a compact view of Valid From + Valid For + Expires
    // in one column, editable via the same popover. Defaults visible; the three
    // individual columns default hidden (opt back in via Edit Columns).
    {
      colId: "validity",
      headerName: "Validity",
      width: 220,
      minWidth: 140,
      flex: 0,
      hide: !visibility?.validity,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      // Sort by the computed expiration date (no window → null, sorts last).
      valueGetter: (p) => {
        const days = resolveDocExpirationDays(p?.data);
        const eff = p?.data?.reportEffectiveDate;
        if (!days || !eff) return null;
        return computeExpirationDate(eff, days);
      },
      cellStyle: { display: "flex", alignItems: "center" },
      cellRenderer: (p) => {
        if (p.node?.group) return null;
        // Route to the same editor each type uses: explicit-expiration types
        // (license/passport) edit the expiration date; everything else edits
        // the effective start date (+ duration). Both show the combined display.
        return isExplicitExpirationDocType(p?.data?.docType) ? (
          <InlineEditableExpirationCell
            {...p}
            variant="combined"
            nowMs={validityNowMs}
            closingMs={validityClosingMs}
          />
        ) : (
          <InlineEditableEffectiveDateCell
            {...p}
            variant="combined"
            nowMs={validityNowMs}
            closingMs={validityClosingMs}
          />
        );
      },
    },
    // Effective start / duration / expiration sit together, right after
    // Associations and before the Updated column.
    {
      colId: "reportEffectiveDate",
      headerName: "Valid From",
      field: "reportEffectiveDate",
      width: 140,
      minWidth: 140,
      flex: 0,
      hide: !visibility?.reportEffectiveDate,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      // Sort by the calendar date (YYYY-MM-DD sorts chronologically).
      valueGetter: (p) =>
        p?.data?.reportEffectiveDate
          ? String(p.data.reportEffectiveDate).slice(0, 10)
          : null,
      cellStyle: { display: "flex", alignItems: "center" },
      cellRenderer: (p) =>
        p.node?.group ? null : <InlineEditableEffectiveDateCell {...p} />,
    },
    {
      colId: "reportGuidelineExpirationDays",
      headerName: "Valid For",
      field: "reportGuidelineExpirationDays",
      width: 130,
      // Override the defaultColDef floor (140) so this narrow column can be
      // dragged smaller.
      minWidth: 80,
      flex: 0,
      hide: !visibility?.reportGuidelineExpirationDays,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      valueGetter: (p) => resolveDocExpirationDays(p?.data) ?? null,
      cellStyle: { display: "flex", alignItems: "center", height: "100%" },
      cellRenderer: (p) =>
        p.node?.group ? null : <DocDurationCell doc={p.data} />,
    },
    {
      // Computed expiration (date + progress bar + countdown).
      colId: "expiration",
      headerName: "Expires",
      width: 180,
      flex: 0,
      hide: !visibility?.expiration,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      cellStyle: { display: "flex", alignItems: "center" },
      valueGetter: (p) => {
        const days = resolveDocExpirationDays(p?.data);
        const eff = p?.data?.reportEffectiveDate;
        if (!days || !eff) return null;
        return computeExpirationDate(eff, days);
      },
      cellRenderer: (p) => {
        if (p.node?.group) return null;
        return isExplicitExpirationDocType(p?.data?.docType) ||
          isDualDateDocType(p?.data?.docType) ? (
          <InlineEditableExpirationCell {...p} />
        ) : (
          <DocExpirationCell
            doc={p.data}
            nowMs={validityNowMs}
            closingMs={validityClosingMs}
          />
        );
      },
    },
    // Combined "Last Updated" — renders "{datetime} by {user}" in a single
    // ellipsing line with a tooltip on hover. `field` points at the raw
    // ISO date so AG Grid sorts/filters by date (ISO strings sort
    // chronologically). `sortingOrder` puts most-recent first on the
    // initial click — that's the asked-for default.
    {
      colId: "lastUpdatedCombined",
      headerName: "Updated",
      field: "modifiedDate",
      type: "dateTime",
      width: 150,
      maxWidth: 200,
      // maxWidth: 240,
      // maxWidth: 360,
      flex: 0,
      hide: !visibility?.lastUpdatedCombined,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      sortingOrder: ["desc", "asc", null],
      cellStyle: { display: "flex", alignItems: "center" },
      cellRenderer: LastUpdatedCombinedCell,
    },
    {
      colId: "uploadedCombined",
      headerName: "Uploaded",
      field: "uploadDate",
      type: "dateTime",
      width: 150,
      maxWidth: 200,
      // maxWidth: 240,
      // maxWidth: 360,
      flex: 0,
      hide: !visibility?.uploadedCombined,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      sortingOrder: ["desc", "asc", null],
      cellStyle: { display: "flex", alignItems: "center" },
      cellRenderer: UploadedCombinedCell,
    },
    {
      colId: "uploadDate",
      headerName: "Upload Date",
      field: "uploadDate",
      type: "dateTime",
      width: 160,
      flex: 0,
      hide: !visibility?.uploadDate,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
    },

    {
      colId: "uploadedBy",
      headerName: "Uploaded By",
      field: "uploadedBy",
      width: 160,
      flex: 0,
      hide: !visibility?.uploadedBy,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      tooltipValueGetter: (p) => p.value,
      cellRenderer: CellRendererUserByEmail,
    },
    {
      colId: "modifiedDate",
      headerName: "Updated",
      field: "modifiedDate",
      type: "dateTime",
      width: 160,
      flex: 0,
      hide: !visibility?.modifiedDate,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      tooltipValueGetter: (p) => formatDateTime(p.value),
    },
    {
      colId: "updatedBy",
      headerName: "Updated By",
      field: "updatedBy",
      width: 160,
      flex: 0,
      hide: !visibility?.updatedBy,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      tooltipValueGetter: (p) => p.value,
      cellRenderer: CellRendererUserByEmail,
    },
    {
      colId: "isHidden",
      headerName: "Is Hidden",
      field: "isHidden",
      width: 100,
      flex: 0,
      hide: !visibility?.isHidden,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      cellRenderer: "agCheckboxCellRenderer",
      valueGetter: (p) => getBooleanValue(p, "isHidden"),
    },
    {
      colId: "excludeFromExport",
      headerName: "Exclude From Export",
      field: "excludeFromExport",
      width: 100,
      flex: 0,
      hide: !visibility?.excludeFromExport,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      // Editable checkbox — saves on click via context.onToggleShareFlag, same
      // as the share-flag columns below (with a spinner + "Saved" badge).
      cellRenderer: ShareFlagCell,
      cellRendererParams: { field: "excludeFromExport" },
      valueGetter: (p) => getBooleanValue(p, "excludeFromExport"),
    },
    // Share flags — one column per flag, click-to-toggle. Unlike the
    // read-only `isHidden` / `excludeFromExport` checkboxes above, these
    // save on click (context.onToggleShareFlag) because staging a
    // 40-document review package one dialog at a time is the manual
    // workflow this replaces.
    ...DOCUMENT_SHARE_FLAGS.map((f) => ({
      colId: f.field,
      headerName: f.columnLabel,
      field: f.field,
      headerTooltip: f.description,
      width: 100,
      flex: 0,
      hide: !visibility?.[f.field],
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      cellRenderer: ShareFlagCell,
      cellRendererParams: { field: f.field },
      valueGetter: (p) => getBooleanValue(p, f.field),
    })),
    // Read-only "staged" badge — set on each doc by the most recent package
    // build (doc.shareStamp). Empty until a doc has been packaged.
    {
      colId: "shareStamp",
      headerName: "Package",
      field: "shareStamp",
      headerTooltip:
        "The last share package this document was staged into (read-only).",
      width: 120,
      flex: 0,
      hide: !visibility?.shareStamp,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      cellRenderer: ShareStampCell,
      // Sort/filter on the selector's package label so the column behaves.
      valueGetter: (p) => {
        const stamp = getActiveShareStamp(p.data);
        if (!stamp?.selector) return "";
        return (
          getShareSelectorConfig(stamp.selector)?.packageLabel || stamp.selector
        );
      },
    },
    // The document's raw JSON in a modal — same as the Loan Pipeline's JSON
    // column. Hidden by default (Columns panel to show it).
    {
      colId: "json",
      headerName: "JSON",
      hide: !visibility?.json,
      width: 100,
      minWidth: 90,
      flex: 0,
      sortable: false,
      filter: false,
      suppressHeaderFilterButton: true,
      suppressHeaderMenuButton: true,
      enableRowGroup: false,
      valueGetter: () => "",
      cellRenderer: DocJsonCell,
    },
  ];
};

// "JSON" button → modal with a searchable / collapsible view of the document.
const DocJsonCell = (params) => {
  const [open, setOpen] = useState(false);
  const data = params?.data;
  if (params?.node?.group || !data) return null;
  return (
    <Flx ac jc sx={{ height: "100%" }}>
      <Button
        size="small"
        variant="text"
        startIcon={<DataObjectOutlined sx={{ fontSize: 15 }} />}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        sx={{ fontSize: 11, minWidth: 0 }}
      >
        JSON
      </Button>
      <BasicModal
        show={open}
        onClose={() => setOpen(false)}
        title={`${data?.file_display_name || "Document"} — JSON`}
        icon={<DataObjectOutlined className="thin" />}
        maxWidth="md"
        bodySx={{ p: 2 }}
      >
        <JsonPreview values={data} defaultCollapse={2} />
      </BasicModal>
    </Flx>
  );
};

// Header for the pinned checkbox column: a select-all checkbox (all rows that
// pass the current filter) and, when grouped, the "Filename" label. Grouped,
// the checkbox steps in one indent so it lines up with the top-level group
// checkboxes; the label stays right beside it at every depth.
const BulkSelectHeader = ({ api, grouped }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!api) return undefined;
    const h = () => tick((n) => n + 1);
    api.addEventListener("selectionChanged", h);
    api.addEventListener("modelUpdated", h);
    return () => {
      api.removeEventListener("selectionChanged", h);
      api.removeEventListener("modelUpdated", h);
    };
  }, [api]);
  let total = 0;
  let selected = 0;
  api?.forEachNodeAfterFilter?.((n) => {
    if (n.group || !n.data) return;
    total += 1;
    if (n.isSelected()) selected += 1;
  });
  const all = total > 0 && selected === total;
  const some = selected > 0 && !all;
  return (
    <Flx
      ac
      g={1}
      sx={{
        height: "100%",
        width: "100%",
        overflow: "visible",
        pl: `${BULK_SELECT_GUTTER_PX + (grouped ? GROUP_INDENT_PX : 0)}px`,
      }}
    >
      <Box
        className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper${
          all ? " ag-checked" : ""
        }${some ? " ag-indeterminate" : ""}`}
        sx={{ flexShrink: 0 }}
      >
        <input
          type="checkbox"
          className="ag-input-field-input ag-checkbox-input"
          checked={all}
          onChange={() =>
            all ? api.deselectAllFiltered() : api.selectAllFiltered()
          }
          aria-label="Select all files"
        />
      </Box>
      {grouped ? (
        <span className="ag-header-cell-text" style={{ whiteSpace: "nowrap" }}>
          Filename
        </span>
      ) : null}
    </Flx>
  );
};

// Small green "Saved" badge that flashes briefly after an inline flag save.
const SavedBadge = () => (
  <Box
    component="span"
    sx={{
      fontSize: 10.5,
      fontWeight: 600,
      color: "#15803d",
      background: "#f0fdf4",
      border: "1px solid #bbf7d0",
      borderRadius: "6px",
      px: 0.6,
      py: "1px",
      lineHeight: 1.4,
      whiteSpace: "nowrap",
    }}
  >
    Saved
  </Box>
);

// Click-to-toggle CHECKBOX for a document flag (share flags + Exclude From
// Export). Saves through `context.onToggleShareFlag` (one hook instance for the
// whole table) and paints optimistically so the box doesn't lag the round-trip
// — the refreshed deal landing in Redux ultimately settles the value, and a
// failed save drops back to it. While saving it shows a spinner; on success a
// brief "Saved" badge.
const ShareFlagCell = (params) => {
  const { data, value, field, context } = params;
  const [optimistic, setOptimistic] = useState(null);
  const [saving, setSaving] = useState(false);
  const [showSaved, setShowSaved] = useState(false);
  const savedTimer = useRef(null);

  // A newer server value always wins over a stale optimistic one.
  useEffect(() => {
    setOptimistic(null);
  }, [value]);
  useEffect(() => () => clearTimeout(savedTimer.current), []);

  // Group rows have no document behind them.
  if (!data?._id) return null;
  const checked = optimistic === null ? !!value : optimistic;

  const handleChange = (e) => {
    const next = e.target.checked;
    setOptimistic(next);
    setSaving(true);
    setShowSaved(false);
    clearTimeout(savedTimer.current);
    context?.onToggleShareFlag?.(data, field, next, {
      onSuccessFn: () => {
        setSaving(false);
        setShowSaved(true);
        savedTimer.current = setTimeout(() => setShowSaved(false), 1800);
      },
      onFailFn: () => {
        setOptimistic(null);
        setSaving(false);
      },
    });
  };

  return (
    <Flx ac jc g={0.75} sx={{ height: "100%" }}>
      <Checkbox
        size="small"
        checked={checked}
        disabled={saving}
        onClick={(e) => e.stopPropagation()}
        onChange={handleChange}
        sx={{ p: 0.25 }}
      />
      {saving && <CircularProgress size={13} sx={{ color: grey[500] }} />}
      {!saving && showSaved && <SavedBadge />}
    </Flx>
  );
};

// Read-only badge for the share stamp the last package build wrote onto a doc
// (doc.shareStamp = { selector, packageOid, stagedAt, stagedBy, note }).
// Renders nothing until the doc has been packaged. There is no per-document
// access-log READ endpoint on the backend yet (document_access events are
// written to the audit `document_access_log` collection but not served — see
// eastview-os frontend_documentation/document-share-packages.md §3), so the
// tooltip surfaces the stamp detail in lieu of a true access history.
// The stamp only shows while the doc still carries at least one share flag:
// a doc that was packaged and then un-flagged keeps its old `shareStamp` on
// the backend, but it no longer belongs to any package, so the cell is empty.
const getActiveShareStamp = (doc) =>
  DOCUMENT_SHARE_FLAGS.some((f) => isShareFlagOn(doc, f.field))
    ? getShareStamp(doc)
    : null;

const ShareStampCell = (params) => {
  const stamp = getActiveShareStamp(params?.data);
  if (!stamp?.selector) return null;
  const label =
    getShareSelectorConfig(stamp.selector)?.packageLabel || stamp.selector;
  const stagedAt = stamp.stagedAt ? formatDateTime(stamp.stagedAt) : null;
  const tip = (
    <Flx column g={0.25} sx={{ py: 0.25 }}>
      <Txt sx={{ fontSize: 12, fontWeight: 600 }}>{label} package</Txt>
      {stagedAt && <Txt sx={{ fontSize: 11 }}>Staged {stagedAt}</Txt>}
      {stamp.stagedBy && <Txt sx={{ fontSize: 11 }}>By {stamp.stagedBy}</Txt>}
      {stamp.note && (
        <Txt sx={{ fontSize: 11, fontStyle: "italic" }}>{stamp.note}</Txt>
      )}
    </Flx>
  );
  return (
    <Flx ac jc sx={{ height: "100%" }}>
      <Tooltip title={tip} placement="top" arrow>
        <Box
          component="span"
          sx={{
            fontSize: 10.5,
            fontWeight: 600,
            color: teal[700],
            background: teal[50],
            border: `1px solid ${teal[200]}`,
            borderRadius: "6px",
            px: 0.6,
            py: "1px",
            lineHeight: 1.4,
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </Box>
      </Tooltip>
    </Flx>
  );
};

const StatusEditPopover = ({ anchor, onClose, currentStatus, onSelect }) => (
  <Popover
    open={Boolean(anchor)}
    anchorEl={anchor}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    PaperProps={{
      sx: {
        border: "1px solid #e5e3df",
        boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
      },
    }}
  >
    <Box sx={{ minWidth: 200, py: 0.5 }}>
      {(selectOptionsDocumentStatus || []).map((opt) => {
        const val = typeof opt === "string" ? opt : opt.value || opt.label;
        const isActive = val === currentStatus;
        const s = getStatusStyle(val);
        return (
          <Box
            key={val}
            onClick={() => onSelect(val)}
            sx={{
              px: 1.5,
              py: 0.75,
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
              fontSize: "13px",
              bgcolor: isActive ? "#F0F7FE" : "transparent",
              "&:hover": { bgcolor: "#FAFAF7" },
            }}
          >
            <Box
              sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: s.dot }}
            />
            {documentStatusLabel(val)}
          </Box>
        );
      })}
    </Box>
  </Popover>
);

// =================================================================
// EDIT DOCUMENT DETAILS DIALOG
// =================================================================
// Wraps the shared UpdateLoanDocumentMetadataForm in a dialog so the
// FilenameCell's "Edit Details" menu item has somewhere to render the
// full editable-fields form. Form-level state (loading, dirty, save)
// is owned by the form itself; this component just manages the open
// state and forwards the saved payload up so the caller can refresh
// the AG Grid row in place.
export const EditDocumentDetailsDialog = ({
  open,
  file,
  loanId,
  onClose,
  onSaved,
}) => {
  if (!file) return null;
  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      // Stop bubbling — the dialog renders inside the AG Grid cell DOM
      // tree, so otherwise clicks inside form fields would propagate up
      // to onCellClicked and trigger the file preview.
      onClick={(e) => e.stopPropagation()}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          border: "1px solid",
          borderColor: "divider",
        },
      }}
    >
      {/* The title reserves a right gutter for the close button so a long
          filename wraps beside it rather than running underneath. */}
      <DialogTitle sx={{ pb: 1, pr: 6 }}>
        <Txt sx={{ fontSize: "15px", fontWeight: 600 }}>
          Edit document details
        </Txt>
        <Txt sx={{ fontSize: "12px", color: grey[600], display: "block" }}>
          {file.file_display_name}
        </Txt>
        <Tooltip title="Close">
          <IconButton
            size="small"
            onClick={onClose}
            aria-label="Close"
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: grey[600],
            }}
          >
            <CloseRounded sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2.5 }}>
        <UpdateLoanDocumentMetadataForm
          file={file}
          loanId={loanId}
          onSuccessFn={(data) => {
            onSaved?.(data);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default LoanDocumentManagerTable;
